/*! KreativPünktchen Stempel-Werkstatt v1.8 – 2026-09-25 */
(function () {
/* ---- js/00-util.js ---- */
/* ==========================================================================
   KreativPünktchen Stempel-Werkstatt – Konfigurator
   (c) Seidel OHG · KreativPünktchen · handgefertigt im Vogtland
   Reines JavaScript ohne Fremdbibliotheken. Einheiten im Modell: Millimeter,
   Ursprung = Mitte der Stempelplatte, y nach unten.
   ========================================================================== */
'use strict';

const PT_MM = 0.3528;           // 1 pt in mm
const EXPORT_PX_PER_MM = 40;    // Druckdatei: 40 px/mm ≈ 1016 dpi
const SAFE_MM = 0.4;            // Sicherheitsabstand zum Plattenrand

const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
const lerp = (a, b, t) => a + (b - a) * t;
const uid = (() => { let n = 0; return (p = 'e') => p + Date.now().toString(36) + (n++).toString(36); })();
const deg2rad = d => d * Math.PI / 180;
const rad2deg = r => r * 180 / Math.PI;
const round = (v, n = 2) => Math.round(v * 10 ** n) / 10 ** n;

function h(tag, attrs, ...children) {
  const el = document.createElement(tag);
  if (attrs) {
    for (const [k, v] of Object.entries(attrs)) {
      if (v == null || v === false) continue;
      if (k === 'class') el.className = v;
      else if (k === 'style' && typeof v === 'object') {
        // eigene CSS-Variablen (--c) gehen nur über setProperty
        for (const [sk, sv] of Object.entries(v)) {
          if (sv == null) continue;
          if (sk.startsWith('--')) el.style.setProperty(sk, sv); else el.style[sk] = sv;
        }
      }
      else if (k.startsWith('on') && typeof v === 'function') el.addEventListener(k.slice(2).toLowerCase(), v);
      else if (k === 'html') el.innerHTML = v;
      else if (v === true) el.setAttribute(k, '');
      else el.setAttribute(k, v);
    }
  }
  for (const c of children.flat(Infinity)) {
    if (c == null || c === false) continue;
    el.appendChild(typeof c === 'string' || typeof c === 'number' ? document.createTextNode(String(c)) : c);
  }
  return el;
}

function svgEl(tag, attrs) {
  const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
  if (attrs) for (const [k, v] of Object.entries(attrs)) if (v != null) el.setAttribute(k, v);
  return el;
}

function debounce(fn, ms) {
  let t;
  return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
}

function rafThrottle(fn) {
  let queued = false, lastArgs;
  return (...a) => {
    lastArgs = a;
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; fn(...lastArgs); });
  };
}

function formatPrice(cents, currency = 'EUR') {
  try {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(cents / 100);
  } catch (e) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
}

/* zwei Farben (#rrggbb) mischen, t = Anteil von b */
function mixColor(a, b, t) {
  const p = x => [1, 3, 5].map(i => parseInt(x.slice(i, i + 2), 16));
  const A = p(a), B = p(b);
  return '#' + A.map((v, i) => Math.round(v + (B[i] - v) * t).toString(16).padStart(2, '0')).join('');
}

const storage = {
  get(k) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } },
  set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch (e) { return false; } },
  del(k) { try { localStorage.removeItem(k); } catch (e) { /* egal */ } }
};

function easeInOut(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

function animate(ms, step, done) {
  const t0 = performance.now();
  let stop = false;
  function frame(now) {
    if (stop) return;
    const t = clamp((now - t0) / ms, 0, 1);
    step(easeInOut(t), t);
    if (t < 1) requestAnimationFrame(frame); else if (done) done();
  }
  requestAnimationFrame(frame);
  return () => { stop = true; };
}

function prefersReducedMotion() {
  try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
}

/* Punkt (mm) in das lokale Koordinatensystem eines Elements drehen */
function toLocal(px, py, ox, oy, rotDeg) {
  const r = -deg2rad(rotDeg || 0);
  const dx = px - ox, dy = py - oy;
  return [dx * Math.cos(r) - dy * Math.sin(r), dx * Math.sin(r) + dy * Math.cos(r)];
}
function fromLocal(lx, ly, ox, oy, rotDeg) {
  const r = deg2rad(rotDeg || 0);
  return [ox + lx * Math.cos(r) - ly * Math.sin(r), oy + lx * Math.sin(r) + ly * Math.cos(r)];
}

function canvas(w, hgt) {
  const c = document.createElement('canvas');
  c.width = Math.max(1, Math.round(w));
  c.height = Math.max(1, Math.round(hgt));
  return c;
}

/* PNG: Auflösung (pHYs) eintragen, damit Grafik- und Laserprogramme die
   Druckdatei in echter Größe öffnen (Canvas-PNGs haben keine Angabe) */
const CRC_TABLE = (() => {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n++) { let c = n; for (let k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1; t[n] = c >>> 0; }
  return t;
})();
function crc32(bytes) {
  let c = 0xFFFFFFFF;
  for (let i = 0; i < bytes.length; i++) c = CRC_TABLE[(c ^ bytes[i]) & 0xFF] ^ (c >>> 8);
  return (c ^ 0xFFFFFFFF) >>> 0;
}
async function pngWithDpi(blob, pxPerMm) {
  try {
    const src = new Uint8Array(await blob.arrayBuffer());
    const sig = [137, 80, 78, 71, 13, 10, 26, 10];
    if (sig.some((b, i) => src[i] !== b)) return blob;
    const dv = new DataView(src.buffer, src.byteOffset, src.byteLength);
    const parts = [src.subarray(0, 8)];
    let off = 8, inserted = false;
    while (off + 12 <= src.length) {
      const len = dv.getUint32(off);
      const type = String.fromCharCode(src[off + 4], src[off + 5], src[off + 6], src[off + 7]);
      const end = off + 12 + len;
      if (type !== 'pHYs') parts.push(src.subarray(off, end));
      if (type === 'IHDR' && !inserted) {
        const ppm = Math.round(pxPerMm * 1000);
        const chunk = new Uint8Array(21);
        const cv = new DataView(chunk.buffer);
        cv.setUint32(0, 9);
        chunk.set([112, 72, 89, 115], 4);          // „pHYs“
        cv.setUint32(8, ppm); cv.setUint32(12, ppm); chunk[16] = 1; // Einheit: Meter
        cv.setUint32(17, crc32(chunk.subarray(4, 17)));
        parts.push(chunk);
        inserted = true;
      }
      off = end;
    }
    return inserted ? new Blob(parts, { type: 'image/png' }) : blob;
  } catch (e) { return blob; }
}

function blobFromCanvas(c, type = 'image/png', q) {
  return new Promise((res, rej) => {
    if (c.toBlob) c.toBlob(b => b ? res(b) : rej(new Error('toBlob fehlgeschlagen')), type, q);
    else {
      try {
        const d = c.toDataURL(type, q).split(',')[1];
        const bin = atob(d); const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
        res(new Blob([arr], { type }));
      } catch (e) { rej(e); }
    }
  });
}

function readFileAsDataURL(file) {
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = () => rej(r.error);
    r.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.decoding = 'async';
    img.onload = () => res(img);
    img.onerror = () => rej(new Error('Bild konnte nicht geladen werden'));
    img.src = src;
  });
}

function slug(s) {
  return String(s).toLowerCase()
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}

/* ---- js/10-config.js ---- */
/* ---------------------------------------------------------------------------
   Stammdaten: Stempelmodelle, Gehäuse, Stempelfarben, Schriften
   Die Shopify-Variante wird über die drei Optionswerte gefunden:
   Stempel · Gehäusefarbe · Stempelkissen/Abdruckfarbe
   --------------------------------------------------------------------------- */

const HOUSINGS = {
  'pastell-blau':  { label: 'pastell blau',  swatch: '#c9dfeb' },
  'pastell-gruen': { label: 'pastell grün',  swatch: '#c3e5dc' },
  'pastell-creme': { label: 'pastell creme', swatch: '#fad6c0' },
  'pastell-pink':  { label: 'pastell pink',  swatch: '#f5c7dc' },
  'pastell-lila':  { label: 'pastell lila',  swatch: '#cfc2e4' },
  'buche':         { label: 'Buche natur',   swatch: '#e5bb7b' }
};

const INKS = {
  'schwarz': { label: 'schwarz', color: '#1e1c20', option: 'schwarz', group: 'schwarz' },
  'blau':    { label: 'blau',    color: '#1f4ea1', option: 'blau' },
  'gruen':   { label: 'grün',    color: '#1c7a47', option: 'grün' },
  'rot':     { label: 'rot',     color: '#c42a30', option: 'rot' },
  'violett': { label: 'violett', color: '#5a2d8c', option: 'violett' },
  'ohne':    { label: 'ohne Stempelkissen', color: '#1e1c20', option: 'ohne Stempelkissen', none: true, group: 'ohne' },
  'schwarz-pink-gruen': { label: 'schwarz/pink/grün', bands: ['#1e1c20', '#dc2f84', '#2b8a4c'], option: 'schwarz/pink/grün', multi: true },
  'schwarz-blau-rot':   { label: 'schwarz/blau/rot',  bands: ['#1e1c20', '#1f4ea1', '#c42a30'], option: 'schwarz/blau/rot', multi: true },
  /* Stempelkissen wie beim Logostempel (HS004), 25.09.2026. Farben nach den Produktfotos.
     Clair und Delicata sind in Shopify je eine Variante (Preisgruppe); die genaue Farbe
     geht als Zeile „Kissenfarbe“ mit in die Bestellung. */
  'schwarz-textil':           { label: 'schwarz Textil', color: '#1e1c20', option: 'schwarz Textil', group: 'textil' },
  'clair-morning-mist':       { label: 'Morning Mist',  color: '#77797b', option: 'VersaFine Clair (farbig)', group: 'clair', series: 'VersaFine Clair' },
  'clair-pinecone':           { label: 'Pinecone',      color: '#43332d', option: 'VersaFine Clair (farbig)', group: 'clair', series: 'VersaFine Clair' },
  'clair-fallen-leaves':      { label: 'Fallen Leaves', color: '#6f5c56', option: 'VersaFine Clair (farbig)', group: 'clair', series: 'VersaFine Clair' },
  'clair-twilight':           { label: 'Twilight',      color: '#243a52', option: 'VersaFine Clair (farbig)', group: 'clair', series: 'VersaFine Clair' },
  'clair-rain-forest':        { label: 'Rain Forest',   color: '#243e34', option: 'VersaFine Clair (farbig)', group: 'clair', series: 'VersaFine Clair' },
  'clair-shady-lane':         { label: 'Shady Lane',    color: '#535b30', option: 'VersaFine Clair (farbig)', group: 'clair', series: 'VersaFine Clair' },
  'clair-chianti':            { label: 'Chianti',       color: '#894156', option: 'VersaFine Clair (farbig)', group: 'clair', series: 'VersaFine Clair' },
  'clair-hawthorn-rose':      { label: 'Hawthorn Rose', color: '#be8fa8', option: 'VersaFine Clair (farbig)', group: 'clair', series: 'VersaFine Clair' },
  'delicata-white-shimmer':   { label: 'White Shimmer',    color: '#d6c7b1', option: 'Delicata (metallic)', group: 'delicata', series: 'Delicata', metallic: true, light: true },
  'delicata-golden-glitz':    { label: 'Golden Glitz',     color: '#a27a40', option: 'Delicata (metallic)', group: 'delicata', series: 'Delicata', metallic: true },
  'delicata-celestial-copper': { label: 'Celestial Copper', color: '#8e4a2b', option: 'Delicata (metallic)', group: 'delicata', series: 'Delicata', metallic: true },
  'delicata-champagne':       { label: 'Champagne',        color: '#b39a82', option: 'Delicata (metallic)', group: 'delicata', series: 'Delicata', metallic: true },
  'delicata-rose-gold':       { label: 'Rose Gold',        color: '#a8615f', option: 'Delicata (metallic)', group: 'delicata', series: 'Delicata', metallic: true },
  'delicata-black-shimmer':   { label: 'Black Shimmer',    color: '#2f3333', option: 'Delicata (metallic)', group: 'delicata', series: 'Delicata', metallic: true }
};
const CLAIR_INKS = Object.keys(INKS).filter(k => INKS[k].group === 'clair');
const DELICATA_INKS = Object.keys(INKS).filter(k => INKS[k].group === 'delicata');
const KNOB_INKS = ['ohne', 'schwarz', 'schwarz-textil', ...CLAIR_INKS, ...DELICATA_INKS];
/* Aufpreis der Kissen beim Holzstempel mit Knauf (wie Logostempel), in Cent */
const PAD_SURCHARGE = { ohne: 0, schwarz: 500, textil: 750, clair: 850, delicata: 1000 };

/* Holzstempel mit Knauf in den Größen des Logostempels HS004 (Stand 25.09.2026).
   price = Preis ohne Stempelkissen in Cent. Das Motiv ist produktionsbedingt rundum
   ca. 1 mm kleiner als der Stempel (Logostempel-Beschreibung) → safe: 1. */
const WOOD_SIZES = [
  { id: 'holz-q30', shape: 'square', w: 30, h: 30, price: 1550 },
  { id: 'holz-q40', shape: 'square', w: 40, h: 40, price: 1950 },
  { id: 'holz-q50', shape: 'square', w: 50, h: 50, price: 2350 },
  { id: 'holz-q70', shape: 'square', w: 70, h: 70, price: 2750 },
  { id: 'holz-r25', shape: 'round', w: 25, h: 25, price: 1350 },
  { id: 'holz-r30', shape: 'round', w: 30, h: 30, price: 1450 },
  { id: 'holz-r35', shape: 'round', w: 35, h: 35, price: 1650 },
  { id: 'holz-r40', shape: 'round', w: 40, h: 40, price: 1950 },
  { id: 'holz-r45', shape: 'round', w: 45, h: 45, price: 2150 },
  { id: 'holz-r50', shape: 'round', w: 50, h: 50, price: 2350 },
  { id: 'holz-r60', shape: 'round', w: 60, h: 60, price: 2750 },
  { id: 'holz-80x20', shape: 'rect', w: 80, h: 20, price: 2350 },
  { id: 'holz-50x30', shape: 'rect', w: 50, h: 30, price: 2350 },
  { id: 'holz-70x30', shape: 'rect', w: 70, h: 30, price: 2450 },
  { id: 'holz-85x35', shape: 'rect', w: 85, h: 35, price: 2550 },
  { id: 'holz-60x40', shape: 'rect', w: 60, h: 40, price: 2550 },
  { id: 'holz-70x40', shape: 'rect', w: 70, h: 40, price: 2650 },
  { id: 'holz-80x50', shape: 'rect', w: 80, h: 50, price: 2750 }
];
const WOOD_HINTS = {
  square: 'Quadratisch mit Griff – für Logo, Motiv und Text.',
  round: 'Rund mit Griff – schön für Logos und Text im Kreis.',
  rect: 'Rechteckig mit Griff – für Logo mit Schriftzug, Namen oder Adresse.'
};

/* Holzstempel-Bilder (gerendert 25.09.2026, Buche, Seitenansicht wie die Selbstfärber-Fotos):
   Pixelmaß, Pixel je mm, beim Klassiker die Oberseite (links oben, rechts oben, rechts unten,
   links unten) für die Gravur. Datei: <id>.webp (im Theme kpk-<id>.webp). */
const HOLZ_RENDER = {
  'holz29': { w: 241, h: 217, mm: 5, top: [[13.1, 46.1], [134.4, 5.0], [193.6, 89.3], [72.2, 130.4]] },
  'holz-r25': { w: 222, h: 327, mm: 5 },
  'holz-r30': { w: 255, h: 372, mm: 5 },
  'holz-r35': { w: 288, h: 418, mm: 5 },
  'holz-r40': { w: 321, h: 464, mm: 5 },
  'holz-r45': { w: 334, h: 470, mm: 5 },
  'holz-r50': { w: 352, h: 474, mm: 5 },
  'holz-r60': { w: 377, h: 485, mm: 5 },
  'holz-q30': { w: 286, h: 388, mm: 5 },
  'holz-q40': { w: 360, h: 482, mm: 5 },
  'holz-q50': { w: 394, h: 491, mm: 5 },
  'holz-q70': { w: 506, h: 508, mm: 5 },
  'holz-80x20': { w: 431, h: 317, mm: 5 },
  'holz-50x30': { w: 330, h: 393, mm: 5 },
  'holz-70x30': { w: 411, h: 400, mm: 5 },
  'holz-85x35': { w: 490, h: 452, mm: 5 },
  'holz-60x40': { w: 404, h: 489, mm: 5 },
  'holz-70x40': { w: 436, h: 492, mm: 5 },
  'holz-80x50': { w: 503, h: 500, mm: 5 }
};

const MODELS = [
  {
    id: 'edy', label: 'Edy', kind: 'Selbstfärber', size: '19 × 19 mm', w: 19, h: 19, shape: 'square',
    option: 'Edy (19 × 19 mm)', housingPrefix: 'Edy ',
    housings: ['pastell-gruen', 'pastell-blau', 'pastell-lila', 'pastell-pink', 'pastell-creme'],
    inks: ['schwarz', 'blau', 'gruen', 'rot', 'violett'],
    hint: 'Klein, handlich, perfekt für Motiv + kurzen Text.',
    img: h => `edy-${h}.webp`, deviceW: 29, maxLines: 3
  },
  {
    id: 'holz29', label: 'Holzstempel', kind: 'Buchenholz', size: '29 × 29 mm', w: 29, h: 29, shape: 'square',
    option: 'Holzstempel (29 × 29 mm)', housingPrefix: '',
    housings: ['buche'],
    inks: ['ohne', 'schwarz', 'blau', 'gruen', 'rot', 'violett', 'schwarz-pink-gruen', 'schwarz-blau-rot'],
    hint: 'Der Klassiker aus Buche ohne Griff – dein Motiv ist oben eingraviert.',
    img: () => 'holz29.webp', deviceW: 34, maxLines: 4, wood: true, group: 'holz', classic: true
  },
  {
    id: 'p4911', label: 'Printy 4911', kind: 'Selbstfärber', size: '38 × 14 mm', w: 38, h: 14, shape: 'rect',
    option: 'Printy 4911 (38 × 14 mm)', housingPrefix: '4911 ',
    housings: ['pastell-blau', 'pastell-gruen', 'pastell-creme', 'pastell-pink'],
    inks: ['schwarz', 'blau', 'gruen', 'rot', 'violett'],
    hint: 'Schmal – für ein, zwei Zeilen oder Motiv + Text.',
    img: h => `p4911-${h}.webp`, deviceW: 52, maxLines: 4
  },
  {
    id: 'p4912', label: 'Printy 4912', kind: 'Selbstfärber', size: '47 × 18 mm', w: 47, h: 18, shape: 'rect',
    option: 'Printy 4912 (47 × 18 mm)', housingPrefix: '4912 ',
    housings: ['pastell-blau', 'pastell-gruen', 'pastell-creme', 'pastell-pink'],
    inks: ['schwarz', 'blau', 'gruen', 'rot', 'violett'],
    hint: 'Viel Platz für drei Zeilen, z. B. Name, Klasse, Schule.',
    img: h => `p4912-${h}.webp`, deviceW: 60, maxLines: 5
  },
  {
    id: 'p4913', label: 'Printy 4913', kind: 'Selbstfärber', size: '58 × 22 mm', w: 58, h: 22, shape: 'rect',
    option: 'Printy 4913 (58 × 22 mm)', housingPrefix: '4913 ',
    housings: ['pastell-blau', 'pastell-pink'],
    inks: ['schwarz', 'blau', 'gruen', 'rot', 'violett'],
    hint: 'Der Große – für Adressen und längere Botschaften.',
    img: h => `p4913-${h}.webp`, deviceW: 70, maxLines: 6
  }
];
/* Holzstempel mit Griff: eine Kachel „Holzstempel“, darunter die Größenauswahl (group: 'holz') */
for (const s of WOOD_SIZES) {
  const rd = s.shape === 'round';
  MODELS.push({
    id: s.id, label: 'Holzstempel', kind: 'Buchenholz mit Griff', shape: s.shape, w: s.w, h: s.h,
    size: rd ? `Ø ${s.w} mm` : `${s.w} × ${s.h} mm`,
    short: rd ? `Ø ${s.w}` : `${s.w} × ${s.h}`,
    option: rd ? `Holzstempel rund (Ø ${s.w} mm)` : `Holzstempel (${s.w} × ${s.h} mm)`,
    housingPrefix: '', housings: ['buche'], inks: KNOB_INKS,
    hint: WOOD_HINTS[s.shape], img: () => `${s.id}.webp`, maxLines: clamp(Math.round(s.h / 7), 3, 10),
    wood: true, knob: true, group: 'holz', safe: 1, base: s.price
  });
}
modelById('holz29').short = '29 × 29';

function isRound(m) { return m.shape === 'round'; }
/* rund verhält sich bei Vorlagen, Bogentext und Ausrichten wie quadratisch */
function isSquarish(m) { return m.shape === 'square' || m.shape === 'round'; }
function safeOf(m) { return m.safe != null ? m.safe : SAFE_MM; }
function groupModels(g) { return MODELS.filter(m => m.group === g); }

/* Schriften: label = freundlicher Name im Konfigurator, family = echte Schrift
   (steht in der Bestellung, damit die Werkstatt sie eindeutig kennt). */
const FONTS = [
  { id: 'grund',   family: 'Playwrite DE Grund', label: 'Grundschrift',               group: 'Schulschriften', weight: 400, sample: 'Super gemacht!' },
  { id: 'va',      family: 'Playwrite DE VA',    label: 'Vereinfachte Ausgangsschrift', group: 'Schulschriften', weight: 400 },
  { id: 'sas',     family: 'Playwrite DE SAS',   label: 'Schulausgangsschrift',        group: 'Schulschriften', weight: 400 },
  { id: 'la',      family: 'Playwrite DE LA',    label: 'Lateinische Ausgangsschrift', group: 'Schulschriften', weight: 400 },
  { id: 'at',      family: 'Playwrite AT',       label: 'Österreichische Schulschrift', group: 'Schulschriften', weight: 400 },
  { id: 'lettering', family: 'Delicious Handrawn', label: 'Handlettering', group: 'Handgeschrieben', weight: 400 },
  { id: 'kritzel', family: 'Gochi Hand',         label: 'Kritzelschrift', group: 'Handgeschrieben', weight: 400 },
  { id: 'heft',    family: 'Patrick Hand',       label: 'Heftschrift',    group: 'Handgeschrieben', weight: 400 },
  { id: 'kreide',  family: 'Schoolbell',         label: 'Kreide',         group: 'Handgeschrieben', weight: 400 },
  { id: 'filz',    family: 'Playpen Sans',       label: 'Filzstift',      group: 'Handgeschrieben', weight: 600 },
  { id: 'kaugummi', family: 'Sniglet',           label: 'Kaugummi',       group: 'Verspielt', weight: 800 },
  { id: 'pummel',  family: 'Fredoka',            label: 'Pummelig',       group: 'Verspielt', weight: 600 },
  { id: 'zirkus',  family: 'Grandstander',       label: 'Zirkus',         group: 'Verspielt', weight: 700 },
  { id: 'comic',   family: 'Chewy',              label: 'Comic',          group: 'Verspielt', weight: 400 },
  { id: 'fibel',   family: 'Andika',             label: 'Fibel',          group: 'Klar & ruhig', weight: 700 },
  { id: 'rund',    family: 'Nunito',             label: 'Rund & klar',    group: 'Klar & ruhig', weight: 800 },
  { id: 'kraeftig', family: 'League Spartan',    label: 'Kräftig',        group: 'Klar & ruhig', weight: 700 },
  { id: 'klassisch', family: 'Lora',             label: 'Klassisch',      group: 'Klar & ruhig', weight: 600 }
];

const FRAMES = [
  { id: 'keiner', label: 'Kein Rahmen' },
  { id: 'linie', label: 'Linie' },
  { id: 'doppelt', label: 'Doppellinie' },
  { id: 'punkte', label: 'Punkte' },
  { id: 'strich', label: 'Gestrichelt' },
  { id: 'rund', label: 'Abgerundet' },
  { id: 'kreis', label: 'Kreis', squareOnly: true }
];

const DEFAULT_PRICES = { edy: 1599, p4911: 1719, p4912: 2199, p4913: 2399, holz29: { ohne: 949, single: 1399, multi: 1549 } };

function modelById(id) { return MODELS.find(m => m.id === id) || MODELS[0]; }
function fontById(id) { return FONTS.find(f => f.id === id) || FONTS[0]; }
function inkById(id) { return INKS[id] || INKS.schwarz; }
/* Kissen mit Serie, z. B. „VersaFine Clair Twilight“ (Zusammenfassung, Bühne, Vorschau-Datei) */
function inkTitle(id) { const k = inkById(id); return k.series ? `${k.series} ${k.label}` : k.label; }

/* Variantenindex: in Shopify kommen die echten Varianten aus dem Liquid-Abschnitt,
   im Vorschau-Modus werden sie mit den Sortimentspreisen erzeugt. */
function buildVariants(cfg) {
  const index = new Map();
  const key = (m, hs, ink) => `${m}|${hs}|${ink}`;
  if (Array.isArray(cfg.variants) && cfg.variants.length) {
    for (const v of cfg.variants) {
      const m = MODELS.find(x => x.option === v.option1);
      if (!m) continue;
      const hsId = Object.keys(HOUSINGS).find(k => (m.housingPrefix + HOUSINGS[k].label) === v.option2);
      if (!hsId) continue;
      // eine Shopify-Variante kann für mehrere Kissenfarben stehen (Clair, Delicata)
      for (const inkId of m.inks) {
        if (INKS[inkId].option !== v.option3) continue;
        index.set(key(m.id, hsId, inkId), { id: v.id, price: v.price, available: v.available !== false });
      }
    }
  } else {
    for (const m of MODELS) for (const hs of m.housings) for (const ink of m.inks) {
      let price = DEFAULT_PRICES[m.id];
      if (m.id === 'holz29') price = ink === 'ohne' ? DEFAULT_PRICES.holz29.ohne : (INKS[ink].multi ? DEFAULT_PRICES.holz29.multi : DEFAULT_PRICES.holz29.single);
      if (m.knob) price = m.base + PAD_SURCHARGE[INKS[ink].group];
      index.set(key(m.id, hs, ink), { id: `demo-${m.id}-${hs}-${INKS[ink].option}`, price, available: true });
    }
  }
  return {
    get: (m, hs, ink) => index.get(key(m, hs, ink)) || null,
    minPrice: m => {
      let min = Infinity;
      for (const [k, v] of index) if (k.startsWith(m + '|') && v.available) min = Math.min(min, v.price);
      return min === Infinity ? null : min;
    },
    size: () => index.size
  };
}

/* ---- js/20-render.js ---- */
/* ---------------------------------------------------------------------------
   Renderer: zeichnet den Entwurf als Maske (schwarz auf transparent) –
   dieselbe Funktion für Bühne, Vorlagen-Vorschau, Holzgriff und Druckdatei.
   --------------------------------------------------------------------------- */

const REF = 100; // Messgröße in px
const Measure = (() => {
  const c = canvas(8, 8);
  const ctx = c.getContext('2d');
  const cache = new Map();
  const supportsLS = 'letterSpacing' in ctx;
  return {
    ctx, supportsLS,
    clear() { cache.clear(); },
    get(key, fn) { if (!cache.has(key)) cache.set(key, fn()); return cache.get(key); }
  };
})();

function fontString(f, px) {
  return `${f.weight} ${px}px "${f.family}", "Quattrocento Sans", sans-serif`;
}

function setSpacing(ctx, px) {
  if (Measure.supportsLS) ctx.letterSpacing = (px || 0).toFixed(2) + 'px';
}

/* Eine Textzeile messen (Referenzgröße 100 px). Ohne Canvas-letterSpacing wird
   der Abstand nachgerechnet und beim Zeichnen zeichenweise gesetzt. */
function measureLine(f, text, lsRef) {
  return Measure.get(`${f.id}|${lsRef}|${text}`, () => {
    const ctx = Measure.ctx;
    ctx.font = fontString(f, REF);
    setSpacing(ctx, lsRef);
    ctx.textAlign = 'left';
    ctx.textBaseline = 'alphabetic';
    const t = text && text.length ? text : ' ';
    const m = ctx.measureText(t);
    let w = m.width;
    if (!Measure.supportsLS && lsRef) w += lsRef * t.length;
    if (Measure.supportsLS && lsRef) w -= lsRef; // letzter Buchstabe ohne Nachlauf
    const a = m.actualBoundingBoxAscent != null ? m.actualBoundingBoxAscent : REF * 0.72;
    const d = m.actualBoundingBoxDescent != null ? m.actualBoundingBoxDescent : REF * 0.2;
    const l = m.actualBoundingBoxLeft != null ? m.actualBoundingBoxLeft : 0;
    const r = m.actualBoundingBoxRight != null ? m.actualBoundingBoxRight : w;
    const empty = !(text && text.trim().length);
    return { text: text || '', w, a: empty ? REF * 0.7 : a, d: empty ? 0 : d, l: empty ? 0 : l, r: empty ? w : r, empty };
  });
}

/* Layout eines Textelements in mm (lokale Koordinaten, Ursprung = Ankerpunkt) */
function textLayout(el) {
  const f = fontById(el.font);
  const fontMM = el.size * PT_MM;
  const s = fontMM / REF;                      // mm je Referenz-px
  const lsRef = (el.ls || 0) / 1000 * REF;
  if (el.arc && el.arc !== 'none') {
    const line = (el.text || '').replace(/\s*\n\s*/g, ' ');
    const m = measureLine(f, line, lsRef);
    const W = m.w * s, A = m.a * s, D = m.d * s;
    const rb = el.arc === 'oben' ? el.radius : el.radius + A;
    const span = W / Math.max(rb, 0.1);          // Bogen in Radiant
    const inner = el.arc === 'oben' ? rb - D : rb - A;
    const outer = el.arc === 'oben' ? rb + A : rb + D;
    let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    const n = 28;
    for (let i = 0; i <= n; i++) {
      const phi = -span / 2 + span * i / n;
      for (const r of [inner, outer]) {
        const x = r * Math.sin(phi);
        const y = el.arc === 'oben' ? -r * Math.cos(phi) : r * Math.cos(phi);
        x0 = Math.min(x0, x); x1 = Math.max(x1, x); y0 = Math.min(y0, y); y1 = Math.max(y1, y);
      }
    }
    return { arc: true, f, fontMM, s, line, m, W, A, D, rb, span, bbox: { x0, y0, x1, y1 }, overlap: span > Math.PI * 1.9 };
  }
  const lines = String(el.text || '').split('\n');
  const ms = lines.map(t => measureLine(f, t, lsRef));
  const lh = REF * (el.lh || 1.15);
  const maxW = Math.max(...ms.map(m => m.w), 1);
  const top = 0 - ms[0].a;
  const bottom = (ms.length - 1) * lh + ms[ms.length - 1].d;
  const cy = (top + bottom) / 2;
  let x0 = Infinity, x1 = -Infinity;
  const pos = ms.map((m, i) => {
    let lx = el.align === 'left' ? -maxW / 2 : el.align === 'right' ? maxW / 2 - m.w : -m.w / 2;
    if (!m.empty) { x0 = Math.min(x0, lx - m.l); x1 = Math.max(x1, lx + m.r); }
    return { x: lx, y: i * lh - cy };
  });
  if (!isFinite(x0)) { x0 = -maxW / 2; x1 = maxW / 2; }
  return {
    arc: false, f, fontMM, s, lines, ms, pos, lsRef,
    bbox: { x0: x0 * s, y0: (top - cy) * s, x1: x1 * s, y1: (bottom - cy) * s }
  };
}

/* ---------- Motive (Vektorpfade) ---------- */
/* Platzhalter „Dein Design“ (v1.7, Wunsch 25.09.): eigene Grafik statt Beispielmotiv (vorher die
   Eule). Gestrichelter Rahmen, Bild-Symbol, Schriftzug in Nunito ExtraBold. Steht nicht in der
   Motivliste und kann nicht bestellt werden (App.warnings: „stop“). */
const PH_MOTIF = -1;
const PH_MOTIF_DATA = {"id": -1, "name": "Dein Design", "w": 100.0, "h": 84.0, "d": "M89.73 3.27 L90.41 3.46 L91.07 3.7 L91.72 3.99 L92.25 4.27 L92.85 4.65 L93.41 5.07 L93.95 5.53 L94.45 6.03 L94.91 6.56 L95.33 7.13 L97.77 5.38 L97.23 4.66 L96.64 3.98 L96 3.34 L95.32 2.75 L94.59 2.21 L93.83 1.73 L92.95 1.25 L92.13 0.89 L91.28 0.59 L90.41 0.35ZM96.88 11.03 L96.96 11.74 L97 12.44 L97 13.19 L97 14 L97 14.8 L97 15.61 L97 16.41 L97 17.21 L97 18.02 L97 18.82 L100 18.82 L100 18.02 L100 17.21 L100 16.41 L100 15.61 L100 14.8 L100 14 L100 13.19 L100 12.34 L99.95 11.44 L99.84 10.55ZM97 23.75 L97 24.55 L97 25.36 L97 26.16 L97 26.96 L97 27.77 L97 28.57 L97 29.38 L97 30.18 L97 30.98 L97 31.79 L100 31.79 L100 30.98 L100 30.18 L100 29.38 L100 28.57 L100 27.77 L100 26.96 L100 26.16 L100 25.36 L100 24.55 L100 23.75ZM97 36.71 L97 37.52 L97 38.32 L97 39.13 L97 39.93 L97 40.73 L97 41.54 L97 42.34 L97 43.14 L97 43.95 L97 44.75 L100 44.75 L100 43.95 L100 43.14 L100 42.34 L100 41.54 L100 40.73 L100 39.93 L100 39.13 L100 38.32 L100 37.52 L100 36.71ZM97 49.68 L97 50.48 L97 51.29 L97 52.09 L97 52.89 L97 53.7 L97 54.5 L97 55.31 L97 56.11 L97 56.91 L97 57.72 L100 57.72 L100 56.91 L100 56.11 L100 55.31 L100 54.5 L100 53.7 L100 52.89 L100 52.09 L100 51.29 L100 50.48 L100 49.68ZM97 62.64 L97 63.45 L97 64.25 L97 65.06 L97 65.86 L97 66.66 L97 67.47 L97 68.27 L97 69.08 L97 69.88 L97 70.68 L100 70.68 L100 69.88 L100 69.08 L100 68.27 L100 67.47 L100 66.66 L100 65.86 L100 65.06 L100 64.25 L100 63.45 L100 62.64ZM96.33 74.99 L96.05 75.63 L95.72 76.26 L95.4 76.77 L94.99 77.34 L94.53 77.88 L94.04 78.39 L93.51 78.85 L92.95 79.28 L92.35 79.66 L91.74 80 L93.15 82.65 L93.94 82.21 L94.69 81.72 L95.41 81.17 L96.09 80.58 L96.72 79.93 L97.31 79.25 L97.84 78.52 L98.37 77.67 L98.78 76.87 L99.14 76.04ZM87.65 80.99 L86.9 81 L86.09 81 L85.29 81 L84.48 81 L83.68 81 L82.88 81 L82.07 81 L81.27 81 L80.47 81 L79.66 81 L79.66 84 L80.47 84 L81.27 84 L82.07 84 L82.88 84 L83.68 84 L84.48 84 L85.29 84 L86.09 84 L86.9 84 L87.75 83.99ZM74.73 81 L73.93 81 L73.13 81 L72.32 81 L71.52 81 L70.72 81 L69.91 81 L69.11 81 L68.3 81 L67.5 81 L66.7 81 L66.7 84 L67.5 84 L68.3 84 L69.11 84 L69.91 84 L70.72 84 L71.52 84 L72.32 84 L73.13 84 L73.93 84 L74.73 84ZM61.77 81 L60.96 81 L60.16 81 L59.36 81 L58.55 81 L57.75 81 L56.95 81 L56.14 81 L55.34 81 L54.53 81 L53.73 81 L53.73 84 L54.53 84 L55.34 84 L56.14 84 L56.95 84 L57.75 84 L58.55 84 L59.36 84 L60.16 84 L60.96 84 L61.77 84ZM48.8 81 L48 81 L47.2 81 L46.39 81 L45.59 81 L44.78 81 L43.98 81 L43.18 81 L42.37 81 L41.57 81 L40.76 81 L40.76 84 L41.57 84 L42.37 84 L43.18 84 L43.98 84 L44.78 84 L45.59 84 L46.39 84 L47.2 84 L48 84 L48.8 84ZM35.84 81 L35.03 81 L34.23 81 L33.43 81 L32.62 81 L31.82 81 L31.01 81 L30.21 81 L29.41 81 L28.6 81 L27.8 81 L27.8 84 L28.6 84 L29.41 84 L30.21 84 L31.01 84 L31.82 84 L32.62 84 L33.43 84 L34.23 84 L35.03 84 L35.84 84ZM22.87 81 L22.07 81 L21.26 81 L20.46 81 L19.66 81 L18.85 81 L18.05 81 L17.25 81 L16.44 81 L15.64 81 L14.83 81 L14.83 84 L15.64 84 L16.44 84 L17.25 84 L18.05 84 L18.85 84 L19.66 84 L20.46 84 L21.26 84 L22.07 84 L22.87 84ZM10.27 80.73 L9.59 80.54 L8.93 80.3 L8.28 80.01 L7.75 79.73 L7.15 79.35 L6.59 78.93 L6.05 78.47 L5.55 77.97 L5.09 77.44 L4.67 76.87 L2.23 78.62 L2.77 79.34 L3.36 80.02 L4 80.66 L4.68 81.25 L5.41 81.79 L6.17 82.27 L7.05 82.75 L7.87 83.11 L8.72 83.41 L9.59 83.65ZM3.12 72.97 L3.04 72.26 L3 71.56 L3 70.81 L3 70 L3 69.2 L3 68.39 L3 67.59 L3 66.79 L3 65.98 L3 65.18 L0 65.18 L0 65.98 L0 66.79 L0 67.59 L0 68.39 L0 69.2 L0 70 L0 70.81 L0 71.66 L0.05 72.56 L0.16 73.45ZM3 60.25 L3 59.45 L3 58.64 L3 57.84 L3 57.04 L3 56.23 L3 55.43 L3 54.62 L3 53.82 L3 53.02 L3 52.21 L0 52.21 L0 53.02 L0 53.82 L0 54.62 L0 55.43 L0 56.23 L0 57.04 L0 57.84 L0 58.64 L0 59.45 L0 60.25ZM3 47.29 L3 46.48 L3 45.68 L3 44.87 L3 44.07 L3 43.27 L3 42.46 L3 41.66 L3 40.86 L3 40.05 L3 39.25 L0 39.25 L0 40.05 L0 40.86 L0 41.66 L0 42.46 L0 43.27 L0 44.07 L0 44.87 L0 45.68 L0 46.48 L0 47.29ZM3 34.32 L3 33.52 L3 32.71 L3 31.91 L3 31.11 L3 30.3 L3 29.5 L3 28.69 L3 27.89 L3 27.09 L3 26.28 L0 26.28 L0 27.09 L0 27.89 L0 28.69 L0 29.5 L0 30.3 L0 31.11 L0 31.91 L0 32.71 L0 33.52 L0 34.32ZM3 21.36 L3 20.55 L3 19.75 L3 18.94 L3 18.14 L3 17.34 L3 16.53 L3 15.73 L3 14.92 L3 14.12 L3 13.32 L0 13.32 L0 14.12 L0 14.92 L0 15.73 L0 16.53 L0 17.34 L0 18.14 L0 18.94 L0 19.75 L0 20.55 L0 21.36ZM3.67 9.01 L3.95 8.37 L4.28 7.74 L4.6 7.23 L5.01 6.66 L5.47 6.12 L5.96 5.61 L6.49 5.15 L7.05 4.72 L7.65 4.34 L8.26 4 L6.85 1.35 L6.06 1.79 L5.31 2.28 L4.59 2.83 L3.91 3.42 L3.28 4.07 L2.69 4.75 L2.16 5.48 L1.63 6.33 L1.22 7.13 L0.86 7.96ZM12.35 3.01 L13.1 3 L13.91 3 L14.71 3 L15.52 3 L16.32 3 L17.12 3 L17.93 3 L18.73 3 L19.53 3 L20.34 3 L20.34 0 L19.53 0 L18.73 0 L17.93 0 L17.12 0 L16.32 0 L15.52 0 L14.71 0 L13.91 0 L13.1 0 L12.25 0.01ZM25.27 3 L26.07 3 L26.87 3 L27.68 3 L28.48 3 L29.28 3 L30.09 3 L30.89 3 L31.7 3 L32.5 3 L33.3 3 L33.3 0 L32.5 0 L31.7 0 L30.89 0 L30.09 0 L29.28 0 L28.48 0 L27.68 0 L26.87 0 L26.07 0 L25.27 0ZM38.23 3 L39.04 3 L39.84 3 L40.64 3 L41.45 3 L42.25 3 L43.05 3 L43.86 3 L44.66 3 L45.47 3 L46.27 3 L46.27 0 L45.47 0 L44.66 0 L43.86 0 L43.05 0 L42.25 0 L41.45 0 L40.64 0 L39.84 0 L39.04 0 L38.23 0ZM51.2 3 L52 3 L52.8 3 L53.61 3 L54.41 3 L55.22 3 L56.02 3 L56.82 3 L57.63 3 L58.43 3 L59.24 3 L59.24 0 L58.43 0 L57.63 0 L56.82 0 L56.02 0 L55.22 0 L54.41 0 L53.61 0 L52.8 0 L52 0 L51.2 0ZM64.16 3 L64.97 3 L65.77 3 L66.57 3 L67.38 3 L68.18 3 L68.99 3 L69.79 3 L70.59 3 L71.4 3 L72.2 3 L72.2 0 L71.4 0 L70.59 0 L69.79 0 L68.99 0 L68.18 0 L67.38 0 L66.57 0 L65.77 0 L64.97 0 L64.16 0ZM77.13 3 L77.93 3 L78.74 3 L79.54 3 L80.34 3 L81.15 3 L81.95 3 L82.75 3 L83.56 3 L84.36 3 L85.17 3 L85.17 0 L84.36 0 L83.56 0 L82.75 0 L81.95 0 L81.15 0 L80.34 0 L79.54 0 L78.74 0 L77.93 0 L77.13 0ZM55.4 20.5A5.6 5.6 0 1 0 66.6 20.5A5.6 5.6 0 1 0 55.4 20.5ZM26.2 47Q24 47 25.37 45.28L38.13 29.22Q39.5 27.5 40.89 29.2L47.11 36.8Q48.5 38.5 50.06 36.94L53.94 33.06Q55.5 31.5 57.25 32.83L74.25 45.67Q76 47 73.8 47L26.2 47ZM16.49 72.5Q16.11 72.5 15.90 72.29Q15.69 72.08 15.69 71.70V66.36Q15.69 65.98 15.90 65.77Q16.11 65.56 16.49 65.56H18.41Q20.19 65.56 21.15 66.46Q22.12 67.36 22.12 69.02Q22.12 69.86 21.87 70.50Q21.62 71.15 21.15 71.59Q20.68 72.03 19.99 72.26Q19.30 72.5 18.41 72.5ZM17.22 71.25H18.32Q18.88 71.25 19.29 71.11Q19.70 70.97 19.98 70.70Q20.25 70.42 20.39 70.00Q20.53 69.58 20.53 69.02Q20.53 67.90 19.97 67.36Q19.42 66.81 18.32 66.81H17.22ZM24.69 72.5Q24.31 72.5 24.10 72.29Q23.89 72.08 23.89 71.70V66.36Q23.89 65.98 24.10 65.77Q24.31 65.56 24.69 65.56H28.12Q28.41 65.56 28.57 65.72Q28.72 65.87 28.72 66.15Q28.72 66.45 28.57 66.60Q28.41 66.75 28.12 66.75H25.35V68.38H27.89Q28.20 68.38 28.35 68.53Q28.50 68.68 28.50 68.98Q28.50 69.27 28.35 69.42Q28.20 69.58 27.89 69.58H25.35V71.31H28.12Q28.41 71.31 28.57 71.46Q28.72 71.61 28.72 71.90Q28.72 72.19 28.57 72.34Q28.41 72.5 28.12 72.5ZM31.20 72.58Q30.82 72.58 30.63 72.38Q30.43 72.17 30.43 71.80V66.26Q30.43 65.89 30.63 65.68Q30.82 65.48 31.20 65.48Q31.56 65.48 31.76 65.68Q31.95 65.89 31.95 66.26V71.80Q31.95 72.17 31.76 72.38Q31.57 72.58 31.20 72.58ZM34.65 72.58Q34.30 72.58 34.12 72.39Q33.94 72.20 33.94 71.85V66.24Q33.94 65.87 34.12 65.67Q34.30 65.48 34.61 65.48Q34.87 65.48 35.02 65.58Q35.16 65.68 35.35 65.92L38.80 70.31H38.53V66.20Q38.53 65.86 38.71 65.67Q38.90 65.48 39.24 65.48Q39.58 65.48 39.77 65.67Q39.95 65.86 39.95 66.20V71.88Q39.95 72.20 39.78 72.39Q39.61 72.58 39.33 72.58Q39.05 72.58 38.89 72.48Q38.73 72.37 38.54 72.13L35.10 67.74H35.36V71.85Q35.36 72.20 35.18 72.39Q35.00 72.58 34.65 72.58ZM46.06 72.5Q45.68 72.5 45.47 72.29Q45.27 72.08 45.27 71.70V66.36Q45.27 65.98 45.47 65.77Q45.68 65.56 46.06 65.56H47.98Q49.76 65.56 50.73 66.46Q51.70 67.36 51.70 69.02Q51.70 69.86 51.45 70.50Q51.19 71.15 50.72 71.59Q50.25 72.03 49.56 72.26Q48.87 72.5 47.98 72.5ZM46.79 71.25H47.89Q48.45 71.25 48.86 71.11Q49.28 70.97 49.55 70.70Q49.83 70.42 49.97 70.00Q50.10 69.58 50.10 69.02Q50.10 67.90 49.55 67.36Q48.99 66.81 47.89 66.81H46.79ZM54.26 72.5Q53.88 72.5 53.67 72.29Q53.47 72.08 53.47 71.70V66.36Q53.47 65.98 53.67 65.77Q53.88 65.56 54.26 65.56H57.69Q57.99 65.56 58.14 65.72Q58.29 65.87 58.29 66.15Q58.29 66.45 58.14 66.60Q57.99 66.75 57.69 66.75H54.92V68.38H57.47Q57.77 68.38 57.92 68.53Q58.08 68.68 58.08 68.98Q58.08 69.27 57.92 69.42Q57.77 69.58 57.47 69.58H54.92V71.31H57.69Q57.99 71.31 58.14 71.46Q58.29 71.61 58.29 71.90Q58.29 72.19 58.14 72.34Q57.99 72.5 57.69 72.5ZM62.48 72.60Q62.07 72.60 61.64 72.54Q61.21 72.48 60.82 72.36Q60.44 72.24 60.13 72.06Q59.91 71.94 59.83 71.75Q59.74 71.56 59.76 71.36Q59.79 71.17 59.91 71.02Q60.03 70.86 60.22 70.82Q60.42 70.77 60.65 70.89Q61.06 71.12 61.53 71.23Q62.01 71.33 62.48 71.33Q63.20 71.33 63.50 71.11Q63.81 70.89 63.81 70.56Q63.81 70.27 63.59 70.11Q63.38 69.94 62.83 69.82L61.72 69.58Q60.78 69.39 60.32 68.91Q59.87 68.43 59.87 67.66Q59.87 67.17 60.07 66.76Q60.28 66.36 60.65 66.07Q61.03 65.77 61.54 65.61Q62.06 65.46 62.68 65.46Q63.23 65.46 63.76 65.59Q64.29 65.72 64.69 65.98Q64.89 66.09 64.96 66.28Q65.04 66.46 65.01 66.64Q64.99 66.82 64.87 66.96Q64.74 67.10 64.56 67.14Q64.37 67.18 64.10 67.05Q63.78 66.88 63.41 66.80Q63.05 66.72 62.67 66.72Q62.25 66.72 61.96 66.83Q61.67 66.94 61.52 67.14Q61.37 67.33 61.37 67.59Q61.37 67.87 61.58 68.05Q61.78 68.23 62.29 68.34L63.41 68.57Q64.37 68.78 64.84 69.24Q65.31 69.69 65.31 70.44Q65.31 70.93 65.12 71.33Q64.92 71.73 64.55 72.01Q64.17 72.30 63.65 72.45Q63.13 72.60 62.48 72.60ZM67.66 72.58Q67.29 72.58 67.09 72.38Q66.90 72.17 66.90 71.80V66.26Q66.90 65.89 67.09 65.68Q67.29 65.48 67.66 65.48Q68.03 65.48 68.22 65.68Q68.42 65.89 68.42 66.26V71.80Q68.42 72.17 68.23 72.38Q68.04 72.58 67.66 72.58ZM73.84 72.60Q72.67 72.60 71.86 72.16Q71.04 71.72 70.62 70.92Q70.20 70.13 70.20 69.05Q70.20 68.23 70.45 67.56Q70.70 66.90 71.18 66.43Q71.65 65.97 72.34 65.71Q73.02 65.46 73.89 65.46Q74.42 65.46 74.95 65.57Q75.48 65.69 75.97 65.97Q76.18 66.08 76.25 66.27Q76.32 66.45 76.29 66.65Q76.25 66.85 76.13 67.00Q76.01 67.16 75.82 67.20Q75.63 67.25 75.38 67.13Q75.06 66.95 74.69 66.87Q74.33 66.78 73.90 66.78Q73.20 66.78 72.73 67.04Q72.25 67.30 72.02 67.81Q71.79 68.32 71.79 69.05Q71.79 70.16 72.33 70.74Q72.86 71.31 73.91 71.31Q74.27 71.31 74.64 71.24Q75.02 71.17 75.38 71.04L75.09 71.66V69.77H74.21Q73.91 69.77 73.76 69.62Q73.60 69.48 73.60 69.22Q73.60 68.96 73.76 68.81Q73.91 68.67 74.21 68.67H75.75Q76.05 68.67 76.20 68.83Q76.35 68.99 76.35 69.28V71.56Q76.35 71.82 76.25 71.99Q76.16 72.17 75.92 72.25Q75.48 72.41 74.93 72.50Q74.38 72.60 73.84 72.60ZM79.00 72.58Q78.65 72.58 78.47 72.39Q78.29 72.20 78.29 71.85V66.24Q78.29 65.87 78.47 65.67Q78.65 65.48 78.96 65.48Q79.22 65.48 79.37 65.58Q79.51 65.68 79.70 65.92L83.15 70.31H82.88V66.20Q82.88 65.86 83.06 65.67Q83.25 65.48 83.59 65.48Q83.93 65.48 84.12 65.67Q84.30 65.86 84.30 66.20V71.88Q84.30 72.20 84.13 72.39Q83.96 72.58 83.68 72.58Q83.40 72.58 83.24 72.48Q83.08 72.37 82.89 72.13L79.45 67.74H79.71V71.85Q79.71 72.20 79.53 72.39Q79.35 72.58 79.00 72.58Z"};
const Motifs = {
  list: [], byId: new Map(), ready: false,
  load(data) {
    this.list = data.motive || [];
    for (const m of this.list) {
      try { m.path = new Path2D(m.d); } catch (e) { m.path = null; }
      this.byId.set(m.id, m);
    }
    const ph = Object.assign({}, PH_MOTIF_DATA);
    try { ph.path = new Path2D(ph.d); } catch (e) { ph.path = null; }
    this.byId.set(PH_MOTIF, ph);
    this.ready = true;
  },
  get(id) { return this.byId.get(Number(id)) || null; }
};
function isPlaceholderPic(el) { return !!el && el.type === 'motif' && Number(el.motif) === PH_MOTIF; }

function elementBBox(el, plate) {
  if (el.type === 'text') return textLayout(el).bbox;
  if (el.type === 'motif') {
    const m = Motifs.get(el.motif);
    const hgt = m ? el.w * m.h / m.w : el.w;
    return { x0: -el.w / 2, y0: -hgt / 2, x1: el.w / 2, y1: hgt / 2 };
  }
  if (el.type === 'image') {
    const r = el.ratio || 1;
    return { x0: -el.w / 2, y0: -el.w * r / 2, x1: el.w / 2, y1: el.w * r / 2 };
  }
  if (el.type === 'frame' && plate) {
    return { x0: -plate.w / 2, y0: -plate.h / 2, x1: plate.w / 2, y1: plate.h / 2 };
  }
  return { x0: -1, y0: -1, x1: 1, y1: 1 };
}

/* Ecken der gedrehten Box eines Elements in Plattenkoordinaten (mm) */
function elementCorners(el, plate) {
  const b = elementBBox(el, plate);
  if (el.type === 'frame') return [[b.x0, b.y0], [b.x1, b.y0], [b.x1, b.y1], [b.x0, b.y1]];
  return [[b.x0, b.y0], [b.x1, b.y0], [b.x1, b.y1], [b.x0, b.y1]].map(([x, y]) => fromLocal(x, y, el.x, el.y, el.rot));
}

/* ---------- Zeichnen ---------- */
const imageCache = new Map(); // id -> Canvas (verarbeitete Upload-Maske)

function drawTextEl(ctx, el, k) {
  const L = textLayout(el);
  const f = L.f;
  const px = L.fontMM * k;              // Schriftgröße in Zielpixeln
  const sc = px / REF;
  ctx.save();
  ctx.translate(el.x * k, el.y * k);
  ctx.rotate(deg2rad(el.rot || 0));
  ctx.fillStyle = '#000';
  if (L.arc) {
    drawArcText(ctx, el, L, k);
  } else {
    ctx.font = fontString(f, px);
    ctx.textAlign = 'left';
    ctx.textBaseline = 'alphabetic';
    const lsPx = L.lsRef * sc;
    L.ms.forEach((m, i) => {
      if (m.empty) return;
      const p = L.pos[i];
      fillTextSpaced(ctx, m.text, p.x * sc, p.y * sc, lsPx);
    });
  }
  ctx.restore();
}

function fillTextSpaced(ctx, text, x, y, lsPx) {
  if (!lsPx) { setSpacing(ctx, 0); ctx.fillText(text, x, y); return; }
  if (Measure.supportsLS) { setSpacing(ctx, lsPx); ctx.fillText(text, x, y); setSpacing(ctx, 0); return; }
  let cx = x;
  for (const ch of text) { ctx.fillText(ch, cx, y); cx += ctx.measureText(ch).width + lsPx; }
}

function drawArcText(ctx, el, L, k) {
  const px = L.fontMM * k;
  const sc = px / REF;
  const W = L.m.w * sc, A = L.m.a * sc, D = L.m.d * sc;
  if (W < 1 || L.m.empty) return;
  const pad = Math.ceil(px * 0.35) + 2;
  const oc = canvas(W + pad * 2, A + D + pad * 2);
  const o = oc.getContext('2d');
  o.font = fontString(L.f, px);
  o.textBaseline = 'alphabetic';
  o.fillStyle = '#000';
  fillTextSpaced(o, L.line, pad, pad + A, L.lsRef * sc);
  const rb = L.rb * k;
  const top = el.arc === 'oben';
  const outerR = rb + (top ? A : D) + pad;
  const stretch = Math.max(1, outerR / Math.max(rb, 1));
  const sw = px > 60 ? 2 : 1;
  const OW = oc.width, OH = oc.height;
  for (let x = 0; x < OW; x += sw) {
    const dc = (x + sw / 2) - (pad + W / 2);
    const phi = dc / rb;
    ctx.save();
    ctx.rotate(top ? phi : -phi);
    const wDraw = sw * stretch + 0.6;
    if (top) ctx.drawImage(oc, x, 0, sw, OH, -wDraw / 2, -rb - (pad + A), wDraw, OH);
    else ctx.drawImage(oc, x, 0, sw, OH, -wDraw / 2, rb - (pad + A), wDraw, OH);
    ctx.restore();
  }
}

function drawMotifEl(ctx, el, k) {
  const m = Motifs.get(el.motif);
  if (!m || !m.path) return;
  const sc = el.w / m.w;
  ctx.save();
  ctx.translate(el.x * k, el.y * k);
  ctx.rotate(deg2rad(el.rot || 0));
  ctx.scale(k * sc * (el.flip ? -1 : 1), k * sc);
  ctx.translate(-m.w / 2, -m.h / 2);
  ctx.fillStyle = '#000';
  ctx.fill(m.path, 'evenodd');
  ctx.restore();
}

function drawImageEl(ctx, el, k) {
  const src = imageCache.get(el.id);
  if (!src) return;
  const w = el.w * k, hh = el.w * (el.ratio || 1) * k;
  ctx.save();
  ctx.translate(el.x * k, el.y * k);
  ctx.rotate(deg2rad(el.rot || 0));
  if (el.flip) ctx.scale(-1, 1);
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(src, -w / 2, -hh / 2, w, hh);
  ctx.restore();
}

function roundRectPath(ctx, x, y, w, hh, r) {
  r = Math.max(0, Math.min(r, w / 2, hh / 2));
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + hh, r);
  ctx.arcTo(x + w, y + hh, x, y + hh, r);
  ctx.arcTo(x, y + hh, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

/* Umriss der Stempelplatte als Pfad: rund oder Rechteck mit leicht runden Ecken (Bühne) */
function platePath(ctx, plate, x, y, w, hh, k) {
  if (isRound(plate)) { ctx.beginPath(); ctx.arc(x + w / 2, y + hh / 2, Math.max(0.5, Math.min(w, hh) / 2), 0, Math.PI * 2); ctx.closePath(); return; }
  roundRectPath(ctx, x, y, w, hh, Math.min(10, k * 0.9));
}

/* Abstand der Rahmenlinie zum Plattenrand (mm): beim Holzstempel mit Knauf rundum 1 mm mehr Rand */
function frameInset(el, plate) {
  return (el.inset != null ? el.inset : 0.55) + Math.max(0, safeOf(plate) - SAFE_MM);
}

function drawFrameEl(ctx, el, k, plate) {
  if (!el.style || el.style === 'keiner') return;
  const sw = (el.stroke || 0.45) * k;
  const inset = frameInset(el, plate) * k + sw / 2;
  const W = plate.w * k, H = plate.h * k;
  ctx.save();
  ctx.strokeStyle = '#000';
  ctx.fillStyle = '#000';
  ctx.lineWidth = sw;
  ctx.lineJoin = 'round';
  if (isRound(plate)) {
    // runde Platte: jeder Rahmen folgt dem Kreis
    const R = W / 2 - inset;
    const ring = r => { ctx.beginPath(); ctx.arc(0, 0, Math.max(0.5, r), 0, Math.PI * 2); ctx.stroke(); };
    if (el.style === 'doppelt') { ring(R); ctx.lineWidth = sw * 0.6; ring(R - sw * 2.4); }
    else if (el.style === 'punkte') { ctx.lineCap = 'round'; ctx.lineWidth = sw * 1.5; ctx.setLineDash([0.01, sw * 3.4]); ring(R); }
    else if (el.style === 'strich') { ctx.lineCap = 'round'; ctx.setLineDash([sw * 4, sw * 2.6]); ring(R); }
    else ring(R);
    ctx.restore();
    return;
  }
  const x = -W / 2 + inset, y = -H / 2 + inset, w = W - inset * 2, hh = H - inset * 2;
  const baseR = Math.min(W, H) * 0.06;
  if (el.style === 'linie') { roundRectPath(ctx, x, y, w, hh, baseR); ctx.stroke(); }
  else if (el.style === 'doppelt') {
    roundRectPath(ctx, x, y, w, hh, baseR); ctx.stroke();
    const g = sw * 2.4;
    ctx.lineWidth = sw * 0.6;
    roundRectPath(ctx, x + g, y + g, w - g * 2, hh - g * 2, Math.max(0, baseR - g)); ctx.stroke();
  } else if (el.style === 'punkte') {
    ctx.lineCap = 'round';
    ctx.lineWidth = sw * 1.5;
    ctx.setLineDash([0.01, sw * 3.4]);
    roundRectPath(ctx, x, y, w, hh, baseR * 1.5); ctx.stroke();
  } else if (el.style === 'strich') {
    ctx.lineCap = 'round';
    ctx.setLineDash([sw * 4, sw * 2.6]);
    roundRectPath(ctx, x, y, w, hh, baseR); ctx.stroke();
  } else if (el.style === 'rund') {
    roundRectPath(ctx, x, y, w, hh, Math.min(w, hh) * 0.28); ctx.stroke();
  } else if (el.style === 'kreis') {
    ctx.beginPath(); ctx.arc(0, 0, Math.min(w, hh) / 2, 0, Math.PI * 2); ctx.stroke();
  }
  ctx.restore();
}

/* Kompletten Entwurf als schwarze Maske zeichnen. ctx-Ursprung = Plattenmitte. */
function drawDesign(ctx, design, k, opts = {}) {
  const plate = modelById(design.model);
  const els = design.elements || [];
  for (const el of els) if (el.type === 'frame') drawFrameEl(ctx, el, k, plate);
  for (const el of els) {
    if (opts.skipId && el.id === opts.skipId) continue;
    if (el.hidden) continue;
    if (el.type === 'text') drawTextEl(ctx, el, k);
    else if (el.type === 'motif') drawMotifEl(ctx, el, k);
    else if (el.type === 'image') drawImageEl(ctx, el, k);
  }
}

/* ---------- Tinten-Optik ---------- */
const Texture = (() => {
  let speck = null, cloud = null;
  function make() {
    // feine Fehlstellen (Papierfaser / nicht ganz satter Abdruck)
    speck = canvas(256, 256);
    const s = speck.getContext('2d');
    const id = s.createImageData(256, 256);
    for (let i = 0; i < id.data.length; i += 4) {
      const r = Math.random();
      id.data[i] = id.data[i + 1] = id.data[i + 2] = 0;
      id.data[i + 3] = r > 0.965 ? Math.round(60 + Math.random() * 150) : (r > 0.8 ? 18 : 0);
    }
    s.putImageData(id, 0, 0);
    // weiche Wolken (ungleichmäßige Farbdichte)
    const small = canvas(24, 24);
    const sm = small.getContext('2d');
    const sd = sm.createImageData(24, 24);
    for (let i = 0; i < sd.data.length; i += 4) { sd.data[i + 3] = Math.round(Math.random() * 120); }
    sm.putImageData(sd, 0, 0);
    cloud = canvas(384, 384);
    const c = cloud.getContext('2d');
    c.imageSmoothingEnabled = true;
    c.imageSmoothingQuality = 'high';
    c.drawImage(small, 0, 0, 384, 384);
  }
  return {
    speck() { if (!speck) make(); return speck; },
    cloud() { if (!cloud) make(); return cloud; }
  };
})();

/* Maske in Stempelfarbe einfärben (mit Struktur) und auf ctx zeichnen */
function composeInk(targetCtx, mask, x, y, ink, opts = {}) {
  const W = mask.width, H = mask.height;
  const col = canvas(W, H);
  const c = col.getContext('2d');
  const inkDef = typeof ink === 'string' ? inkById(ink) : ink;
  if (inkDef.bands) {
    const g = c.createLinearGradient(0, 0, W, 0);
    const n = inkDef.bands.length;
    inkDef.bands.forEach((b, i) => {
      g.addColorStop(Math.max(0, i / n + 0.02), b);
      g.addColorStop(Math.min(1, (i + 1) / n - 0.02), b);
    });
    c.fillStyle = g;
  } else if (inkDef.metallic) {
    // Metallic (Delicata): leichter Glanzstreifen quer über den Abdruck
    const g = c.createLinearGradient(0, 0, W, H);
    const hi = mixColor(inkDef.color, '#ffffff', inkDef.light ? 0.3 : 0.24);
    g.addColorStop(0, inkDef.color);
    g.addColorStop(0.42, hi);
    g.addColorStop(0.58, hi);
    g.addColorStop(1, inkDef.color);
    c.fillStyle = g;
  } else c.fillStyle = inkDef.color;
  c.fillRect(0, 0, W, H);
  c.globalCompositeOperation = 'destination-in';
  c.drawImage(mask, 0, 0);
  if (opts.texture !== false) {
    c.globalCompositeOperation = 'destination-out';
    c.globalAlpha = opts.textureStrength != null ? opts.textureStrength : 0.4;
    const pat = c.createPattern(Texture.speck(), 'repeat');
    c.fillStyle = pat;
    c.fillRect(0, 0, W, H);
    c.globalAlpha = 0.16;
    c.drawImage(Texture.cloud(), 0, 0, W, H);
  }
  targetCtx.save();
  targetCtx.globalAlpha = opts.alpha != null ? opts.alpha : 0.94;
  targetCtx.globalCompositeOperation = opts.blend || 'multiply';
  targetCtx.drawImage(col, x, y);
  targetCtx.restore();
  return col;
}

/* Maske in beliebiger Auflösung erzeugen */
function renderMask(design, k, opts = {}) {
  const plate = modelById(design.model);
  const W = Math.ceil(plate.w * k), H = Math.ceil(plate.h * k);
  const c = canvas(W, H);
  const ctx = c.getContext('2d');
  ctx.translate(W / 2, H / 2);
  drawDesign(ctx, design, k, opts);
  if (opts.clip !== false) {
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.globalCompositeOperation = 'destination-in';
    ctx.fillStyle = '#000';
    if (isRound(plate)) { ctx.beginPath(); ctx.arc(W / 2, H / 2, Math.min(W, H) / 2, 0, Math.PI * 2); ctx.fill(); }
    else ctx.fillRect(0, 0, W, H);
  }
  return c;
}

/* ---- js/30-templates.js ---- */
/* ---------------------------------------------------------------------------
   Vorlagen: ordnen Motiv und Text je nach Plattenform an und passen die
   Schriftgröße automatisch ein.
   --------------------------------------------------------------------------- */

const MIN_PT = 6, MAX_PT = 30;
/* Platzhalter-Text der Vorlagen (v1.7, Wunsch 25.09.): verschwindet beim Antippen, man schreibt direkt */
const PH_TEXT = 'Dein Wunschtext';

function newText(text, font, extra = {}) {
  return Object.assign({ id: uid('t'), type: 'text', text, font, size: 10, lh: 1.12, ls: 0, align: 'center', arc: 'none', radius: 6, x: 0, y: 0, rot: 0 }, extra);
}
function newMotif(motif, extra = {}) {
  return Object.assign({ id: uid('m'), type: 'motif', motif, w: 10, x: 0, y: 0, rot: 0, flip: false }, extra);
}

/* Größe so wählen, dass die Box in (maxW × maxH) passt */
function fitText(el, maxW, maxH, minPt = MIN_PT, maxPt = MAX_PT) {
  el.size = 10;
  const b = textLayout(el).bbox;
  const w = Math.max(b.x1 - b.x0, 0.01), hh = Math.max(b.y1 - b.y0, 0.01);
  el.size = round(clamp(Math.min(10 * maxW / w, 10 * maxH / hh), minPt, maxPt), 1);
  return el;
}

/* Bogentext: Radius zur Außenkante outerR für die aktuelle Größe */
function arcRadius(el, outerR) {
  const L = textLayout(Object.assign({}, el, { arc: 'none', text: (el.text || '').replace(/\s*\n\s*/g, ' ') }));
  const A = L.ms[0].a * L.s, D = L.ms[0].d * L.s;
  el.radius = round(el.arc === 'oben' ? outerR - A : outerR - A - D, 2);
  return { A, D };
}

/* Bogentext: Größe so wählen, dass die Schrift in den Ring passt und der Bogen maxSpan nicht überschreitet */
function fitArc(el, outerR, maxSpan, capMax, minPt = MIN_PT, maxPt = 22) {
  let lo = minPt, hi = maxPt;
  for (let i = 0; i < 14; i++) {
    const mid = (lo + hi) / 2;
    el.size = mid;
    const { A } = arcRadius(el, outerR);
    const L = textLayout(el);
    if (A <= capMax && L.span <= maxSpan && el.radius > 0.5) lo = mid; else hi = mid;
  }
  el.size = round(lo, 1);
  arcRadius(el, outerR);
  return el;
}

/* Motiv in eine Box einpassen */
function fitMotif(el, boxW, boxH) {
  if (el.type === 'motif') {
    const m = Motifs.get(el.motif);
    const ar = m ? m.h / m.w : 1;
    el.w = round(Math.min(boxW, boxH / ar), 2);
  } else if (el.type === 'image') {
    const ar = el.ratio || 1;
    el.w = round(Math.min(boxW, boxH / ar), 2);
  }
  return el;
}

/* ---------- Innenflächen: Platte (mit Sicherheitsabstand) und Rahmen ----------
   Maße wie in drawFrameEl; gap = Luft zwischen Rahmenlinie und Inhalt. */
function plateRegion(plate, margin = safeOf(plate)) {
  if (isRound(plate)) return { circle: true, r: plate.w / 2 - margin };
  return { hx: plate.w / 2 - margin, hy: plate.h / 2 - margin, r: 0 };
}
function frameRegion(fr, plate, gap = 0.55) {
  const sw = fr.stroke || 0.45;
  const c = frameInset(fr, plate) + sw / 2;      // Mitte der äußeren Linie
  const w = plate.w - 2 * c, hh = plate.h - 2 * c;
  let edge = sw / 2, r = Math.min(plate.w, plate.h) * 0.06;
  if (fr.style === 'doppelt') edge = sw * 2.4 + sw * 0.3;
  else if (fr.style === 'punkte') { edge = sw * 0.75; r *= 1.5; }
  else if (fr.style === 'rund') r = Math.min(w, hh) * 0.28;
  const d = edge + gap;
  if (fr.style === 'kreis' || isRound(plate)) return { circle: true, r: Math.min(w, hh) / 2 - d };
  return { hx: w / 2 - d, hy: hh / 2 - d, r: Math.max(0, r - d) };
}
/* Rahmen beim Vorlagenwechsel: rund → jede Art folgt dem Kreis („Kreis“/„Abgerundet“ = Linie) */
function frameFor(style, model) {
  if (!style || style === 'keiner') return null;
  if (isRound(model)) return style === 'kreis' || style === 'rund' ? 'linie' : style;
  return style === 'kreis' ? 'rund' : style;
}
/* Seitenverhältnis (Höhe/Breite) eines Motivs oder Bildes */
function picAR(pic) {
  if (pic.type === 'motif') { const mo = Motifs.get(pic.motif); return mo ? mo.h / mo.w : 1; }
  return pic.ratio || 1;
}
/* Größte Box (ar = Höhe/Breite) im Kreis mit Radius R, deren Unterkante bei Breite w
   höchstens bei yMaxOf(w) liegt. Liefert Breite und Mitte (y). */
function boxInCircle(ar, R, yMaxOf = () => Infinity, wMax = Infinity) {
  const band = w => { const s = Math.sqrt(Math.max(0, R * R - w * w / 4)); return [-s, Math.min(s, yMaxOf(w))]; };
  const fits = w => { const [a, b] = band(w); return b > a && w * ar <= b - a; };
  let lo = 0, hi = Math.max(0, Math.min(2 * R, wMax));
  if (fits(hi)) lo = hi;
  else for (let i = 0; i < 24; i++) { const mid = (lo + hi) / 2; if (fits(mid)) lo = mid; else hi = mid; }
  const [a, b] = band(lo);
  return { w: lo, cy: (a + b) / 2 };
}
/* Text (ohne Bogen) so groß wie möglich, sodass sein Kasten mittig im Kreis R liegt */
function fitTextInCircle(el, R, maxPt) {
  let lo = MIN_PT, hi = Math.max(MIN_PT, maxPt);
  const ok = sz => { el.size = sz; const b = textLayout(el).bbox; const hw = Math.max(-b.x0, b.x1), hh = (b.y1 - b.y0) / 2; return hw * hw + hh * hh <= R * R; };
  if (ok(hi)) lo = hi;
  else for (let i = 0; i < 16; i++) { const mid = (lo + hi) / 2; if (ok(mid)) lo = mid; else hi = mid; }
  el.size = round(lo, 1);
  const b = textLayout(el).bbox;
  el.y = round(-(b.y0 + b.y1) / 2, 2);
  return el;
}
function contentRegion(design) {
  const plate = modelById(design.model);
  const fr = (design.elements || []).find(e => e.type === 'frame' && e.style && e.style !== 'keiner');
  return fr ? frameRegion(fr, plate) : plateRegion(plate);
}
function inRegion(x, y, R) {
  if (R.circle) return x * x + y * y <= R.r * R.r;
  const ax = Math.abs(x), ay = Math.abs(y);
  if (ax > R.hx || ay > R.hy) return false;
  const cx = R.hx - R.r, cy = R.hy - R.r;
  if (R.r > 0 && ax > cx && ay > cy) { const dx = ax - cx, dy = ay - cy; return dx * dx + dy * dy <= R.r * R.r; }
  return true;
}
/* Tintenpunkte des Inhalts (ohne Rahmen) in mm, auch außerhalb der Platte */
function inkPoints(design, k = 8, only) {
  const plate = modelById(design.model);
  const W = Math.ceil(plate.w * k * 2), H = Math.ceil(plate.h * k * 2);
  const c = canvas(W, H);
  const ctx = c.getContext('2d');
  ctx.translate(W / 2, H / 2);
  const els = (design.elements || []).filter(e => e.type !== 'frame' && (!only || e === only));
  drawDesign(ctx, { model: design.model, elements: els }, k);
  const d = ctx.getImageData(0, 0, W, H).data;
  const pts = [];
  for (let y = 0, p = 3; y < H; y++) {
    for (let x = 0; x < W; x++, p += 4) if (d[p] > 127) pts.push((x + 0.5 - W / 2) / k, (y + 0.5 - H / 2) / k);
  }
  return pts;
}
/* Gesamten Inhalt gleichmäßig (um die Plattenmitte) verkleinern, bis er in R passt.
   Schrift wird nicht exakt linear kleiner (Rundung, Laufweite) – daher bis zu drei Durchgänge. */
function fitContentInto(design, R) {
  if (!R || (R.circle ? R.r <= 0 : (R.hx <= 0 || R.hy <= 0))) return 1;
  // Raster ist 1/6 mm grob – eine Pixelbreite Reserve, damit auch feiner gemessen nichts übersteht
  const e = 0.17;
  R = R.circle ? { circle: true, r: R.r - e } : { hx: R.hx - e, hy: R.hy - e, r: Math.max(0, R.r - e) };
  let total = 1;
  for (let pass = 0; pass < 3; pass++) {
    const pts = inkPoints(design, 6);
    if (!pts.length) return total;
    const fits = s => { for (let i = 0; i < pts.length; i += 2) if (!inRegion(pts[i] * s, pts[i + 1] * s, R)) return false; return true; };
    if (fits(1)) return total;
    let lo = 0.2, hi = 1;
    for (let i = 0; i < 16; i++) { const mid = (lo + hi) / 2; if (fits(mid)) lo = mid; else hi = mid; }
    const s = lo * 0.99;
    for (const e of design.elements) {
      if (e.type === 'frame') continue;
      e.x = round(e.x * s, 3); e.y = round(e.y * s, 3);
      if (e.type === 'text') { e.size = round(e.size * s, 2); if (e.arc && e.arc !== 'none') e.radius = round(e.radius * s, 3); }
      else e.w = round(e.w * s, 3);
    }
    total *= s;
  }
  return total;
}

function splitInTwo(text) {
  const t = String(text || '').trim();
  if (t.includes('\n')) { const [a, ...b] = t.split('\n'); return [a.trim(), b.join(' ').trim()]; }
  const words = t.split(/\s+/);
  if (words.length < 2) return [t, ''];
  let best = 1, bestDiff = Infinity;
  for (let i = 1; i < words.length; i++) {
    const a = words.slice(0, i).join(' ').length, b = words.slice(i).join(' ').length;
    if (Math.abs(a - b) < bestDiff) { bestDiff = Math.abs(a - b); best = i; }
  }
  return [words.slice(0, best).join(' '), words.slice(best).join(' ')];
}

function wrapForBox(text, font, maxW, maxH, maxLines = 3) {
  const t = String(text || '').trim();
  if (!t || t.includes('\n')) return t;
  const probe = newText(t, font);
  fitText(probe, maxW, maxH);
  if (probe.size >= 8 || t.split(/\s+/).length < 2) return t;
  const [a, b] = splitInTwo(t);
  return b ? a + '\n' + b : a;
}

const TEMPLATES = {
  square: [
    { id: 'motiv-text', label: 'Motiv + Text', needs: 'mt' },
    { id: 'kreis', label: 'Text im Kreis', needs: 'mt' },
    { id: 'bogen', label: 'Bogen unten', needs: 'mt' },
    { id: 'oben-unten', label: 'Oben & unten', needs: 'mt' },
    { id: 'text', label: 'Nur Text', needs: 't' },
    { id: 'motiv', label: 'Nur Motiv', needs: 'm' }
  ],
  rect: [
    { id: 'motiv-links', label: 'Motiv links', needs: 'mt' },
    { id: 'motiv-rechts', label: 'Motiv rechts', needs: 'mt' },
    { id: 'text', label: 'Nur Text', needs: 't' },
    { id: 'rahmen', label: 'Text mit Rahmen', needs: 't' }
  ],
  // runde Holzstempel (25.09.2026): wie quadratisch, ohne „Oben & unten“ (dafür gibt es den Kreis)
  round: [
    { id: 'motiv-text', label: 'Motiv + Text', needs: 'mt' },
    { id: 'kreis', label: 'Text im Kreis', needs: 'mt' },
    { id: 'bogen', label: 'Bogen unten', needs: 'mt' },
    { id: 'text', label: 'Nur Text', needs: 't' },
    { id: 'motiv', label: 'Nur Motiv', needs: 'm' }
  ]
};

function templatesFor(model) { return TEMPLATES[model.shape]; }

/* Inhalt aus dem aktuellen Entwurf holen (Texte oben → unten, erstes Motiv/Bild) */
function extractContent(design) {
  const els = design.elements || [];
  const texts = els.filter(e => e.type === 'text');
  const order = e => e.arc === 'oben' ? -1000 + e.x : e.arc === 'unten' ? 1000 + e.x : e.y;
  texts.sort((a, b) => order(a) - order(b));
  const pic = els.find(e => e.type === 'motif' || e.type === 'image') || null;
  const frame = els.find(e => e.type === 'frame' && e.style !== 'keiner') || null;
  return {
    texts: texts.map(t => t.text),
    phs: texts.map(t => !!t.ph),          // Beispieltexte (Platzhalter) bleiben beim Neuanordnen Platzhalter
    fonts: texts.map(t => t.font),
    font: texts[0] ? texts[0].font : 'grund',
    pic: pic ? JSON.parse(JSON.stringify(pic)) : null,
    frame: frame ? frame.style : null
  };
}

function applyTemplate(design, tplId, contentOverride) {
  const model = modelById(design.model);
  const c = contentOverride || extractContent(design);
  const S = Math.min(model.w, model.h);
  const m = safeOf(model) + 0.35;
  const fontAt = i => c.fonts[i] || c.font;
  const pic = c.pic ? Object.assign(c.pic, { rot: 0, x: 0, y: 0 }) : null;
  const allText = c.texts.filter(t => t && t.trim()).join(' ').trim();
  const els = [];
  const addFrame = style => { if (style) els.push({ id: uid('f'), type: 'frame', style, stroke: 0.42, inset: 0.5 }); };
  const rd = isRound(model);

  // Eigenes, fertiges Design: Bild füllt die Stempelfläche. Kommt Text dazu, wie „Motiv + Text“.
  if (tplId === 'design') {
    if (!allText) {
      const frame = rd ? frameFor(c.frame, model) : c.frame ? (c.frame === 'kreis' && model.shape !== 'square' ? 'rund' : c.frame) : null;
      const mm = frame ? safeOf(model) + 1.2 : m;
      if (pic) { fitMotif(pic, model.w - 2 * mm, model.h - 2 * mm); els.push(pic); }
      addFrame(frame);
      design.elements = els;
      design.template = 'design';
      design.manual = false;
      const fr0 = els.find(e => e.type === 'frame');
      // rund: Bild so groß, dass es gerade in den Kreis passt (nach den echten Bildpunkten)
      if (fr0) fitContentInto(design, frameRegion(fr0, model));
      else if (rd) fitContentInto(design, plateRegion(model));
      return design;
    }
    tplId = isSquarish(model) ? 'motiv-text' : 'motiv-links';
  }

  if (rd) {
    // ---------- runde Platte (Holzstempel mit Knauf) ----------
    const R = model.w / 2 - m;
    const cap = S * 0.105;
    if (tplId === 'motiv-text') {
      const t = c.texts.length > 1 ? c.texts.slice(0, 2).join('\n') : wrapForBox(allText || PH_TEXT, c.font, R * 1.3, R * 0.5, 2);
      const tx = newText(t, fontAt(0));
      if (pic) {
        const two = t.includes('\n');
        fitText(tx, R * (two ? 1.35 : 1.3), R * (two ? 0.5 : 0.3), MIN_PT, S * 1.05);
        const tb = textLayout(tx).bbox;
        const hw = Math.max(-tb.x0, tb.x1);
        tx.y = round(Math.sqrt(Math.max(0, R * R - hw * hw)) - tb.y1, 2);   // Unterkante auf der Sehne
        const bottom = tx.y + tb.y0 - S * 0.04;
        const bx = boxInCircle(picAR(pic), R, () => bottom, S * 0.78);
        pic.w = round(bx.w, 2); pic.x = 0; pic.y = round(bx.cy, 2);
        els.push(pic);
      } else fitTextInCircle(tx, R, S * 1.05);
      els.push(tx);
    } else if (tplId === 'kreis') {
      const [a, b] = c.texts.length > 1 ? [c.texts[0], c.texts.slice(1).join(' ')] : splitInTwo(allText || PH_TEXT);
      const top = fitArc(newText(a, fontAt(0), { arc: 'oben' }), R, deg2rad(150), cap);
      els.push(top);
      let innerR = top.radius;
      if (b) {
        const bot = fitArc(newText(b, fontAt(1), { arc: 'unten' }), R, deg2rad(150), cap);
        const sz = Math.min(top.size, bot.size);
        top.size = bot.size = sz;
        arcRadius(top, R);
        arcRadius(bot, R);
        els.push(bot);
        innerR = Math.min(top.radius, bot.radius);
      }
      if (pic) { const d = (innerR - S * 0.035) * 2 * 0.74; fitMotif(pic, d, d); els.push(pic); }
    } else if (tplId === 'bogen') {
      const bot = fitArc(newText(allText || PH_TEXT, fontAt(0), { arc: 'unten' }), R, deg2rad(165), cap * 1.1);
      els.push(bot);
      if (pic) {
        const inner = bot.radius - S * 0.035;         // Innenkante des Textrings mit Luft
        const bx = boxInCircle(picAR(pic), R, w => Math.sqrt(Math.max(0, inner * inner - w * w / 4)), Math.min(S * 0.74, 2 * inner));
        pic.w = round(bx.w, 2); pic.x = 0; pic.y = round(bx.cy, 2);
        els.push(pic);
      }
    } else if (tplId === 'text') {
      const t = c.texts.length > 1 ? c.texts.join('\n') : wrapForBox(allText || PH_TEXT, c.font, R * 1.5, R, 3);
      els.push(fitTextInCircle(newText(t, fontAt(0)), R, S * 1.2));
    } else if (tplId === 'motiv') {
      if (pic) { fitMotif(pic, 2 * R, 2 * R); els.push(pic); }   // wird unten nach Bildpunkten eingepasst
    }
    addFrame(frameFor(c.frame, model));
  } else if (model.shape === 'square') {
    const half = model.w / 2 - m;
    const cap = S * 0.105;
    if (tplId === 'motiv-text') {
      const t = c.texts.length > 1 ? c.texts.slice(0, 2).join('\n') : wrapForBox(allText || PH_TEXT, c.font, S * 0.9, S * 0.26, 2);
      const tx = newText(t, fontAt(0));
      fitText(tx, S * 0.9, S * (t.includes('\n') ? 0.27 : 0.17), MIN_PT, S * 1.05);
      const tb = textLayout(tx).bbox;
      tx.y = round(half - tb.y1, 2);
      if (pic) {
        const top = -half, bottom = tx.y + tb.y0 - S * 0.04;
        fitMotif(pic, S * 0.78, bottom - top);
        pic.y = round((top + bottom) / 2, 2);
        pic.x = 0;
        els.push(pic);
      } else { fitText(tx, S * 0.88, S * 0.8); const b2 = textLayout(tx).bbox; tx.y = round(-(b2.y0 + b2.y1) / 2, 2); }
      els.push(tx);
    } else if (tplId === 'kreis') {
      const [a, b] = c.texts.length > 1 ? [c.texts[0], c.texts.slice(1).join(' ')] : splitInTwo(allText || PH_TEXT);
      const outerR = half;
      const top = fitArc(newText(a, fontAt(0), { arc: 'oben' }), outerR, deg2rad(150), cap);
      els.push(top);
      let innerR = top.radius;
      if (b) {
        const bot = fitArc(newText(b, fontAt(1), { arc: 'unten' }), outerR, deg2rad(150), cap);
        const sz = Math.min(top.size, bot.size);
        top.size = bot.size = sz;
        arcRadius(top, outerR);
        arcRadius(bot, outerR);
        els.push(bot);
        innerR = Math.min(top.radius, bot.radius);
      }
      if (pic) { const d = (innerR - S * 0.035) * 2 * 0.74; fitMotif(pic, d, d); els.push(pic); }
    } else if (tplId === 'bogen') {
      const outerR = half;
      const bot = fitArc(newText(allText || PH_TEXT, fontAt(0), { arc: 'unten' }), outerR, deg2rad(165), cap * 1.1);
      els.push(bot);
      if (pic) {
        const inner = bot.radius;             // Innenkante des Textrings (Mitte = Plattenmitte)
        const gap = S * 0.035;
        let w = S * 0.74;
        for (let i = 0; i < 3; i++) {
          const yLim = Math.sqrt(Math.max(0, inner * inner - (w / 2) * (w / 2))) - gap;
          fitMotif(pic, w, yLim + half);
          const ph = pic.type === 'motif' ? pic.w * ((Motifs.get(pic.motif) || { h: 1 }).h / (Motifs.get(pic.motif) || { w: 1 }).w) : pic.w * (pic.ratio || 1);
          pic.y = round(yLim - ph / 2, 2);
          if (pic.y - ph / 2 < -half) pic.y = round(-half + ph / 2, 2);
          if (Math.abs(pic.w - w) < 0.2) break;
          w = pic.w;
        }
        els.push(pic);
      }
    } else if (tplId === 'oben-unten') {
      let [a, b] = c.texts.length > 1 ? [c.texts[0], c.texts.slice(1).join(' ')] : splitInTwo(allText || PH_TEXT);
      const t1 = fitText(newText(a, fontAt(0)), S * 0.9, S * 0.16, MIN_PT, S);
      const t2 = b ? fitText(newText(b, fontAt(1)), S * 0.9, S * 0.16, MIN_PT, S) : null;
      if (t2) { const sz = Math.min(t1.size, t2.size); t1.size = t2.size = sz; }
      const b1 = textLayout(t1).bbox; t1.y = round(-half - b1.y0, 2);
      els.push(t1);
      let bottom = half;
      if (t2) { const b2 = textLayout(t2).bbox; t2.y = round(half - b2.y1, 2); els.push(t2); bottom = t2.y + b2.y0; }
      if (pic) {
        const topY = t1.y + b1.y1 + S * 0.035, botY = bottom - S * 0.035;
        fitMotif(pic, S * 0.8, botY - topY); pic.y = round((topY + botY) / 2, 2); els.push(pic);
      }
    } else if (tplId === 'text') {
      const t = c.texts.length > 1 ? c.texts.join('\n') : wrapForBox(allText || PH_TEXT, c.font, S * 0.88, S * 0.6, 3);
      els.push(fitText(newText(t, fontAt(0)), S * 0.88, S * 0.84, MIN_PT, S * 1.2));
    } else if (tplId === 'motiv') {
      if (pic) { fitMotif(pic, S * 0.88, S * 0.88); els.push(pic); }
    }
    if (c.frame && tplId !== 'kreis') addFrame(c.frame === 'kreis' ? 'rund' : c.frame);
  } else {
    const W = model.w, H = model.h;
    const halfW = W / 2 - m, halfH = H / 2 - m;
    const lines = c.texts.filter(t => t != null);
    const txt = lines.length > 1 ? lines.join('\n') : (allText || PH_TEXT);
    if (tplId === 'motiv-links' || tplId === 'motiv-rechts') {
      const side = tplId === 'motiv-links' ? -1 : 1;
      let boxW = 0;
      if (pic) {
        fitMotif(pic, Math.min(H * 1.25, W * 0.36), H - 2 * m);
        const pw = pic.w;
        pic.x = round(side * (halfW - pw / 2), 2); pic.y = 0;
        boxW = pw + W * 0.04;
        els.push(pic);
      }
      const areaW = W - 2 * m - boxW;
      const cx = -side * (boxW / 2);
      const wrapped = txt.includes('\n') ? txt : wrapForBox(txt, c.font, areaW, H - 2 * m, 3);
      const tx = fitText(newText(wrapped, fontAt(0)), areaW, H - 2 * m, MIN_PT, H * 1.6);
      const tb = textLayout(tx).bbox;
      tx.x = round(cx - (tb.x0 + tb.x1) / 2, 2);
      tx.y = round(-(tb.y0 + tb.y1) / 2, 2);
      els.push(tx);
    } else if (tplId === 'text' || tplId === 'rahmen') {
      const inner = tplId === 'rahmen' ? 0.8 : 0.94;
      const wrapped = txt.includes('\n') ? txt : wrapForBox(txt, c.font, W * inner, H * inner, 3);
      const tx = fitText(newText(wrapped, fontAt(0)), W * inner - 2 * m, (H - 2 * m) * (tplId === 'rahmen' ? 0.72 : 0.96), MIN_PT, H * 1.6);
      const tb = textLayout(tx).bbox;
      tx.y = round(-(tb.y0 + tb.y1) / 2, 2);
      els.push(tx);
      if (tplId === 'rahmen') addFrame('rund');
    }
    if (c.frame && tplId !== 'rahmen') addFrame(c.frame === 'kreis' ? 'rund' : c.frame);
  }
  // Texte der Vorlage ohne eigenen Inhalt sind Platzhalter („Dein Wunschtext“): Antippen macht das Feld frei
  const nts = els.filter(e => e.type === 'text');
  if (!allText) nts.forEach(t => { t.ph = true; });
  else if (c.phs && c.phs.length) {
    if (c.phs.length === nts.length) nts.forEach((t, i) => { if (c.phs[i]) t.ph = true; });
    else if (c.phs.every(Boolean)) nts.forEach(t => { t.ph = true; });
  }
  design.elements = els;
  design.template = tplId;
  design.manual = false;          // Anordnung kommt aus der Vorlage (Tippen darf neu einpassen)
  const fr = els.find(e => e.type === 'frame');
  if (fr) fitContentInto(design, frameRegion(fr, model));
  else if (rd) fitContentInto(design, plateRegion(model));   // rund: nichts ragt über den Kreis
  return design;
}

/* ---- js/40-stage.js ---- */
/* ---------------------------------------------------------------------------
   Bühne: Abdruck-Vorschau auf Papier, Auswahlrahmen, Ziehen/Skalieren/Drehen,
   Hilfslinien, Gerätebild (Selbstfärber-Foto bzw. gerenderter Holzstempel, beim
   Klassiker mit Gravur oben drauf).
   --------------------------------------------------------------------------- */

const TOOLS_KEY = 'kpk-werkzeuge-v1';   // Raster/Einrasten an oder aus (nur in diesem Browser)

class Stage {
  constructor(app, root) {
    this.app = app;
    this.root = root;
    this.dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    this.preview = false;
    this.drag = null;
    this.k = 10;
    this.plateBox = { x: 0, y: 0, w: 0, h: 0 };
    const tp = storage.get(TOOLS_KEY) || {};
    this.grid = tp.raster !== false;        // Raster: Standard an
    this.snap = tp.einrasten !== false;     // Einrasten an Mitte und Rändern: Standard an
    this.build();
    this.renderSoon = rafThrottle(() => this.render());
    this.woodSoon = debounce(() => this.renderWood(), 60);
    const ro = window.ResizeObserver ? new ResizeObserver(() => this.resize()) : null;
    if (ro) ro.observe(this.paper); else window.addEventListener('resize', () => this.resize());
    this.resize();
  }

  build() {
    const r = this.root;
    this.paper = h('div', { class: 'kpk-paper' });
    this.canvas = h('canvas', { class: 'kpk-canvas', role: 'img', 'aria-label': 'Vorschau deines Stempelabdrucks' });
    this.overlay = h('div', { class: 'kpk-overlay' });
    // Hilfslinien als <span>: das Shop-Theme (Craft/Dawn, base.css „div:empty { display: none }“)
    // blendet leere <div> aus – deshalb waren die Linien im Shop nie zu sehen (Fix v1.7)
    this.guideV = h('span', { class: 'kpk-guide kpk-guide-v', 'aria-hidden': 'true' });
    this.guideH = h('span', { class: 'kpk-guide kpk-guide-h', 'aria-hidden': 'true' });
    this.guideEV = h('span', { class: 'kpk-guide kpk-guide-v kpk-guide-edge', 'aria-hidden': 'true' });
    this.guideEH = h('span', { class: 'kpk-guide kpk-guide-h kpk-guide-edge', 'aria-hidden': 'true' });
    this.sel = h('div', { class: 'kpk-sel', hidden: true },
      this.slotLbl = h('span', { class: 'kpk-sel-slot', 'aria-hidden': 'true' }),
      h('span', { class: 'kpk-h kpk-h-nw', 'data-h': 'scale' }),
      h('span', { class: 'kpk-h kpk-h-ne', 'data-h': 'scale' }),
      h('span', { class: 'kpk-h kpk-h-se', 'data-h': 'scale' }),
      h('span', { class: 'kpk-h kpk-h-sw', 'data-h': 'scale' }),
      h('span', { class: 'kpk-h kpk-h-rot', 'data-h': 'rotate', title: 'Drehen' }, icon('rotate'))
    );
    this.ctxbar = h('div', { class: 'kpk-ctxbar', hidden: true },
      h('button', { type: 'button', class: 'kpk-ctx', 'data-act': 'center', title: 'Mittig ausrichten' }, icon('center'), h('span', null, 'Mitte')),
      h('button', { type: 'button', class: 'kpk-ctx', 'data-act': 'duplicate', title: 'Verdoppeln' }, icon('copy')),
      h('button', { type: 'button', class: 'kpk-ctx', 'data-act': 'front', title: 'Nach vorne' }, icon('front')),
      h('button', { type: 'button', class: 'kpk-ctx kpk-ctx-del', 'data-act': 'delete', title: 'Entfernen' }, icon('trash'))
    );
    this.overlay.append(this.guideV, this.guideH, this.guideEV, this.guideEH, this.sel, this.ctxbar);
    this.paper.append(this.canvas, this.overlay);

    this.device = h('div', { class: 'kpk-device', 'aria-hidden': 'true' });
    this.devImgA = h('img', { class: 'kpk-device-img is-on', alt: '' });
    this.devImgB = h('img', { class: 'kpk-device-img', alt: '' });
    // Klassiker 29 × 29 (ohne Griff): der Entwurf als Gravur auf der Oberseite des Holzblocks
    this.woodCanvas = h('canvas', { class: 'kpk-wood-engr' });
    this.device.append(this.devImgA, this.devImgB, this.woodCanvas);
    // nach dem Größenwechsel (Übergang) Platte und Gravur neu setzen
    this.device.addEventListener('transitionend', e => { if (e.target === this.device && (e.propertyName === 'width' || e.propertyName === 'height')) { this.render(); if (this.root.classList.contains('is-classic')) this.renderWood(); } });

    this.tools = h('div', { class: 'kpk-stage-tools' },
      this.btnUndo = h('button', { type: 'button', class: 'kpk-tool', title: 'Rückgängig', 'aria-label': 'Rückgängig', onclick: () => this.app.undo() }, icon('undo')),
      this.btnRedo = h('button', { type: 'button', class: 'kpk-tool', title: 'Wiederholen', 'aria-label': 'Wiederholen', onclick: () => this.app.redo() }, icon('redo')),
      h('span', { class: 'kpk-tool-sep' }),
      this.btnGrid = h('button', { type: 'button', class: 'kpk-tool kpk-tool-txt kpk-tool-toggle', title: 'Raster ein/aus', 'aria-pressed': String(this.grid), onclick: () => this.toggleGrid() }, icon('grid'), h('span', null, 'Raster')),
      this.btnSnap = h('button', { type: 'button', class: 'kpk-tool kpk-tool-txt kpk-tool-toggle', title: 'Einrasten an Mitte und Rändern ein/aus', 'aria-pressed': String(this.snap), onclick: () => this.toggleSnap() }, icon('magnet'), h('span', null, 'Einrasten')),
      h('span', { class: 'kpk-tool-sep' }),
      this.btnPreview = h('button', { type: 'button', class: 'kpk-tool kpk-tool-txt', 'aria-pressed': 'false', onclick: () => this.togglePreview() }, icon('eye'), h('span', null, 'Ansicht'))
    );
    this.badge = h('div', { class: 'kpk-stage-badge' });
    this.warn = h('div', { class: 'kpk-stage-warn', hidden: true });
    this.hint = h('div', { class: 'kpk-stage-hint' }, 'Antippen, ziehen, drehen – alles ist frei beweglich.');
    // Direkt auf der Fläche schreiben (v1.7): Feld erscheint am angetippten Text
    this.editor = h('div', { class: 'kpk-edit', hidden: true },
      this.editTa = h('textarea', { class: 'kpk-edit-ta', rows: 1, 'aria-label': 'Text schreiben', autocomplete: 'off', autocapitalize: 'sentences', spellcheck: 'false', enterkeyhint: 'done' }),
      h('button', { type: 'button', class: 'kpk-edit-ok', title: 'Fertig', 'aria-label': 'Fertig', onclick: () => this.closeEditor() }, icon('check')));

    r.append(this.paper, this.device, this.tools, this.badge, this.warn, this.hint, this.editor);
    this.editTa.addEventListener('input', () => this.onEditInput());
    this.editTa.addEventListener('keydown', e => {
      const el = this.editId && this.app.state.elements.find(x => x.id === this.editId);
      if (e.key === 'Escape' || (e.key === 'Enter' && (e.metaKey || e.ctrlKey || (el && el.arc !== 'none')))) { e.preventDefault(); this.closeEditor(); }
      e.stopPropagation();
    });
    this.editTa.addEventListener('blur', () => setTimeout(() => { if (this.editId && document.activeElement !== this.editTa) this.closeEditor(); }, 150));
    this.editor.addEventListener('pointerdown', e => e.stopPropagation());

    // Zeiger-Interaktion
    this.overlay.addEventListener('pointerdown', e => this.onDown(e));
    this.overlay.addEventListener('pointermove', e => this.onMove(e));
    this.overlay.addEventListener('pointerup', e => this.onUp(e));
    this.overlay.addEventListener('pointercancel', e => this.onUp(e, true));
    this.overlay.addEventListener('dblclick', e => {
      const hit = this.hitTest(...this.toMM(e));
      if (hit && hit.type === 'text') this.openEditor(hit.id);
    });
    this.ctxbar.addEventListener('pointerdown', e => e.stopPropagation());
    this.ctxbar.addEventListener('click', e => {
      const b = e.target.closest('[data-act]');
      if (b) this.app.elementAction(b.dataset.act);
    });
    r.tabIndex = 0;
    r.addEventListener('keydown', e => this.onKey(e));
  }

  resize() {
    const rect = this.paper.getBoundingClientRect();
    this.cw = Math.max(50, rect.width);
    this.ch = Math.max(50, rect.height);
    this.sizeDevice();
    this.canvas.width = Math.round(this.cw * this.dpr);
    this.canvas.height = Math.round(this.ch * this.dpr);
    this.canvas.style.width = this.cw + 'px';
    this.canvas.style.height = this.ch + 'px';
    this.render();
  }

  layout() {
    const plate = modelById(this.app.state.model);
    const narrow = this.cw < 520;
    const padX = narrow ? 26 : 56, padTop = narrow ? 58 : 100, padBot = narrow ? 54 : 80;
    // Gerät (links unten) in Papier-Koordinaten, damit die Platte nicht darunter liegt
    const inset = this.paper.offsetLeft || 18;
    // Holzstempel: Zielgröße statt der gerade animierten Größe (Übergang .5 s)
    const dw = this.devW || this.device.offsetWidth, dh = this.devH || this.device.offsetHeight;
    const dev = dw ? {
      x: this.device.offsetLeft - inset, y: this.device.offsetTop + this.device.offsetHeight - dh - (this.paper.offsetTop || 18),
      w: dw, h: dh
    } : null;
    let k = Math.min((this.cw - padX * 2) / plate.w, (this.ch - padTop - padBot) / plate.h);
    let x, y, w, hh;
    const place = () => {
      w = plate.w * k; hh = plate.h * k;
      x = (this.cw - w) / 2;
      y = padTop + (this.ch - padTop - padBot - hh) / 2;
    };
    const hits = () => dev && x < dev.x + dev.w + 10 && x + w > dev.x - 10 && y < dev.y + dev.h + 10 && y + hh > dev.y - 10;
    for (let i = 0; i < 40; i++) {
      place();
      if (!hits()) break;
      // erst nach rechts, dann nach oben ausweichen, sonst kleiner
      const nx = dev.x + dev.w + 14;
      if (nx + w <= this.cw - 14) { x = nx; if (!hits()) break; }
      place();
      const ny = dev.y - 14 - hh;
      if (ny >= padTop - 20) { y = ny; if (!hits()) break; }
      k *= 0.96;
    }
    k = Math.max(1, k);
    this.k = k;
    this.plateBox = { x, y, w, h: hh };
    return { plate, k, x, y, w, h: hh };
  }

  toMM(e) {
    const rect = this.paper.getBoundingClientRect();
    const plate = modelById(this.app.state.model);
    const px = e.clientX - rect.left - this.plateBox.x;
    const py = e.clientY - rect.top - this.plateBox.y;
    return [px / this.k - plate.w / 2, py / this.k - plate.h / 2];
  }

  mmToPx(x, y) {
    const plate = modelById(this.app.state.model);
    return [this.plateBox.x + (x + plate.w / 2) * this.k, this.plateBox.y + (y + plate.h / 2) * this.k];
  }

  hitTest(mx, my) {
    const els = this.app.state.elements;
    const tol = 1.2 / Math.max(this.k / 12, 0.4); // großzügiger bei kleiner Darstellung
    for (let i = els.length - 1; i >= 0; i--) {
      const el = els[i];
      if (el.type === 'frame' || (el.hidden && !el.phOpen)) continue;
      const b = elementBBox(el);
      const [lx, ly] = toLocal(mx, my, el.x, el.y, el.rot);
      if (lx >= b.x0 - tol && lx <= b.x1 + tol && ly >= b.y0 - tol && ly <= b.y1 + tol) return el;
    }
    return null;
  }

  onDown(e) {
    if (e.button != null && e.button > 0) return;
    const handle = e.target.closest('[data-h]');
    const [mx, my] = this.toMM(e);
    const st = this.app.state;
    let el = null, mode = 'move';
    if (handle && st.selected) { el = st.elements.find(x => x.id === st.selected); mode = handle.dataset.h; }
    else el = this.hitTest(mx, my);
    if (!el) { this.app.select(null); return; }
    const wasSelected = st.selected === el.id;
    e.preventDefault();
    try { this.root.focus({ preventScroll: true }); } catch (err) { /* alt */ }
    this.overlay.setPointerCapture && this.overlay.setPointerCapture(e.pointerId);
    if (st.selected !== el.id) this.app.select(el.id, { fromStage: true });
    const b = elementBBox(el);
    const ref = el.type === 'text' ? { size: el.size, radius: el.radius } : { w: el.w };
    this.drag = {
      id: el.id, mode, sx: mx, sy: my, ox: el.x, oy: el.y, rot: el.rot || 0, ref, wasSelected,
      d0: Math.hypot(mx - el.x, my - el.y) || 1,
      a0: Math.atan2(my - el.y, mx - el.x), moved: false,
      px: e.clientX, py: e.clientY, t0: performance.now(),
      bboxDiag: Math.hypot(b.x1 - b.x0, b.y1 - b.y0)
    };
    this.root.classList.add('is-dragging');
    this.hint.classList.add('is-gone');
  }

  onMove(e) {
    const d = this.drag;
    if (!d) return;
    // kleines Zittern beim Antippen ist noch kein Verschieben
    if (!d.moved && Math.hypot(e.clientX - d.px, e.clientY - d.py) < 4) return;
    const [mx, my] = this.toMM(e);
    const el = this.app.state.elements.find(x => x.id === d.id);
    if (!el) return;
    d.moved = true;
    const plate = modelById(this.app.state.model);
    const g = { cx: false, cy: false, ex: null, ey: null };
    if (d.mode === 'move') {
      let nx = d.ox + (mx - d.sx), ny = d.oy + (my - d.sy);
      // Einrasten an Plattenmitte und Rändern (Sicherheitsabstand); ausgeschaltet zeigen die
      // Linien nur an, wenn es (fast) genau passt – 3 px, mit dem Finger sonst kaum zu treffen
      const tol = this.snap ? Math.max(0.35, 6 / this.k) : 3 / this.k;
      const b = elementBBox(el);
      const pts = [[b.x0, b.y0], [b.x1, b.y0], [b.x1, b.y1], [b.x0, b.y1]].map(([lx, ly]) => fromLocal(lx, ly, nx, ny, el.rot));
      const [bx, by] = fromLocal((b.x0 + b.x1) / 2, (b.y0 + b.y1) / 2, nx, ny, el.rot);
      const minX = Math.min(...pts.map(p => p[0])), maxX = Math.max(...pts.map(p => p[0]));
      const minY = Math.min(...pts.map(p => p[1])), maxY = Math.max(...pts.map(p => p[1]));
      let ex = plate.w / 2 - safeOf(plate), ey = plate.h / 2 - safeOf(plate);
      if (isRound(plate)) {
        // rund: „Rand“ ist dort, wo die äußerste Ecke den Sicherheitskreis berührt
        const R = ex;
        const ay = Math.max(Math.abs(minY), Math.abs(maxY)), ax = Math.max(Math.abs(minX), Math.abs(maxX));
        ex = Math.sqrt(Math.max(0, R * R - ay * ay));
        ey = Math.sqrt(Math.max(0, R * R - ax * ax));
      }
      const put = (dx, dy) => { if (this.snap) { nx -= dx; ny -= dy; } };
      if (Math.abs(bx) < tol) { put(bx, 0); g.cx = true; }
      else if (Math.abs(minX + ex) < tol) { put(minX + ex, 0); g.ex = -ex; }
      else if (Math.abs(maxX - ex) < tol) { put(maxX - ex, 0); g.ex = ex; }
      // rund: nur ein Rand auf einmal (beide zugleich würden die Ecke über den Kreis schieben)
      const yEdge = !(isRound(plate) && g.ex != null);
      if (Math.abs(by) < tol) { put(0, by); g.cy = true; }
      else if (yEdge && Math.abs(minY + ey) < tol) { put(0, minY + ey); g.ey = -ey; }
      else if (yEdge && Math.abs(maxY - ey) < tol) { put(0, maxY - ey); g.ey = ey; }
      const lim = Math.max(plate.w, plate.h);
      el.x = round(clamp(nx, -lim, lim), 3);
      el.y = round(clamp(ny, -lim, lim), 3);
    } else if (d.mode === 'scale') {
      const f = clamp(Math.hypot(mx - el.x, my - el.y) / d.d0, 0.15, 6);
      if (el.type === 'text') {
        el.size = round(clamp(d.ref.size * f, 4, 60), 2);
        if (el.arc !== 'none') el.radius = round(clamp(d.ref.radius * f, 1, 40), 3);
      } else el.w = round(clamp(d.ref.w * f, 1.5, Math.max(plate.w, plate.h) * 1.6), 3);
    } else if (d.mode === 'rotate') {
      let a = rad2deg(Math.atan2(my - el.y, mx - el.x) - d.a0) + d.rot;
      a = ((a % 360) + 540) % 360 - 180;
      for (const s of [-180, -90, 0, 90, 180]) if (Math.abs(a - s) < 4) a = s;
      el.rot = round(a, 1);
    }
    this.showGuides(g);
    this.app.changed({ live: true });
  }

  onUp(e, cancel) {
    const d = this.drag;
    if (!d) return;
    this.drag = null;
    this.root.classList.remove('is-dragging');
    this.showGuides(null);
    if (d.moved) {
      this.app.state.manual = true;         // Platzhalter bleiben Platzhalter, auch verschoben
      this.app.changed({ commit: true });
      this.placeEditor();
    } else if (!cancel && d.mode === 'move' && performance.now() - d.t0 < 700) this.app.tapElement(d.id, { wasSelected: d.wasSelected });
  }

  /* Hilfslinien: Mitte senkrecht/waagrecht und Rand, an der Platte ausgerichtet */
  showGuides(g) {
    const on = (el, v) => el.classList.toggle('is-on', !!v);
    if (!g) { for (const el of [this.guideV, this.guideH, this.guideEV, this.guideEH]) on(el, false); return; }
    const pb = this.plateBox, plate = modelById(this.app.state.model), k = this.k, o = 12;
    const X = mm => (pb.x + (mm + plate.w / 2) * k) + 'px', Y = mm => (pb.y + (mm + plate.h / 2) * k) + 'px';
    const vert = (el, mm) => Object.assign(el.style, { left: X(mm), top: (pb.y - o) + 'px', height: (pb.h + 2 * o) + 'px' });
    const horz = (el, mm) => Object.assign(el.style, { top: Y(mm), left: (pb.x - o) + 'px', width: (pb.w + 2 * o) + 'px' });
    if (g.cx) vert(this.guideV, 0);
    if (g.cy) horz(this.guideH, 0);
    if (g.ex != null) vert(this.guideEV, g.ex);
    if (g.ey != null) horz(this.guideEH, g.ey);
    on(this.guideV, g.cx); on(this.guideH, g.cy); on(this.guideEV, g.ex != null); on(this.guideEH, g.ey != null);
  }
  flashGuides(cx = true, cy = true) {
    this.showGuides({ cx, cy, ex: null, ey: null });
    clearTimeout(this.flashT);
    this.flashT = setTimeout(() => { if (!this.drag) this.showGuides(null); }, 900);
  }

  toggleGrid() {
    this.grid = !this.grid;
    this.btnGrid.setAttribute('aria-pressed', String(this.grid));
    storage.set(TOOLS_KEY, { raster: this.grid, einrasten: this.snap });
    this.render();
  }
  toggleSnap() {
    this.snap = !this.snap;
    this.btnSnap.setAttribute('aria-pressed', String(this.snap));
    storage.set(TOOLS_KEY, { raster: this.grid, einrasten: this.snap });
    this.app.toast(this.snap ? 'Einrasten an – Motiv und Text rasten an Mitte und Rand ein.' : 'Einrasten aus – alles lässt sich frei verschieben.');
  }

  /* feines Raster (1 mm, jede 5 mm kräftiger) und gestrichelte Mittellinien */
  drawGrid(c, x, y, w, hh, k, plate) {
    c.save();
    platePath(c, plate, x, y, w, hh, k);
    c.clip();
    c.lineWidth = 1;
    const fine = k >= 6;
    for (let i = 1; i < plate.w; i++) {
      if (i % 5 && !fine) continue;
      c.strokeStyle = i % 5 ? 'rgba(74,68,68,.07)' : 'rgba(74,68,68,.15)';
      const px = Math.round(x + i * k) + 0.5;
      c.beginPath(); c.moveTo(px, y); c.lineTo(px, y + hh); c.stroke();
    }
    for (let i = 1; i < plate.h; i++) {
      if (i % 5 && !fine) continue;
      c.strokeStyle = i % 5 ? 'rgba(74,68,68,.07)' : 'rgba(74,68,68,.15)';
      const py = Math.round(y + i * k) + 0.5;
      c.beginPath(); c.moveTo(x, py); c.lineTo(x + w, py); c.stroke();
    }
    c.strokeStyle = 'rgba(74,68,68,.24)';
    c.setLineDash([4, 4]);
    const mx = Math.round(x + w / 2) + 0.5, my = Math.round(y + hh / 2) + 0.5;
    c.beginPath(); c.moveTo(mx, y); c.lineTo(mx, y + hh); c.moveTo(x, my); c.lineTo(x + w, my); c.stroke();
    c.restore();
  }

  onKey(e) {
    const st = this.app.state;
    const mod = e.metaKey || e.ctrlKey;
    if (mod && e.key.toLowerCase() === 'z') { e.preventDefault(); e.shiftKey ? this.app.redo() : this.app.undo(); return; }
    if (mod && e.key.toLowerCase() === 'y') { e.preventDefault(); this.app.redo(); return; }
    if (!st.selected) return;
    const el = st.elements.find(x => x.id === st.selected);
    if (!el) return;
    if (e.target && /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
    const step = e.shiftKey ? 1 : 0.2;
    let used = true;
    if (e.key === 'ArrowLeft') el.x = round(el.x - step, 3);
    else if (e.key === 'ArrowRight') el.x = round(el.x + step, 3);
    else if (e.key === 'ArrowUp') el.y = round(el.y - step, 3);
    else if (e.key === 'ArrowDown') el.y = round(el.y + step, 3);
    else if (e.key === 'Delete' || e.key === 'Backspace') { this.app.elementAction('delete'); return; }
    else if (e.key === 'Escape') { this.app.select(null); return; }
    else used = false;
    if (used) { e.preventDefault(); this.app.state.manual = true; this.app.changed({ commit: true }); }
  }

  togglePreview(force) {
    this.preview = force != null ? force : !this.preview;
    this.btnPreview.setAttribute('aria-pressed', String(this.preview));
    this.root.classList.toggle('is-preview', this.preview);
    this.render();
  }

  render() {
    if (!this.cw) return;
    const st = this.app.state;
    const { plate, k, x, y, w, h: hh } = this.layout();
    const c = this.canvas.getContext('2d');
    const dpr = this.dpr;
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.clearRect(0, 0, this.canvas.width, this.canvas.height);
    c.scale(dpr, dpr);

    // Plattenumriss + Lineal
    if (!this.preview) {
      c.save();
      c.strokeStyle = 'rgba(74,68,68,.34)';
      c.lineWidth = 1;
      c.setLineDash([5, 5]);
      platePath(c, plate, x - 0.5, y - 0.5, w + 1, hh + 1, k);
      c.stroke();
      // Holzstempel mit Knauf: Gestaltungsfläche (rundum 1 mm kleiner) fein gepunktet
      if (safeOf(plate) >= 1) {
        const s = safeOf(plate) * k;
        c.strokeStyle = 'rgba(74,68,68,.22)';
        c.setLineDash([1.5, 3.5]);
        platePath(c, plate, x + s, y + s, w - 2 * s, hh - 2 * s, k);
        c.stroke();
      }
      c.setLineDash([]);
      c.fillStyle = 'rgba(74,68,68,.42)';
      c.font = '600 10px "Quattrocento Sans", sans-serif';
      c.textAlign = 'center';
      c.textBaseline = 'top';
      // mm-Striche oben
      for (let i = 0; i <= plate.w; i++) {
        const tx = x + i * k;
        const len = i % 10 === 0 ? 7 : i % 5 === 0 ? 5 : 3;
        if (k < 5 && i % 5) continue;
        c.fillRect(tx - 0.5, y - 10 - len, 1, len);
        if (i % 10 === 0 && k > 3) c.fillText(String(i), tx, y - 30);
      }
      for (let i = 0; i <= plate.h; i++) {
        const ty = y + i * k;
        const len = i % 10 === 0 ? 7 : i % 5 === 0 ? 5 : 3;
        if (k < 5 && i % 5) continue;
        c.fillRect(x - 10 - len, ty - 0.5, len, 1);
      }
      c.restore();
      if (this.grid) this.drawGrid(c, x, y, w, hh, k, plate);
    }

    // Abdruck
    const kk = k * dpr;
    const mask = renderMask({ model: st.model, elements: st.elements }, kk);
    this.lastMask = mask;
    c.save();
    c.setTransform(1, 0, 0, 1, 0, 0);
    const inkId = st.ink === 'ohne' ? 'schwarz' : st.ink;
    composeInk(c, mask, Math.round(x * dpr), Math.round(y * dpr), inkId, { alpha: 0.95 });
    c.restore();

    this.updateOverlay();
    this.updateBadge(plate);
    if (plate.classic) this.woodSoon();
  }

  updateBadge(plate) {
    const st = this.app.state;
    const ink = inkById(st.ink);
    // Farbe in eigenem Teil: am Handy ausgeblendet, damit die Werkzeugleiste Platz hat
    this.badge.replaceChildren(`${plate.label} · ${plate.size}`, h('span', { class: 'kpk-badge-ink' }, st.ink === 'ohne' ? ' · Vorschau in Schwarz' : ' · ' + ink.label));
    this.fitHeader();
  }

  /* Werkzeugleiste und Stempelname teilen sich die obere Zeile. Wird es eng (schmale
     Bühne am Laptop, lange Namen wie „Holzstempel · Ø 40 mm · Celestial Copper“),
     zeigt die Leiste nur Symbole – wie am Tablet – statt den Namen zu überdecken. */
  fitHeader() {
    const key = this.badge.textContent + '|' + Math.round(this.cw || 0) + '|' + this.hint.classList.contains('is-gone');
    if (this.hdrKey === key) return;
    this.hdrKey = key;
    this.root.classList.remove('is-crowded');
    const hintW = this.hint.offsetParent && !this.hint.classList.contains('is-gone') ? this.hint.scrollWidth : 0;
    const need = this.badge.offsetLeft + Math.max(this.badge.scrollWidth, hintW) + 14;
    this.root.classList.toggle('is-crowded', need > this.tools.offsetLeft);
  }

  updateOverlay() {
    const st = this.app.state;
    const el = st.selected ? st.elements.find(x => x.id === st.selected) : null;
    if (!el || el.type === 'frame' || this.preview) { this.sel.hidden = true; this.ctxbar.hidden = true; return; }
    // freier Platz (angetippter Platzhalter): beim Text die Größe des Beispiels zeigen
    const textSlot = el.type === 'text' && el.phOpen && !String(el.text || '').trim();
    const slot = !!el.phOpen && (el.type !== 'text' || textSlot);
    const bel = textSlot ? Object.assign({}, el, { text: el.phWas || 'Text' }) : el;
    const b = elementBBox(bel);
    const pad = 4;
    const wpx = (b.x1 - b.x0) * this.k + pad * 2;
    const hpx = (b.y1 - b.y0) * this.k + pad * 2;
    const [cx, cy] = fromLocal((b.x0 + b.x1) / 2, (b.y0 + b.y1) / 2, el.x, el.y, el.rot);
    const [px, py] = this.mmToPx(cx, cy);
    Object.assign(this.sel.style, {
      width: wpx + 'px', height: hpx + 'px',
      transform: `translate(${px - wpx / 2}px, ${py - hpx / 2}px) rotate(${el.rot || 0}deg)`
    });
    this.sel.hidden = false;
    this.sel.classList.toggle('is-small', Math.min(wpx, hpx) < 44);
    this.sel.classList.toggle('is-slot', slot);
    const kind = el.type === 'text' ? 'text' : 'bild';
    if (slot && this.slotLbl.dataset.kind !== kind) {
      this.slotLbl.dataset.kind = kind;
      this.slotLbl.replaceChildren(icon(kind === 'text' ? 'middle' : 'image'), h('span', null, kind === 'text' ? 'Dein Text' : 'Dein Bild'));
    }
    // Kontextleiste über/unter der Auswahl
    const corners = elementCorners(bel).map(([mx, my]) => this.mmToPx(mx, my));
    const top = Math.min(...corners.map(p => p[1]));
    const bottom = Math.max(...corners.map(p => p[1]));
    const midX = corners.reduce((s, p) => s + p[0], 0) / 4;
    this.ctxbar.hidden = !!this.drag || !!el.phOpen || !!this.editId;
    const barH = 40;
    let by = top - barH - 34;
    if (by < 4) by = bottom + 14;
    const bw = this.ctxbar.offsetWidth || 190;
    const bx = clamp(midX - bw / 2, 6, this.cw - bw - 6);
    this.ctxbar.style.transform = `translate(${bx}px, ${by}px)`;
    if (this.editId) this.placeEditor(corners);
  }

  /* ---------- Direkt schreiben (v1.7) ---------- */
  openEditor(id) {
    const app = this.app, st = app.state;
    const el = st.elements.find(e => e.id === id && e.type === 'text');
    if (!el) return;
    if (this.editId === id) { try { this.editTa.focus({ preventScroll: true }); } catch (e) { /* alt */ } return; }
    if (this.editId) this.closeEditor();
    if (st.selected !== id) app.select(id, { fromStage: true });
    else if (app.panels.step !== 'text') app.panels.go('text', { silent: true });
    if (el.ph) app.openTextPlaceholder(id);          // „Dein Wunschtext“ verschwindet sofort
    this.editId = id;
    const cur = st.elements.find(e => e.id === id);
    this.editTa.value = cur.text;
    this.editTa.placeholder = cur.phWas || 'Dein Text …';
    this.editTa.rows = cur.arc !== 'none' ? 1 : Math.min(4, Math.max(1, cur.text.split('\n').length));
    this.editor.hidden = false;
    this.editor.dataset.pos = '';
    this.root.classList.add('is-editing');
    this.updateOverlay();
    try { this.editTa.focus({ preventScroll: true }); } catch (e) { this.editTa.focus(); }
    const n = this.editTa.value.length;
    try { this.editTa.setSelectionRange(n, n); } catch (e) { /* alt */ }
    app.panels.syncTextValue(id);
  }
  onEditInput() {
    const id = this.editId;
    const el = id && this.app.state.elements.find(e => e.id === id);
    if (!el) return;
    let v = this.editTa.value;
    if (el.arc !== 'none') v = v.replace(/\n/g, ' ');
    this.app.updateEl(id, { text: v }, false, 'typing');
    this.editTa.rows = el.arc !== 'none' ? 1 : Math.min(4, Math.max(1, v.split('\n').length));
    this.app.panels.syncTextValue(id);
  }
  closeEditor() {
    const id = this.editId;
    if (!id) return;
    this.editId = null;
    this.editor.hidden = true;
    this.root.classList.remove('is-editing');
    if (document.activeElement === this.editTa) this.editTa.blur();
    const el = this.app.state.elements.find(e => e.id === id);
    if (el && el.phOpen) this.app.closeTextPlaceholder(id);
    this.app.changed({ commit: true });
    this.app.panels.syncTextValue(id);
    this.updateOverlay();
  }
  /* Feld unter (sonst über) den Text legen, innerhalb der Arbeitsfläche; springt beim Tippen nur,
     wenn der Text es sonst überdecken würde */
  placeEditor(corners) {
    if (!this.editId || this.editor.hidden) return;
    const el = this.app.state.elements.find(e => e.id === this.editId);
    if (!el) return;
    if (!corners) {
      const bel = el.phOpen && !String(el.text || '').trim() ? Object.assign({}, el, { text: el.phWas || 'Text' }) : el;
      corners = elementCorners(bel).map(([mx, my]) => this.mmToPx(mx, my));
    }
    const ox = this.paper.offsetLeft, oy = this.paper.offsetTop;
    const top = Math.min(...corners.map(p => p[1])), bottom = Math.max(...corners.map(p => p[1]));
    const left = Math.min(...corners.map(p => p[0])), right = Math.max(...corners.map(p => p[0]));
    const w = clamp(right - left + 40, Math.min(260, this.cw - 16), this.cw - 16);
    this.editor.style.width = w + 'px';
    const eh = this.editor.offsetHeight || 48;
    const x = clamp((left + right) / 2 - w / 2, 8, this.cw - w - 8);
    const below = bottom + 12, above = top - 12 - eh;
    let pos = this.editor.dataset.pos;
    const fitsBelow = below + eh <= this.ch - 6, fitsAbove = above >= 6;
    if (pos === 'below' && !fitsBelow) pos = '';
    if (pos === 'above' && !fitsAbove) pos = '';
    if (!pos) pos = fitsBelow ? 'below' : fitsAbove ? 'above' : 'inside';
    this.editor.dataset.pos = pos;
    const y = pos === 'below' ? below : pos === 'above' ? above : clamp(bottom - eh, 6, this.ch - eh - 6);
    this.editor.style.transform = `translate(${Math.round(ox + x)}px, ${Math.round(oy + y)}px)`;
  }

  setDevice(model, housing, animate = true) {
    const m = modelById(model);
    this.root.classList.toggle('is-wood', !!m.wood);
    this.root.classList.toggle('is-knob', !!m.knob);
    this.root.classList.toggle('is-classic', !!m.classic);
    this.device.dataset.model = m.id;
    this.device.dataset.shape = m.shape;
    this.sizeDevice(m);
    requestAnimationFrame(() => { this.render(); if (m.classic) this.renderWood(); });
    const src = this.app.asset(m.img(housing));
    const on = this.devImgA.classList.contains('is-on') ? this.devImgA : this.devImgB;
    const off = on === this.devImgA ? this.devImgB : this.devImgA;
    if (on.getAttribute('src') === src) return;
    if (!animate || prefersReducedMotion() || !on.getAttribute('src')) { on.src = src; return; }
    off.onload = () => { off.classList.add('is-on'); on.classList.remove('is-on'); this.render(); };
    off.src = src;
  }

  /* Holzstempel: Bildgröße nach echten Millimetern, alle Größen im selben Maßstab – so sieht man
     beim Umschalten, wie groß der Stempel wirklich ist. Maßstab so, dass der größte (70 × 70 mit
     Griff, ca. 96 mm hoch) in 36 % der Höhe bzw. 30 % der Breite passt. Der Klassiker ohne Griff
     ist viel kleiner; er wird 1,6-fach gezeigt, damit die Gravur oben lesbar bleibt. */
  sizeDevice(m = modelById(this.app.state.model)) {
    const r = m.wood && HOLZ_RENDER[m.id];
    if (!r) { this.device.style.width = ''; this.device.style.height = ''; this.devW = this.devH = 0; return; }
    const cw = this.cw || 600, ch = this.ch || 560;
    const s = Math.min(ch * 0.36 / 96, cw * 0.30 / 96) * (m.classic ? 1.6 : 1);
    this.devW = Math.round(r.w / r.mm * s);
    this.devH = Math.round(r.h / r.mm * s);
    this.device.style.width = this.devW + 'px';
    this.device.style.height = this.devH + 'px';
    if (m.classic) this.woodSoon && this.woodSoon();
  }

  /* Klassiker: Entwurf als Brandgravur auf die Oberseite des Holzblocks (Parallelogramm aus dem
     Render, orthografisch → reine Affin-Abbildung), darunter klein die Signatur */
  renderWood() {
    const st = this.app.state;
    const m = modelById(st.model);
    const cv = this.woodCanvas;
    const r = HOLZ_RENDER[m.id];
    if (!m.classic || !r || !r.top) { cv.width = cv.height = 0; return; }
    const W = this.devW || this.device.clientWidth, H = this.devH || this.device.clientHeight;
    if (!W || !H) return;
    const dpr = this.dpr;
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    const c = cv.getContext('2d');
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.clearRect(0, 0, cv.width, cv.height);
    const f = (W * dpr) / r.w;                         // Render-Pixel → Leinwand-Pixel
    const [p0, p1, , p3] = r.top.map(([x, y]) => [x * f, y * f]);
    // Oberseite (27 × 27 mm innen) in Einheiten 0..1: Entwurf mittig auf 80 %, Signatur darunter
    const face = (u, v) => [p0[0] + u * (p1[0] - p0[0]) + v * (p3[0] - p0[0]), p0[1] + u * (p1[1] - p0[1]) + v * (p3[1] - p0[1])];
    const side = Math.hypot(p1[0] - p0[0], p1[1] - p0[1]);
    const k = Math.max(2, (side * 0.8) / m.w);          // Maske in etwa Zielauflösung
    const mask = renderMask({ model: st.model, elements: st.elements }, k);
    const col = canvas(mask.width, mask.height);
    const cc = col.getContext('2d');
    cc.fillStyle = '#6e3f14';
    cc.fillRect(0, 0, col.width, col.height);
    cc.globalCompositeOperation = 'destination-in';
    cc.drawImage(mask, 0, 0);
    const u0 = 0.1, v0 = 0.05, span = 0.8;
    const [ox, oy] = face(u0, v0);
    const a = (p1[0] - p0[0]) * span / mask.width, b = (p1[1] - p0[1]) * span / mask.width;
    const cx = (p3[0] - p0[0]) * span / mask.height, cy = (p3[1] - p0[1]) * span / mask.height;
    c.setTransform(a, b, cx, cy, ox + 0.7 * dpr, oy + 0.9 * dpr);   // leichte Tiefe der Gravur
    c.globalAlpha = 0.28;
    c.drawImage(col, 0, 0);
    c.setTransform(a, b, cx, cy, ox, oy);
    c.globalAlpha = 0.86;
    c.drawImage(col, 0, 0);
    // Signatur
    const [sx, sy] = face(0.5, 0.93);
    const ux = (p1[0] - p0[0]), uy = (p1[1] - p0[1]), vx = (p3[0] - p0[0]), vy = (p3[1] - p0[1]);
    c.setTransform(ux / 100, uy / 100, vx / 100, vy / 100, sx, sy);
    c.globalAlpha = 0.72;
    c.fillStyle = '#6e3f14';
    c.font = '700 5.6px "League Spartan", sans-serif';
    c.textAlign = 'center';
    c.textBaseline = 'middle';
    c.fillText('kreativpünktchen', 0, 0);
    c.globalAlpha = 1;
  }

  setWarnings(list) {
    if (!list.length) { this.warn.hidden = true; return; }
    this.warn.hidden = false;
    this.warn.textContent = list[0].short || list[0].text;
  }
}

/* Kleine Symbolbibliothek (Linien-Icons im Stil der Seite) */
function icon(name) {
  const P = {
    rotate: '<path d="M20 12a8 8 0 1 1-2.34-5.66"/><path d="M20 4v5h-5"/>',
    undo: '<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>',
    redo: '<path d="m15 14 5-5-5-5"/><path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13"/>',
    eye: '<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/>',
    ruler: '<rect x="2" y="7" width="20" height="10" rx="2"/><path d="M6 7v4M10 7v3M14 7v4M18 7v3"/>',
    grid: '<rect x="3.5" y="3.5" width="17" height="17" rx="2.5"/><path d="M9.2 3.5v17M14.8 3.5v17M3.5 9.2h17M3.5 14.8h17"/>',
    magnet: '<path d="M6 4h3.5v7.5a2.5 2.5 0 0 0 5 0V4H18v7.5a6 6 0 0 1-12 0Z"/><path d="M6 8h3.5M14.5 8H18"/>',
    center: '<path d="M12 3v18M3 12h18"/><rect x="7" y="7" width="10" height="10" rx="2"/>',
    copy: '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>',
    front: '<rect x="3" y="3" width="12" height="12" rx="2"/><path d="M9 21h10a2 2 0 0 0 2-2V9"/>',
    trash: '<path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/>',
    stamp: '<path d="M9 13V9.5a3 3 0 1 1 6 0V13"/><path d="M5 13h14v4H5z"/><path d="M4 21h16"/>',
    upload: '<path d="M12 16V4M7 9l5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    check: '<path d="m5 12 5 5 9-10"/>',
    chevronLeft: '<path d="m14.5 5.5-6.5 6.5 6.5 6.5"/>',
    help: '<circle cx="12" cy="12" r="9"/><path d="M9.6 9.4a2.5 2.5 0 1 1 3.4 2.4c-.6.3-1 .8-1 1.5v.4"/><path d="M12 17v.2"/>',
    image: '<rect x="3" y="4" width="18" height="16" rx="3"/><circle cx="9" cy="10" r="2"/><path d="m20 16-4.5-4.5L7 20"/>',
    left: '<path d="M4 6h16M4 12h10M4 18h14"/>',
    middle: '<path d="M4 6h16M7 12h10M5 18h14"/>',
    right: '<path d="M4 6h16M10 12h10M6 18h14"/>',
    arcUp: '<path d="M4 16a8 8 0 0 1 16 0"/>',
    arcDown: '<path d="M4 8a8 8 0 0 0 16 0"/>',
    straight: '<path d="M4 12h16"/>',
    search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
    close: '<path d="M6 6l12 12M18 6 6 18"/>',
    flip: '<path d="M12 3v18"/><path d="M8 7 4 12l4 5V7ZM16 7l4 5-4 5V7Z"/>',
    truck: '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>',
    shield: '<path d="M12 3 5 6v6c0 4.4 3 7.4 7 9 4-1.6 7-4.6 7-9V6l-7-3Z"/><path d="m9 12 2 2 4-4"/>',
    heart: '<path d="M12 20s-7-4.4-9-9.2C1.7 7.5 4 4 7.4 4c2 0 3.3 1 4.6 2.6C13.3 5 14.6 4 16.6 4 20 4 22.3 7.5 21 10.8 19 15.6 12 20 12 20Z"/>',
    sparkle: '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18"/>'
  };
  const s = document.createElement('span');
  s.className = 'kpk-ic';
  s.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${P[name] || ''}</svg>`;
  return s;
}

/* ---- js/50-panels.js ---- */
/* ---------------------------------------------------------------------------
   Seitenleiste: Schritte Stempel & Farbe · Design · Vorlage · Text · Fertig
   (25.09.2026: Design – vorher „Motiv“ – kommt jetzt vor der Vorlage)
   --------------------------------------------------------------------------- */

const STEPS = [
  { id: 'stempel', label: 'Stempel & Farbe', short: 'Stempel' },
  { id: 'motiv', label: 'Design' },
  { id: 'vorlage', label: 'Vorlage' },
  { id: 'text', label: 'Text' },
  { id: 'fertig', label: 'Fertig' }
];

/* Marken-Zeichen wie das Favicon (Wunsch 25.09. abends): das „k“ aus dem Logo, oben rechts die zwei
   roten Punkte. Umriss aus dem Logo nachgezeichnet, Lage der Punkte nach dem Favicon. */
function brandMark() {
  const s = svgEl('svg', { class: 'kpk-mark', viewBox: '3 0.6 28 28.3', 'aria-hidden': 'true', focusable: 'false' });
  s.append(
    svgEl('path', { class: 'kpk-mark-k', d: 'M3.6 3.5H8.62V18.37L14.06 13.64H20.32L13.64 20.65L20.91 28.4H14.78L8.62 22.86V28.4H3.6Z' }),
    svgEl('circle', { class: 'kpk-mark-dot', cx: '23.45', cy: '6.5', r: '2.55' }),
    svgEl('circle', { class: 'kpk-mark-dot', cx: '28', cy: '3.65', r: '2.55' }));
  return s;
}

class Panels {
  constructor(app, root) {
    this.app = app;
    this.root = root;
    this.step = 'stempel';
    this.motifFilter = '';
    this.build();
  }

  build() {
    const app = this.app;
    const cfg = app.cfg;
    this.head = h('header', { class: 'kpk-head' },
      h('div', { class: 'kpk-eyebrow' }, brandMark(), 'Stempel-Werkstatt'),
      h('h1', { class: 'kpk-title' }, cfg.title || 'Stempel selbst gestalten'),
      h('p', { class: 'kpk-lead' }, cfg.lead || 'Motiv, Text und Farbe – live gestaltet und von Hand gefertigt im Vogtland.'),
      h('div', { class: 'kpk-head-meta' },
        cfg.rating ? h('div', { class: 'kpk-rating' }, h('span', { class: 'kpk-stars', 'aria-hidden': 'true' }, '★★★★★'), h('span', null, cfg.rating)) : null,
        h('button', { type: 'button', class: 'kpk-help', onclick: () => app.tour && app.tour.start(0) }, icon('help'), 'So funktioniert’s'))
    );
    this.nav = h('nav', { class: 'kpk-steps', role: 'tablist', 'aria-label': 'Schritte' },
      STEPS.map((s, i) => h('button', {
        type: 'button', role: 'tab', class: 'kpk-step', 'data-step': s.id, 'aria-selected': 'false',
        onclick: () => this.go(s.id)
      }, h('span', { class: 'kpk-step-n' }, String(i + 1)), h('span', { class: 'kpk-step-l' }, s.label)))
    );
    this.body = h('div', { class: 'kpk-panels' });
    this.panels = {};
    for (const s of STEPS) {
      const p = h('section', { class: 'kpk-panel', role: 'tabpanel', 'data-step': s.id, hidden: true });
      this.panels[s.id] = p;
      this.body.appendChild(p);
    }
    this.priceEl = h('div', { class: 'kpk-price' });
    this.delivEl = h('div', { class: 'kpk-deliv' }, icon('truck'), h('span', null, cfg.delivery || 'Wird für dich angefertigt – Lieferung in 2–5 Werktagen (DE)'));
    this.cta = h('button', { type: 'button', class: 'kpk-cta', onclick: () => this.next() });
    this.back = h('button', { type: 'button', class: 'kpk-back', 'aria-label': 'Zurück', onclick: () => this.prev() }, icon('chevronLeft'));
    this.buy = h('footer', { class: 'kpk-buy' },
      h('div', { class: 'kpk-buy-info' }, this.priceEl, this.delivEl),
      h('div', { class: 'kpk-buy-actions' }, this.back, this.cta));
    this.root.append(this.head, this.nav, this.body, this.buy);
    this.go('stempel', { silent: true });
  }

  go(step, opts = {}) {
    if (step !== 'motiv' && this.app.closePlaceholders && this.app.closePlaceholders('image') && this.app.stage) this.app.stage.renderSoon();
    this.step = step;
    for (const b of $$('.kpk-step', this.nav)) {
      const on = b.dataset.step === step;
      b.setAttribute('aria-selected', String(on));
      b.classList.toggle('is-on', on);
      const idx = STEPS.findIndex(s => s.id === b.dataset.step);
      const cur = STEPS.findIndex(s => s.id === step);
      b.classList.toggle('is-done', idx < cur);
    }
    for (const [id, p] of Object.entries(this.panels)) p.hidden = id !== step;
    this.render(step);
    this.updateBuy();
    const active = $(`.kpk-step[data-step="${step}"]`, this.nav);
    if (active && active.scrollIntoView && !opts.silent) {
      try { active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) { /* alt */ }
    }
    this.app.onStep(step);
    if (!opts.silent) this.reveal(step);
  }

  /* Ein neuer Schritt beginnt oben: sein Anfang (Überschrift, beim Design „Eigenes Bild hochladen“)
     soll direkt unter der Schrittleiste stehen. Liegt er verdeckt darüber (man war im vorigen Schritt
     weit unten) oder zu weit unten, wird dorthin gescrollt. Die Schrittleiste klebt (am Handy unter der
     Arbeitsfläche), deshalb zählt ihre klebende Position, nicht die aktuelle (Wunsch 25.09.). */
  reveal(step) {
    const p = this.panels[step];
    if (!p) return;
    const cs = getComputedStyle(this.nav);
    const stuck = cs.position === 'sticky' ? (parseFloat(cs.top) || 0) : 0;
    const want = stuck + this.nav.offsetHeight + 12;
    const top = p.getBoundingClientRect().top;
    if (top >= want - 1 && top <= window.innerHeight * 0.75) return;
    // Kopfzeile des Shops beim Hochscrollen nicht einblenden (Dawn/Craft: sticky-header)
    const sh = document.querySelector('sticky-header');
    if (sh && top < want) sh.dispatchEvent(new Event('preventHeaderReveal'));
    const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, window.scrollY + top - want), behavior: calm ? 'auto' : 'smooth' });
  }

  /* Füllt ein fertiges Design die ganze Fläche, gibt es keine Vorlage zu wählen:
     „Weiter“ und „Zurück“ springen dann über diesen Schritt (anklickbar bleibt er). */
  skips(id) {
    const st = this.app.state;
    return id === 'vorlage' && st.template === 'design' && st.elements.some(e => e.type === 'image');
  }
  neighbor(dir) {
    let i = STEPS.findIndex(s => s.id === this.step) + dir;
    while (i > 0 && i < STEPS.length - 1 && this.skips(STEPS[i].id)) i += dir;
    return STEPS[Math.max(0, Math.min(STEPS.length - 1, i))];
  }
  next() {
    if (this.step === 'fertig') { this.app.addToCart(); return; }
    this.go(this.neighbor(1).id);
  }
  prev() {
    if (STEPS.findIndex(s => s.id === this.step) > 0) this.go(this.neighbor(-1).id);
  }

  render(step = this.step) {
    const p = this.panels[step];
    if (!p) return;
    const fn = this['render_' + step];
    p.replaceChildren();
    if (fn) fn.call(this, p);
    p.classList.remove('is-in');
    void p.offsetWidth;
    p.classList.add('is-in');
  }

  refresh(what) {
    // leichte Aktualisierung ohne Neuaufbau, wo möglich
    if (this.step === 'vorlage') this.drawTemplatePreviews();
    if (this.step === 'fertig') this.render('fertig');
    if (this.step === 'text' && what !== 'typing') this.syncTextControls();
    if (this.step === 'motiv') this.syncMotifControls();
    this.updateBuy();
  }

  updateBuy() {
    const app = this.app;
    const v = app.variant();
    const qty = app.state.qty || 1;
    this.priceEl.replaceChildren(
      h('span', { class: 'kpk-price-v' }, v ? formatPrice(v.price * qty, app.cfg.currency) : '–'),
      h('small', null, 'inkl. MwSt., zzgl. Versand')
    );
    const last = this.step === 'fertig';
    const i = STEPS.findIndex(s => s.id === this.step);
    const nx = this.neighbor(1);
    this.cta.textContent = last ? 'In den Warenkorb' : `Weiter: ${nx.short || nx.label}`;
    this.cta.classList.toggle('is-final', last);
    const ok = app.canOrder();
    this.cta.disabled = last && !ok.ok;
    this.back.hidden = i === 0;
    this.cta.title = last && !ok.ok ? ok.reason : '';
  }

  /* ---------------- 1 · Stempel & Farbe ---------------- */
  render_stempel(p) {
    const app = this.app, st = app.state;
    const cur = modelById(st.model);
    p.append(h('h2', { class: 'kpk-h2' }, 'Welcher Stempel soll es sein?'));
    const row = h('div', { class: 'kpk-models' });
    const seen = new Set();
    for (const m of MODELS) {
      // Holzstempel: eine Kachel für alle Größen, die Größe wählt man darunter
      if (m.group && seen.has(m.group)) continue;
      if (m.group) seen.add(m.group);
      const members = m.group ? groupModels(m.group) : [m];
      const on = members.some(x => x.id === st.model);
      const hs = on ? st.housing : m.housings[0];
      const prices = members.map(x => app.variants.minPrice(x.id)).filter(v => v != null);
      const minP = prices.length ? Math.min(...prices) : null;
      const from = m.inks.includes('ohne') || members.length > 1;
      const sizeTxt = members.length > 1 ? (on ? cur.size : `${members.length} Größen`) : m.size;
      // Holz ohne Auswahl: ein fertiges Bild mit beiden Arten nebeneinander (v1.8 – vorher zwei
      // übereinandergelegte Bilder, die im Shop unruhig wirkten)
      const media = m.wood
        ? h('img', { class: 'kpk-model-render', src: app.asset(on ? cur.img() : 'holz-paar.webp'), alt: '', loading: 'lazy' })
        : h('img', { src: app.asset(m.img(hs)), alt: '', loading: 'lazy' });
      row.append(h('button', {
        type: 'button', class: 'kpk-model' + (on ? ' is-on' : ''), 'aria-pressed': String(on),
        'aria-label': `${m.label}, ${m.kind}, ${sizeTxt}`,
        onclick: () => { if (!on) app.setModel(m.group ? (app.lastOf(m.group) || m.id) : m.id); this.render('stempel'); }
      },
        h('span', { class: 'kpk-model-media' }, media),
        h('span', { class: 'kpk-model-name' }, m.label),
        h('span', { class: 'kpk-model-size' }, sizeTxt),
        h('span', { class: 'kpk-model-price' }, minP != null ? (from ? 'ab ' : '') + formatPrice(minP, app.cfg.currency) : ''),
        h('span', { class: 'kpk-check', 'aria-hidden': 'true' }, icon('check'))
      ));
    }
    p.append(row);
    p.append(h('p', { class: 'kpk-model-info' }, h('strong', null, `${cur.label} · ${cur.kind} · ${cur.size}`), h('span', null, cur.hint)));
    if (cur.group) p.append(this.sizePicker(cur));
    this.renderColors(p);
    p.append(this.designShortcut());
    p.append(h('p', { class: 'kpk-note' }, 'Beim Wechsel bleibt dein Entwurf erhalten – wir ordnen ihn automatisch neu an.'));
  }

  /* Größen des Holzstempels, sortiert nach Griff (Wunsch 25.09.): „Ohne Griff“ = Klassiker 29 × 29,
     „Mit Griff“ = die Logostempel-Größen (quadratisch, rund, rechteckig). Preise ohne Kissen. */
  sizePicker(cur) {
    const app = this.app;
    const members = groupModels(cur.group);
    const box = h('div', { class: 'kpk-sizes' });
    box.append(h('div', { class: 'kpk-row-head' }, h('h3', { class: 'kpk-h3' }, 'Größe'),
      h('span', { class: 'kpk-count' }, `${cur.size} · ${cur.knob ? 'mit Griff' : 'ohne Griff'}`)));
    const chip = m => {
      const on = m.id === cur.id;
      const pr = app.variants.minPrice(m.id);
      return h('button', {
        type: 'button', class: 'kpk-size' + (on ? ' is-on' : ''), 'aria-pressed': String(on), 'data-model': m.id,
        disabled: pr == null ? true : null,
        'aria-label': `${m.size}, ${m.knob ? 'mit Griff' : 'ohne Griff'}${pr != null ? ', ab ' + formatPrice(pr, app.cfg.currency) : ''}`,
        onclick: () => { app.setModel(m.id); this.render('stempel'); }
      },
        h('span', { class: 'kpk-size-ic', 'data-shape': m.shape, style: { '--ar': String(round(m.w / m.h, 3)) }, 'aria-hidden': 'true' }),
        h('span', { class: 'kpk-size-l' }, m.short || m.size, m.classic ? h('small', null, 'Klassiker') : null),
        h('span', { class: 'kpk-size-p' }, pr != null ? formatPrice(pr, app.cfg.currency) : '–'));
    };
    const groups = [
      { t: 'Ohne Griff', sub: 'Holzblock, dein Motiv oben eingraviert', img: 'holz29.webp', list: members.filter(m => !m.knob) },
      { t: 'Mit Griff', sub: 'Griff aus Buche, roter Punkt vorn', img: 'holz-r40.webp', list: members.filter(m => m.knob) }
    ];
    for (const g of groups) {
      if (!g.list.length) continue;
      const on = g.list.some(m => m.id === cur.id);
      const sec = h('div', { class: 'kpk-size-group' + (on ? ' is-on' : '') },
        h('div', { class: 'kpk-size-group-h' },
          h('span', { class: 'kpk-size-group-img', 'aria-hidden': 'true' }, h('img', { src: app.asset(g.img), alt: '', loading: 'lazy' })),
          h('span', { class: 'kpk-size-group-t' }, h('strong', null, g.t), h('small', null, g.sub))));
      const rows = [['Quadratisch', 'square'], ['Rund', 'round'], ['Rechteckig', 'rect']];
      if (g.list.length === 1) sec.append(h('div', { class: 'kpk-size-list' }, g.list.map(chip)));
      else for (const [t, shape] of rows) {
        const list = g.list.filter(m => m.shape === shape);
        if (list.length) sec.append(h('div', { class: 'kpk-size-row' }, h('span', { class: 'kpk-size-t' }, t), h('div', { class: 'kpk-size-list' }, list.map(chip))));
      }
      box.append(sec);
    }
    box.append(h('p', { class: 'kpk-note' }, cur.knob
      ? 'Preise ohne Stempelkissen. Die Maße sind die Stempelplatte – dein Motiv bleibt rundum 1 mm vom Rand weg (fein gepunktet auf der Fläche).'
      : 'Preise ohne Stempelkissen.'));
    return box;
  }

  /* Gehäuse- und Stempelfarbe (Selbstfärber) bzw. Stempelkissen (Holzstempel) */
  renderColors(p) {
    const app = this.app, st = app.state;
    const m = modelById(st.model);
    const box = h('div', { class: 'kpk-colors' });
    if (m.knob) {
      // Kissen wie beim Logostempel: ohne · schwarz / schwarz Textil · VersaFine Clair · Delicata metallic
      const price = id => { const v = app.variants.get(m.id, 'buche', id); return v ? formatPrice(v.price, app.cfg.currency) : ''; };
      const groups = [
        { t: 'Ohne Stempelkissen', ids: ['ohne'], p: price('ohne') },
        { t: 'Stempelkissen schwarz', ids: ['schwarz', 'schwarz-textil'], p: `${price('schwarz')} · Textil ${price('schwarz-textil')}` },
        { t: 'VersaFine Clair', ids: CLAIR_INKS, p: price(CLAIR_INKS[0]) },
        { t: 'Delicata metallic', ids: DELICATA_INKS, p: price(DELICATA_INKS[0]) }
      ];
      for (const g of groups) {
        const r = h('div', { class: 'kpk-inks' });
        for (const id of g.ids) r.append(this.inkButton(id, m, 'buche'));
        box.append(h('div', { class: 'kpk-row-head' }, h('h3', { class: 'kpk-h3' }, g.t), h('span', { class: 'kpk-count' }, g.p)), r);
      }
      const ink = INKS[st.ink] || {};
      const note = st.ink === 'ohne' ? 'Die Vorschau zeigt den Abdruck in Schwarz.'
        : st.ink === 'schwarz-textil' ? 'Textil-Stempelkissen: zum Stempeln auf Stoff.'
        : ink.light ? 'White Shimmer schimmert hell – am schönsten auf dunklem oder farbigem Papier.'
        : ink.metallic ? 'Metallic-Farben glänzen – die Vorschau zeigt das nur angedeutet.' : '';
      if (note) box.append(h('p', { class: 'kpk-note' }, note));
    } else if (!m.wood) {
      const sw = h('div', { class: 'kpk-swatches' });
      for (const hs of m.housings) {
        const v = app.variants.get(m.id, hs, st.ink);
        sw.append(h('button', {
          type: 'button', class: 'kpk-swatch' + (hs === st.housing ? ' is-on' : ''), disabled: v && !v.available ? true : null,
          'aria-pressed': String(hs === st.housing), title: HOUSINGS[hs].label,
          onclick: () => { app.setHousing(hs); this.render('stempel'); }
        }, h('span', { class: 'kpk-swatch-dot', style: { background: HOUSINGS[hs].swatch } }), h('span', { class: 'kpk-swatch-l' }, HOUSINGS[hs].label.replace('pastell ', ''))));
      }
      box.append(h('div', { class: 'kpk-row-head' }, h('h3', { class: 'kpk-h3' }, 'Gehäusefarbe'), h('span', { class: 'kpk-count' }, HOUSINGS[st.housing].label)), sw);
      const pads = h('div', { class: 'kpk-inks' });
      for (const id of m.inks) pads.append(this.inkButton(id, m, st.housing));
      box.append(h('div', { class: 'kpk-row-head' }, h('h3', { class: 'kpk-h3' }, 'Stempelfarbe'), h('span', { class: 'kpk-count' }, 'Kissen ist schon eingesetzt')), pads);
    } else {
      const groups = [
        { t: 'Ohne Stempelkissen', ids: ['ohne'] },
        { t: 'Mit Stempelkissen', ids: ['schwarz', 'blau', 'gruen', 'rot', 'violett'] },
        { t: 'Mit dreifarbigem Stempelkissen', ids: ['schwarz-pink-gruen', 'schwarz-blau-rot'] }
      ];
      for (const g of groups) {
        const v0 = app.variants.get(m.id, 'buche', g.ids[0]);
        const r = h('div', { class: 'kpk-inks' });
        for (const id of g.ids) r.append(this.inkButton(id, m, 'buche'));
        box.append(h('div', { class: 'kpk-row-head' }, h('h3', { class: 'kpk-h3' }, g.t), h('span', { class: 'kpk-count' }, v0 ? formatPrice(v0.price, app.cfg.currency) : '')), r);
      }
      if (st.ink === 'ohne') box.append(h('p', { class: 'kpk-note' }, 'Die Vorschau zeigt den Abdruck in Schwarz.'));
    }
    p.append(box);
  }

  inkButton(id, m, hs) {
    const app = this.app, st = app.state;
    const ink = INKS[id];
    const v = app.variants.get(m.id, hs, id);
    return h('button', {
      type: 'button', class: 'kpk-ink' + (id === st.ink ? ' is-on' : ''), disabled: v && !v.available ? true : null,
      'aria-pressed': String(id === st.ink), onclick: () => { app.setInk(id); this.render(this.step); }
    }, padSwatch(ink), h('span', null, ink.none ? 'ohne' : ink.label));
  }

  /* Abkürzung: fertiges Design hochladen, Vorlage überspringen */
  designShortcut(inTemplates) {
    const app = this.app, st = app.state;
    const on = st.template === 'design' && st.elements.some(e => e.type === 'image');
    const card = h('button', { type: 'button', class: 'kpk-shortcut' + (inTemplates ? ' is-top' : '') + (on ? ' is-on' : ''), onclick: () => openUploadChooser(app, { mode: 'design' }) },
      h('span', { class: 'kpk-shortcut-ic' }, icon('image')),
      h('span', { class: 'kpk-shortcut-t' },
        h('strong', null, inTemplates ? 'Eigenes Design statt Vorlage' : 'Schon ein fertiges Design oder Logo?'),
        h('span', null, inTemplates ? 'Dein Bild oder Logo füllt die ganze Stempelfläche.' : 'Lade es hoch – es füllt die Stempelfläche, die Vorlage überspringst du.')),
      h('span', { class: 'kpk-shortcut-go' }, on ? 'Neu hochladen' : 'Hochladen'));
    card.addEventListener('dragover', e => { e.preventDefault(); card.classList.add('is-over'); });
    card.addEventListener('dragleave', () => card.classList.remove('is-over'));
    card.addEventListener('drop', e => {
      e.preventDefault(); card.classList.remove('is-over');
      const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) app.openUpload(f, { mode: 'design' });
    });
    return card;
  }

  /* ---------------- 3 · Vorlage ---------------- */
  render_vorlage(p) {
    const app = this.app, st = app.state;
    const model = modelById(st.model);
    p.append(h('h2', { class: 'kpk-h2' }, 'Wähle eine Anordnung'),
      h('p', { class: 'kpk-sub' }, 'Mit deinem Motiv und deinem Text – alles lässt sich danach frei verschieben.'));
    // Eigenes, fertiges Design: ohne Vorlage
    p.append(this.designShortcut(true));
    const grid = h('div', { class: 'kpk-tpls', 'data-shape': model.shape });
    this.tplCanvases = [];
    for (const t of templatesFor(model)) {
      const cv = h('canvas', { class: 'kpk-tpl-cv' });
      this.tplCanvases.push({ cv, t });
      grid.append(h('button', {
        type: 'button', class: 'kpk-tpl' + (st.template === t.id ? ' is-on' : ''), 'aria-pressed': String(st.template === t.id),
        onclick: () => { app.useTemplate(t.id); this.render('vorlage'); }
      }, h('span', { class: 'kpk-tpl-media', 'data-shape': model.shape }, cv), h('span', { class: 'kpk-tpl-l' }, t.label),
      h('span', { class: 'kpk-check', 'aria-hidden': 'true' }, icon('check'))));
    }
    p.append(grid);
    requestAnimationFrame(() => this.drawTemplatePreviews());
  }

  drawTemplatePreviews() {
    if (!this.tplCanvases) return;
    const app = this.app, st = app.state;
    const model = modelById(st.model);
    const content = extractContent(st);
    for (const { cv, t } of this.tplCanvases) {
      if (!cv.isConnected) continue;
      const box = cv.parentElement.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const W = Math.max(60, box.width), H = Math.max(40, box.height);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      const d = { model: st.model, elements: [] };
      const c2 = JSON.parse(JSON.stringify(content));
      if (!c2.pic && (t.needs === 'mt' || t.needs === 'm')) c2.pic = newMotif(PH_MOTIF, { ph: true });
      if (c2.pic && c2.pic.type === 'image') c2.pic.id = content.pic.id; // gleiche Bildquelle
      applyTemplate(d, t.id, c2);
      const k = Math.min((W * 0.82) / model.w, (H * 0.8) / model.h) * dpr;
      const mask = renderMask(d, k);
      const ctx = cv.getContext('2d');
      ctx.clearRect(0, 0, cv.width, cv.height);
      composeInk(ctx, mask, (cv.width - mask.width) / 2, (cv.height - mask.height) / 2, st.ink === 'ohne' ? 'schwarz' : st.ink, { texture: false, alpha: 1, blend: 'source-over' });
    }
  }

  /* ---------------- 2 · Design (Motiv oder eigenes Bild) ---------------- */
  render_motiv(p) {
    const app = this.app, st = app.state;
    p.append(h('h2', { class: 'kpk-h2' }, 'Motiv oder eigenes Bild'));
    if (st.template === 'design' && st.elements.some(e => e.type === 'image')) {
      p.append(h('div', { class: 'kpk-ok kpk-design-ok' }, icon('check'), h('span', null,
        h('strong', null, 'Dein Design füllt die Stempelfläche. '),
        'Größe und Lage kannst du hier oder direkt auf der Fläche anpassen. Text brauchst du nicht? Dann weiter zu „Fertig“.')));
    }
    // Hochladen: die Karte öffnet das Hochladen-Fenster, dort stehen auch die Beispiele
    // „Was sich gut stempeln lässt“ (Wunsch 25.09.). Ziehen und Ablegen geht direkt.
    const drop = h('button', { type: 'button', class: 'kpk-drop', onclick: () => openUploadChooser(app) },
      h('span', { class: 'kpk-drop-ic' }, icon('upload')),
      h('span', { class: 'kpk-drop-t' }, h('strong', null, 'Eigenes Bild hochladen'), h('span', null, 'Logo, Zeichnung oder Foto · JPG, PNG, SVG')));
    drop.addEventListener('dragover', e => { e.preventDefault(); drop.classList.add('is-over'); });
    drop.addEventListener('dragleave', () => drop.classList.remove('is-over'));
    drop.addEventListener('drop', e => {
      e.preventDefault(); drop.classList.remove('is-over');
      const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) app.openUpload(f);
    });
    p.append(h('div', { class: 'kpk-up-area' }, drop));

    // aktives Motiv/Bild: Regler
    this.motifCtl = h('div', { class: 'kpk-ctl-block' });
    p.append(this.motifCtl);
    this.syncMotifControls();

    // Motivliste
    const search = h('input', { type: 'search', class: 'kpk-search', placeholder: 'Tier suchen, z. B. Eule', value: this.motifFilter, 'aria-label': 'Motiv suchen' });
    const grid = h('div', { class: 'kpk-motifs' });
    const fill = () => {
      grid.replaceChildren();
      const q = slug(this.motifFilter);
      const cur = st.elements.find(e => e.type === 'motif' && !isPlaceholderPic(e));
      grid.append(h('button', { type: 'button', class: 'kpk-motif kpk-motif-none' + (!st.elements.some(e => e.type === 'motif' || e.type === 'image') ? ' is-on' : ''), onclick: () => { app.setMotif(null); fill(); this.syncMotifControls(); } },
        h('span', { class: 'kpk-motif-none-ic' }, '∅'), h('span', { class: 'kpk-motif-n' }, 'ohne')));
      for (const m of Motifs.list) {
        if (q && !slug(m.name).includes(q) && String(m.id) !== q) continue;
        const svg = svgEl('svg', { viewBox: `0 0 ${m.w} ${m.h}`, 'aria-hidden': 'true' });
        svg.appendChild(svgEl('path', { d: m.d, 'fill-rule': 'evenodd' }));
        grid.append(h('button', {
          type: 'button', class: 'kpk-motif' + (cur && cur.motif === m.id ? ' is-on' : ''), title: `${m.name} (Nr. ${m.id})`, 'aria-label': `${m.name}, Motiv ${m.id}`,
          onclick: () => { app.setMotif(m.id); fill(); this.syncMotifControls(); }
        }, svg, h('span', { class: 'kpk-motif-n' }, String(m.id))));
      }
      if (!grid.children.length) grid.append(h('p', { class: 'kpk-note' }, 'Kein Motiv gefunden.'));
    };
    search.addEventListener('input', () => { this.motifFilter = search.value; fill(); });
    p.append(h('div', { class: 'kpk-row-head' }, h('h3', { class: 'kpk-h3' }, 'Unsere Tiermotive'), h('span', { class: 'kpk-count' }, `${Motifs.list.length} Motive`)));
    p.append(h('div', { class: 'kpk-search-wrap' }, icon('search'), search));
    p.append(grid);
    fill();

    // Rahmen
    const model = modelById(st.model);
    const frameEl = st.elements.find(e => e.type === 'frame');
    const curFrame = frameEl ? frameEl.style : 'keiner';
    const frames = h('div', { class: 'kpk-chips' });
    for (const f of FRAMES) {
      if (f.squareOnly && model.shape !== 'square') continue;
      if (isRound(model) && (f.id === 'rund' || f.id === 'kreis')) continue;   // rund: jede Linie folgt dem Kreis
      frames.append(h('button', { type: 'button', class: 'kpk-chip kpk-frame' + (curFrame === f.id ? ' is-on' : ''), 'data-frame': f.id, onclick: () => { app.setFrame(f.id); this.render('motiv'); } },
        h('span', { class: 'kpk-frame-ic', 'data-style': f.id }), f.label));
    }
    p.append(h('h3', { class: 'kpk-h3' }, 'Rahmen'), frames);
  }

  syncMotifControls(full) {
    const box = this.motifCtl;
    if (!box || !box.isConnected) return;
    const app = this.app, st = app.state;
    const el = st.elements.find(e => e.id === st.selected && (e.type === 'motif' || e.type === 'image')) || st.elements.find(e => e.type === 'motif' || e.type === 'image');
    if (!el) { box.replaceChildren(); box.hidden = true; delete box.dataset.id; return; }
    if (isPlaceholderPic(el)) {
      if (box.dataset.id === 'slot|' + el.id) return;
      box.dataset.id = 'slot|' + el.id;
      box.hidden = false;
      box.replaceChildren(h('div', { class: 'kpk-slot-hint' }, icon('image'),
        h('span', null, h('strong', null, '„Dein Design“ ist ein Platzhalter. '), 'Lade oben dein Bild hoch oder such dir unten ein Motiv aus – es kommt genau an diese Stelle.')),
        h('div', { class: 'kpk-ctl-row' },
          h('button', { type: 'button', class: 'kpk-btn-s', onclick: () => { app.removeEl(el.id); this.render('motiv'); } }, icon('trash'), 'Platzhalter löschen')));
      return;
    }
    if (!full && box.dataset.id === el.id + '|' + el.type + '|' + (el.motif || '')) {
      // nur Werte nachziehen – nie den Regler ersetzen, an dem gerade gezogen wird
      for (const s of $$('[data-bind]', box)) {
        if (s.type !== 'range' || s.dataset.dragging) continue;
        s.value = el[s.dataset.bind] || 0;
        s.dispatchEvent(new Event('kpk-sync'));
      }
      return;
    }
    box.dataset.id = el.id + '|' + el.type + '|' + (el.motif || '');
    box.replaceChildren();
    box.hidden = false;
    const model = modelById(st.model);
    const title = el.type === 'motif' ? `${(Motifs.get(el.motif) || {}).name || 'Motiv'} · Nr. ${el.motif}` : 'Dein Bild';
    box.append(h('div', { class: 'kpk-ctl-title' }, h('strong', null, title),
      el.type === 'image' ? h('button', { type: 'button', class: 'kpk-link', onclick: () => app.reopenUpload(el.id) }, 'Kontrast anpassen') : null));
    box.append(slider('Größe', el.w, 2, Math.max(model.w, model.h) * 1.2, 0.1, v => `${v.toFixed(1).replace('.', ',')} mm`, v => app.updateEl(el.id, { w: v }), 'w'));
    box.append(slider('Drehen', el.rot || 0, -180, 180, 1, v => `${Math.round(v)}°`, v => app.updateEl(el.id, { rot: v }), 'rot'));
    box.append(h('div', { class: 'kpk-ctl-row' },
      h('button', { type: 'button', class: 'kpk-btn-s', onclick: () => app.updateEl(el.id, { flip: !el.flip }, true) }, icon('flip'), 'Spiegeln'),
      h('button', { type: 'button', class: 'kpk-btn-s', onclick: () => { app.select(el.id); app.elementAction('center'); } }, icon('center'), 'Mittig'),
      h('button', { type: 'button', class: 'kpk-btn-s', onclick: () => { app.removeEl(el.id); this.render('motiv'); } }, icon('trash'), 'Entfernen')));
  }

  /* ---------------- 4 · Text ---------------- */
  render_text(p) {
    const app = this.app, st = app.state;
    p.append(h('h2', { class: 'kpk-h2' }, 'Dein Text'));
    const texts = st.elements.filter(e => e.type === 'text');
    this.textList = h('div', { class: 'kpk-texts' });
    const sel = texts.find(t => t.id === st.selected) || texts[0];
    texts.forEach((t, i) => {
      const ta = h('textarea', { class: 'kpk-textarea', 'data-id': t.id, rows: t.arc !== 'none' ? 1 : Math.min(4, Math.max(1, t.text.split('\n').length)), 'aria-label': `Text ${i + 1}`, placeholder: t.ph ? t.text : 'Dein Text …' });
      ta.value = t.ph ? '' : t.text;
      const rowsFor = v => (t.arc !== 'none' ? 1 : Math.min(4, Math.max(1, String(v).split('\n').length)));
      ta.addEventListener('focus', () => {
        if (app.state.selected !== t.id) { app.select(t.id, { keepPanel: true }); this.markTextCards(); this.syncTextControls(); }
        const cur = app.state.elements.find(e => e.id === t.id);
        if (cur && cur.ph && app.openTextPlaceholder(t.id)) { ta.value = ''; ta.placeholder = cur.phWas; }
      });
      ta.addEventListener('blur', () => {
        const cur = app.state.elements.find(e => e.id === t.id);
        if (cur && cur.phOpen && app.closeTextPlaceholder(t.id)) { ta.value = cur.ph ? '' : cur.text; ta.placeholder = cur.ph ? cur.text : 'Dein Text …'; ta.rows = rowsFor(cur.ph ? '' : cur.text); }
      });
      ta.addEventListener('input', () => {
        let v = ta.value;
        if (t.arc !== 'none') v = v.replace(/\n/g, ' ');
        app.updateEl(t.id, { text: v }, false, 'typing');
        ta.rows = t.arc !== 'none' ? 1 : Math.min(4, Math.max(1, v.split('\n').length));
      });
      ta.addEventListener('change', () => app.changed({ commit: true }));
      const card = h('div', { class: 'kpk-text-card', 'data-id': t.id },
        h('div', { class: 'kpk-text-card-head' },
          h('span', { class: 'kpk-text-n' }, t.arc === 'oben' ? 'Bogen oben' : t.arc === 'unten' ? 'Bogen unten' : `Text ${i + 1}`),
          h('button', { type: 'button', class: 'kpk-icon-btn', title: 'Text entfernen', 'aria-label': 'Text entfernen', onclick: () => { app.removeEl(t.id); this.render('text'); } }, icon('trash'))),
        ta);
      this.textList.append(card);
    });
    p.append(this.textList);
    p.append(h('button', { type: 'button', class: 'kpk-add', onclick: () => { app.addText(); this.render('text'); } }, icon('plus'), 'Weiteren Text hinzufügen'));
    if (!texts.length) p.append(h('p', { class: 'kpk-note' }, 'Noch kein Text – füge oben einen hinzu.'));
    this.textCtl = h('div', { class: 'kpk-text-ctl' });
    p.append(this.textCtl);
    if (sel && app.state.selected !== sel.id) app.select(sel.id, { keepPanel: true, silent: true });
    this.markTextCards();
    this.syncTextControls(true);
  }

  /* Feld im Schritt „Text“ nachziehen, wenn direkt auf der Fläche geschrieben wird */
  syncTextValue(id) {
    if (!this.textList || !this.textList.isConnected) return;
    const ta = this.textList.querySelector(`textarea[data-id="${id}"]`);
    const el = this.app.state.elements.find(e => e.id === id);
    if (!ta || !el || document.activeElement === ta) return;
    ta.value = el.ph ? '' : el.text;
    ta.placeholder = el.ph ? el.text : el.phOpen ? (el.phWas || PH_TEXT) : 'Dein Text …';
    ta.rows = el.arc !== 'none' ? 1 : Math.min(4, Math.max(1, ta.value.split('\n').length));
  }

  markTextCards() {
    if (!this.textList) return;
    for (const c of $$('.kpk-text-card', this.textList)) c.classList.toggle('is-on', c.dataset.id === this.app.state.selected);
  }

  syncTextControls(full) {
    const box = this.textCtl;
    if (!box || !box.isConnected) return;
    const app = this.app, st = app.state;
    const el = st.elements.find(e => e.id === st.selected && e.type === 'text');
    if (!el) { box.replaceChildren(); return; }
    if (!full && box.dataset.id === el.id) {
      // nur Werte nachziehen
      for (const s of $$('[data-bind]', box)) {
        const key = s.dataset.bind;
        if (s.type === 'range' && document.activeElement !== s && !s.dataset.dragging) { s.value = el[key]; s.dispatchEvent(new Event('kpk-sync')); }
      }
      for (const b of $$('[data-font]', box)) b.classList.toggle('is-on', b.dataset.font === el.font);
      for (const b of $$('[data-arc]', box)) b.classList.toggle('is-on', b.dataset.arc === el.arc);
      for (const b of $$('[data-align]', box)) b.classList.toggle('is-on', b.dataset.align === el.align);
      this.updateFontSamples(el);
      return;
    }
    box.dataset.id = el.id;
    box.replaceChildren();
    const model = modelById(st.model);
    // Form
    const seg = (items, cur, key) => h('div', { class: 'kpk-seg', role: 'group' }, items.map(it => h('button', {
      type: 'button', class: 'kpk-seg-b' + (cur === it.v ? ' is-on' : ''), ['data-' + key]: it.v, title: it.t,
      onclick: () => { app.setTextForm(el.id, key, it.v); this.render('text'); }
    }, it.i ? icon(it.i) : null, h('span', null, it.t))));
    const forms = [{ v: 'none', t: 'Gerade', i: 'straight' }];
    if (isSquarish(model)) forms.push({ v: 'oben', t: 'Bogen oben', i: 'arcUp' }, { v: 'unten', t: 'Bogen unten', i: 'arcDown' });
    else forms.push({ v: 'oben', t: 'Bogen', i: 'arcUp' });
    box.append(h('div', { class: 'kpk-ctl-group' }, h('label', { class: 'kpk-label' }, 'Form'), seg(forms, el.arc, 'arc')));
    const ptMax = Math.max(36, Math.round(Math.min(model.w, model.h) * 1.1), Math.ceil(el.size));
    box.append(slider('Schriftgröße', el.size, 4, ptMax, 0.5, v => `${String(round(v, 1)).replace('.', ',')} pt`, v => app.updateEl(el.id, { size: v }), 'size'));
    if (el.arc !== 'none') {
      const rMax = model.shape === 'rect' ? model.w * 2 : Math.max(model.w, model.h) * 0.8;
      box.append(slider('Bogen-Radius', el.radius, 2, Math.max(rMax, el.radius), 0.1, v => `${v.toFixed(1).replace('.', ',')} mm`, v => app.updateEl(el.id, { radius: v }), 'radius'));
    } else {
      box.append(h('div', { class: 'kpk-ctl-group' }, h('label', { class: 'kpk-label' }, 'Ausrichtung'),
        seg([{ v: 'left', t: 'Links', i: 'left' }, { v: 'center', t: 'Mittig', i: 'middle' }, { v: 'right', t: 'Rechts', i: 'right' }], el.align, 'align')));
      box.append(slider('Zeilenabstand', el.lh, 0.8, 1.8, 0.02, v => v.toFixed(2).replace('.', ','), v => app.updateEl(el.id, { lh: v }), 'lh'));
    }
    box.append(slider('Buchstabenabstand', el.ls, -60, 300, 5, v => String(Math.round(v)), v => app.updateEl(el.id, { ls: v }), 'ls'));
    box.append(slider('Drehen', el.rot || 0, -180, 180, 1, v => `${Math.round(v)}°`, v => app.updateEl(el.id, { rot: v }), 'rot'));
    // Schriften
    const fontsBox = h('div', { class: 'kpk-fonts' });
    let group = null, grid = null;
    for (const f of FONTS) {
      if (f.group !== group) {
        group = f.group;
        fontsBox.append(h('div', { class: 'kpk-font-group' }, group));
        grid = h('div', { class: 'kpk-font-grid' });
        fontsBox.append(grid);
      }
      grid.append(h('button', {
        type: 'button', class: 'kpk-font' + (el.font === f.id ? ' is-on' : ''), 'data-font': f.id, title: `${f.label} (${f.family})`,
        onclick: () => { app.updateEl(el.id, { font: f.id }, true); this.syncTextControls(); app.ensureFont(f.id); }
      },
      h('span', { class: 'kpk-font-sample', style: { fontFamily: `"${f.family}", cursive`, fontWeight: String(f.weight) } }, ''),
      h('span', { class: 'kpk-font-l' }, f.label)));
    }
    box.append(h('h3', { class: 'kpk-h3' }, 'Schrift'), fontsBox);
    this.updateFontSamples(el);
  }

  updateFontSamples(el) {
    const txt = (el.text || '').split('\n')[0].trim().slice(0, 22) || 'Super gemacht!';
    for (const s of $$('.kpk-font-sample', this.textCtl)) s.textContent = txt;
  }

  /* ---------------- 5 · Fertig ---------------- */
  render_fertig(p) {
    const app = this.app, st = app.state;
    const m = modelById(st.model);
    const v = app.variant();
    p.append(h('h2', { class: 'kpk-h2' }, 'Alles gut so?'));
    const thumb = h('canvas', { class: 'kpk-sum-cv' });
    const rows = [
      ['Stempel', `${m.label} · ${m.size}`],
      [m.wood ? 'Holz' : 'Gehäuse', HOUSINGS[st.housing].label],
      [m.wood ? 'Stempelkissen' : 'Stempelfarbe', inkTitle(st.ink)]
    ];
    const texts = st.elements.filter(e => e.type === 'text' && e.text.trim());
    texts.forEach((t, i) => rows.push([texts.length > 1 ? `Text ${i + 1}` : 'Text', t.ph ? 'noch „Dein Wunschtext“ – bitte ausfüllen' : `${t.text.replace(/\n/g, ' / ')}`, t.ph ? null : fontById(t.font).label]));
    const mo = st.elements.find(e => e.type === 'motif');
    if (mo && isPlaceholderPic(mo)) rows.push(['Motiv', 'noch Platzhalter „Dein Design“ – bitte ersetzen']);
    else if (mo) rows.push(['Motiv', `${(Motifs.get(mo.motif) || {}).name || ''} (Nr. ${mo.motif})`]);
    if (st.elements.some(e => e.type === 'image')) rows.push(['Eigenes Bild', 'wird mitgeschickt']);
    const fr = st.elements.find(e => e.type === 'frame' && e.style !== 'keiner');
    if (fr) rows.push(['Rahmen', (FRAMES.find(f => f.id === fr.style) || {}).label || fr.style]);
    p.append(h('div', { class: 'kpk-sum' },
      h('div', { class: 'kpk-sum-media' }, thumb),
      h('dl', { class: 'kpk-sum-list' }, rows.map(r => [h('dt', null, r[0]), h('dd', null, r[1], r[2] ? h('small', null, r[2]) : null)]))));
    requestAnimationFrame(() => {
      const box = thumb.parentElement.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      thumb.width = Math.round(box.width * dpr); thumb.height = Math.round(box.height * dpr);
      thumb.style.width = box.width + 'px'; thumb.style.height = box.height + 'px';
      const k = Math.min(box.width * 0.84 / m.w, box.height * 0.84 / m.h) * dpr;
      const mask = renderMask(st, k);
      composeInk(thumb.getContext('2d'), mask, (thumb.width - mask.width) / 2, (thumb.height - mask.height) / 2, st.ink === 'ohne' ? 'schwarz' : st.ink, { alpha: 1, blend: 'source-over' });
    });
    // Stempel-Check
    const warns = app.warnings();
    const check = h('div', { class: 'kpk-check-list' });
    if (!warns.length) check.append(h('div', { class: 'kpk-ok' }, icon('check'), h('span', null, 'Stempel-Check: alles passt – gut lesbar und innerhalb der Stempelfläche.')));
    for (const w of warns) check.append(h('div', { class: 'kpk-warn ' + (w.level === 'stop' ? 'is-stop' : '') }, h('span', { class: 'kpk-warn-ic' }, '!'), h('span', null, w.text)));
    p.append(check);
    // Menge
    const qty = h('div', { class: 'kpk-qty' },
      h('button', { type: 'button', 'aria-label': 'Weniger', onclick: () => { app.setQty((st.qty || 1) - 1); this.render('fertig'); } }, '–'),
      h('output', null, String(st.qty || 1)),
      h('button', { type: 'button', 'aria-label': 'Mehr', onclick: () => { app.setQty((st.qty || 1) + 1); this.render('fertig'); } }, '+'));
    p.append(h('div', { class: 'kpk-ctl-group kpk-qty-row' }, h('label', { class: 'kpk-label' }, 'Anzahl'), qty));
    const cb = h('input', { type: 'checkbox', id: 'kpk-ok-' + app.uidRoot });
    cb.checked = !!st.confirmed;
    cb.addEventListener('change', () => { app.state.confirmed = cb.checked; this.updateBuy(); });
    p.append(h('label', { class: 'kpk-confirm', for: 'kpk-ok-' + app.uidRoot }, cb,
      h('span', null, 'Ich habe meinen Entwurf geprüft (Rechtschreibung, Anordnung) – er wird genau so gefertigt. ',
        'Mir ist bewusst, dass bei Stempeln, die nach meinen individuellen Vorgaben angefertigt werden, kein Widerrufsrecht besteht (§ 312g Abs. 2 Nr. 1 BGB).')));
    p.append(h('p', { class: 'kpk-legal' }, 'Deine gesetzlichen Rechte bei Mängeln bleiben davon unberührt. ',
      h('a', { href: policyUrl(app), target: '_blank', rel: 'noopener' }, 'Widerrufsbelehrung ansehen')));
    p.append(h('div', { class: 'kpk-promise' },
      h('div', null, icon('shield'), h('span', null, 'Wir schauen uns jeden Entwurf vor dem Lasern an und melden uns, falls etwas nicht passt.')),
      h('div', null, icon('heart'), h('span', null, 'Handgefertigt im Vogtland – seit über 30 Jahren.'))));
    if (!v) p.append(h('p', { class: 'kpk-warn is-stop' }, 'Diese Kombination ist gerade nicht verfügbar.'));
  }
}

/* Stempelkissen als kleines Kissen in seiner Farbe (dreifarbig: drei Streifen) */
function padSwatch(ink) {
  const felt = ink.bands
    ? h('span', { class: 'kpk-pad-felt', style: { background: `linear-gradient(90deg, ${ink.bands[0]} 0 33.4%, ${ink.bands[1]} 33.4% 66.7%, ${ink.bands[2]} 66.7%)` } })
    : h('span', { class: 'kpk-pad-felt', style: { '--c': ink.color } });
  return h('span', { class: 'kpk-pad' + (ink.none ? ' is-none' : ink.bands ? ' is-multi' : ink.metallic ? ' is-metal' : ''), 'aria-hidden': 'true' }, ink.none ? null : felt);
}

/* Widerrufsbelehrung des Shops */
function policyUrl(app) {
  if (app.cfg.mode === 'shopify') return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'policies/refund-policy';
  return 'https://kreativpuenktchen.de/policies/refund-policy';
}

/* Schieberegler mit Anzeige */
function slider(label, value, min, max, step, fmt, onInput, bind) {
  const out = h('output', { class: 'kpk-val' }, fmt(Number(value)));
  const inp = h('input', { type: 'range', class: 'kpk-range', min, max, step, value, 'aria-label': label, 'data-bind': bind || null });
  const upd = () => { out.textContent = fmt(Number(inp.value)); inp.style.setProperty('--p', ((inp.value - min) / (max - min) * 100) + '%'); };
  const endDrag = () => { delete inp.dataset.dragging; };
  inp.addEventListener('pointerdown', () => { inp.dataset.dragging = '1'; });
  inp.addEventListener('touchstart', () => { inp.dataset.dragging = '1'; }, { passive: true });
  for (const ev of ['pointerup', 'pointercancel', 'touchend', 'touchcancel', 'change', 'blur']) inp.addEventListener(ev, endDrag);
  if (!slider.hooked) {
    // Loslassen außerhalb des Reglers beendet das Ziehen ebenfalls
    slider.hooked = true;
    document.addEventListener('pointerup', () => { for (const r of document.querySelectorAll('.kpk-range[data-dragging]')) delete r.dataset.dragging; }, true);
  }
  inp.addEventListener('input', () => { upd(); onInput(Number(inp.value)); });
  inp.addEventListener('change', () => { if (typeof App !== 'undefined' && App.current) App.current.changed({ commit: true }); });
  inp.addEventListener('kpk-sync', upd);
  upd();
  return h('div', { class: 'kpk-ctl-group' }, h('div', { class: 'kpk-ctl-top' }, h('label', { class: 'kpk-label' }, label), out), inp);
}

/* Beispiele beim Hochladen: was sich gut stempeln lässt und was nicht (Wunsch 25.09.) */
function uploadExamples() {
  const ink = '#231f1f';
  const flower = (stroke, sw) => `<g fill="none" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round">` +
    `<g transform="translate(50 36)">${[0, 72, 144, 216, 288].map(a => `<ellipse cx="0" cy="-15" rx="7.5" ry="11" transform="rotate(${a})"/>`).join('')}` +
    `<circle r="6.5" fill="#fff"/></g><path d="M50 49c-1 14 1 25 0 40"/><path d="M50 73c-7-10-17-11-24-7 6 8 16 10 24 7Z"/><path d="M50 65c6-9 15-10 21-6-5 7-14 9-21 6Z"/></g>`;
  const EX = [
    { ok: true, label: 'Klare Linien', svg: `<rect width="100" height="100" fill="#fff"/>${flower(ink, 3.4)}` },
    { ok: true, label: 'Logo, kräftige Schrift', svg: `<rect width="100" height="100" fill="#fff"/><path d="M50 60C50 60 26 46 26 31c0-8 6-14 13-14 5 0 9 3 11 7 2-4 6-7 11-7 7 0 13 6 13 14 0 15-24 29-24 29Z" fill="${ink}"/><text x="50" y="86" text-anchor="middle" font-family="'Quattrocento Sans', Arial, sans-serif" font-weight="700" font-size="19" letter-spacing="1.5" fill="${ink}">MIA</text>` },
    { ok: false, label: 'Foto mit Verläufen', svg: `<defs><linearGradient id="kpkx-sky" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#7fb2e0"/><stop offset=".72" stop-color="#f4dcbc"/></linearGradient><radialGradient id="kpkx-sun" cx=".7" cy=".36" r=".38"><stop offset="0" stop-color="#fff7de"/><stop offset=".22" stop-color="#ffd98a" stop-opacity=".95"/><stop offset="1" stop-color="#ffd98a" stop-opacity="0"/></radialGradient><linearGradient id="kpkx-h1" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#8db07a"/><stop offset="1" stop-color="#46703f"/></linearGradient><linearGradient id="kpkx-h2" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#5f8c50"/><stop offset="1" stop-color="#27452a"/></linearGradient><filter id="kpkx-blur"><feGaussianBlur stdDeviation="1.4"/></filter></defs><rect width="100" height="100" fill="url(#kpkx-sky)"/><rect width="100" height="100" fill="url(#kpkx-sun)"/><path d="M0 62C20 50 38 55 56 61S88 57 100 50V100H0Z" fill="url(#kpkx-h1)" filter="url(#kpkx-blur)"/><path d="M0 79C24 68 46 72 64 80S92 76 100 71V100H0Z" fill="url(#kpkx-h2)"/><g filter="url(#kpkx-blur)"><ellipse cx="24" cy="60" rx="8" ry="11" fill="#3a5e33"/><rect x="23" y="66" width="2.4" height="10" fill="#4a3a2c"/></g>` },
    { ok: false, label: 'Zu fein, zu blass', svg: `<rect width="100" height="100" fill="#fff"/>${flower('#c9c2c2', 0.8)}<path d="M18 92h64M24 95h52" stroke="#d6d0d0" stroke-width=".6"/>` }
  ];
  return h('div', { class: 'kpk-up-tips' },
    h('p', { class: 'kpk-up-tips-h' }, 'Was sich gut stempeln lässt'),
    h('div', { class: 'kpk-up-ex' }, EX.map(ex => h('figure', { class: 'kpk-up-ex-i ' + (ex.ok ? 'is-ok' : 'is-no') },
      h('span', { class: 'kpk-up-ex-img', html: `<svg viewBox="0 0 100 100" aria-hidden="true">${ex.svg}</svg>` },
        h('span', { class: 'kpk-up-ex-badge', 'aria-hidden': 'true' }, icon(ex.ok ? 'check' : 'close'))),
      h('figcaption', null, h('span', { class: 'kpk-sr' }, ex.ok ? 'Gut: ' : 'Ungeeignet: '), ex.label)))),
    h('p', { class: 'kpk-up-tips-note' }, 'Am besten dunkle, klare Formen auf hellem Grund.'));
}

/* ---- js/55-tour.js ---- */
/* ---------------------------------------------------------------------------
   Anleitung: kurze Tour durch die Werkstatt
   Beim ersten Besuch wird sie angeboten, oben unter „So funktioniert’s“
   lässt sie sich jederzeit wieder starten.
   --------------------------------------------------------------------------- */

const TOUR_KEY = 'kpk-anleitung-v2';   // v2 (25.09.): springt durch alle Bereiche – wer v1 kannte, sieht die neue einmal

const TOUR_STEPS = [
  { title: 'Willkommen in der Stempel-Werkstatt', text: 'In fünf Schritten zu deinem eigenen Stempel. Ich springe einmal kurz durch alle Bereiche – dauert keine Minute.', intro: true },
  { sel: '.kpk-stage', title: 'Deine Arbeitsfläche', text: 'Hier entsteht dein Stempel. Tipp auf „Dein Wunschtext“ und schreib los – der Platzhalter verschwindet sofort. „Dein Design“ ersetzt du durch ein Motiv oder dein Bild. Ziehen verschiebt, die Ecken ändern Größe und Drehung.' },
  { sel: '.kpk-steps', title: 'Fünf Schritte', text: 'Stempel & Farbe, Design, Vorlage, Text und Fertig. Du kannst jederzeit hin- und herspringen, nichts geht verloren.' },
  { sel: '.kpk-models', step: 'stempel', title: '1 · Stempel & Farbe', text: 'Holzstempel (ohne Griff oder mit Griff in vielen Größen, auch rund), Edy oder einer der Printys – der Preis steht gleich dabei.' },
  { sel: '.kpk-colors', step: 'stempel', title: 'Farben', text: 'Gehäuse- und Stempelfarbe wählst du gleich hier. Beim Holzstempel wählst du Größe und Stempelkissen.' },
  { sel: '.kpk-shortcut', step: 'stempel', title: 'Schon ein fertiges Logo?', text: 'Dann lade es hier hoch. Es füllt die ganze Stempelfläche, die Vorlage überspringst du.' },
  { sel: '.kpk-up-area', step: 'motiv', title: '2 · Design', text: 'Hier lädst du dein eigenes Bild oder Logo hoch – dort siehst du auch, was sich gut stempeln lässt. Weiter unten findest du unsere Tiermotive.' },
  { sel: '.kpk-tpls', step: 'vorlage', title: '3 · Vorlage', text: 'Hier legst du fest, wie Bild und Text angeordnet sind. Danach kannst du alles frei verschieben.' },
  { sel: '.kpk-texts', step: 'text', title: '4 · Text', text: 'Tipp ins Feld und schreib deinen Text, das Beispiel verschwindet dabei. Darunter wählst du Schrift und Größe.' },
  { sel: '.kpk-confirm', step: 'fertig', title: '5 · Fertig', text: 'Prüf deinen Entwurf in der Übersicht, setz das Häkchen und leg den Stempel in den Warenkorb.' },
  { sel: '.kpk-stage-tools', title: 'Kleine Helfer', text: 'Rückgängig und Wiederholen, Raster und Einrasten zum An- und Ausschalten. „Ansicht“ zeigt den Entwurf ohne Hilfslinien.' },
  { sel: '.kpk-buy', title: 'Preis und Weiter', text: 'Hier steht immer der aktuelle Preis. „Weiter“ führt dich zum nächsten Schritt, am Ende legst du den Stempel in den Warenkorb.' },
  { title: 'Viel Spaß beim Gestalten!', text: 'Die Anleitung findest du jederzeit wieder oben unter „So funktioniert’s“.', outro: true }
];

class Tour {
  constructor(app) {
    this.app = app;
    this.i = 0;
    this.root = null;
    this.onMove = rafThrottle(() => this.place());
    this.onKey = e => {
      if (!this.root) return;
      if (e.key === 'Escape') { e.preventDefault(); this.end(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); }
    };
  }

  static seen() { return !!storage.get(TOUR_KEY); }

  /* Beim ersten Besuch: freundliches Angebot statt Zwangstour */
  offer() {
    if (Tour.seen()) return;
    setTimeout(() => { if (!this.root && !document.querySelector('.kpk-modal')) this.start(0); }, 900);
  }

  start(i = 0) {
    this.end(true);
    this.lastFocus = document.activeElement;
    this.startStep = this.app.panels.step;
    this.root = h('div', { class: 'kpk kpk-tour', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Anleitung' });
    // span statt div: das Shop-Theme blendet leere divs aus (div:empty{display:none}) –
    // dann fehlten Rahmen und Abdunklung
    this.block = h('span', { class: 'kpk-tour-block', onclick: () => this.tip && this.tip.querySelector('.kpk-tour-next').focus() });
    this.spot = h('span', { class: 'kpk-tour-spot', 'aria-hidden': 'true' });
    this.tip = h('div', { class: 'kpk-tour-tip' });
    this.root.append(this.block, this.spot, this.tip);
    document.body.appendChild(this.root);
    window.addEventListener('scroll', this.onMove, { passive: true });
    window.addEventListener('resize', this.onMove);
    document.addEventListener('keydown', this.onKey, true);
    requestAnimationFrame(() => this.root && this.root.classList.add('is-in'));
    this.show(i);
  }

  show(i) {
    this.i = clamp(i, 0, TOUR_STEPS.length - 1);
    const s = TOUR_STEPS[this.i];
    const panels = this.app.panels;
    if (s.step && panels.step !== s.step) panels.go(s.step, { silent: true });
    this.target = s.sel ? $(s.sel, this.app.el) : null;
    if (this.target && !this.target.getClientRects().length) this.target = null;
    this.renderTip(s);
    if (this.target) {
      this.root.classList.remove('is-free');
      this.spot.classList.remove('is-jump'); void this.spot.offsetWidth; this.spot.classList.add('is-jump');
      this.ensureVisible(this.target);
      this.place();
      clearTimeout(this.settle);
      this.settle = setTimeout(() => this.place(), 420);
    } else {
      this.root.classList.add('is-free');
      this.place();
    }
    const btn = this.tip.querySelector('.kpk-tour-next');
    if (btn) setTimeout(() => { try { btn.focus({ preventScroll: true }); } catch (e) { btn.focus(); } }, 60);
  }

  renderTip(s) {
    const n = TOUR_STEPS.length;
    const last = this.i === n - 1;
    const dots = h('div', { class: 'kpk-tour-dots', 'aria-hidden': 'true' },
      TOUR_STEPS.map((_, k) => h('i', { class: k === this.i ? 'is-on' : (k < this.i ? 'is-done' : null) })));
    const actions = h('div', { class: 'kpk-tour-actions' });
    if (s.intro) {
      actions.append(
        h('button', { type: 'button', class: 'kpk-btn-ghost kpk-tour-skip', onclick: () => this.end() }, 'Gleich loslegen'),
        h('button', { type: 'button', class: 'kpk-cta kpk-tour-next', onclick: () => this.next() }, 'Anleitung starten'));
    } else {
      if (!last) actions.append(h('button', { type: 'button', class: 'kpk-tour-link', onclick: () => this.end() }, 'Überspringen'));
      actions.append(h('span', { class: 'kpk-tour-spacer' }));
      if (this.i > 1) actions.append(h('button', { type: 'button', class: 'kpk-tour-back', 'aria-label': 'Zurück', onclick: () => this.prev() }, icon('chevronLeft')));
      actions.append(h('button', { type: 'button', class: 'kpk-cta kpk-tour-next', onclick: () => (last ? this.end() : this.next()) }, last ? 'Los geht’s' : 'Weiter'));
    }
    this.tip.replaceChildren(...[
      h('div', { class: 'kpk-tour-top' },
        h('span', { class: 'kpk-tour-count' }, s.intro || s.outro ? 'Anleitung' : `${this.i} von ${n - 2}`),
        h('button', { type: 'button', class: 'kpk-tour-x', 'aria-label': 'Anleitung schließen', onclick: () => this.end() }, icon('close'))),
      h('h2', { class: 'kpk-tour-title' }, s.title),
      h('p', { class: 'kpk-tour-text' }, s.text),
      s.intro || s.outro ? null : dots,
      actions].filter(Boolean));
    this.tip.classList.remove('is-in'); void this.tip.offsetWidth; this.tip.classList.add('is-in');
  }

  /* Ziel so scrollen, dass es nicht unter der mitlaufenden Bühne, der
     Schrittleiste oder der Kaufleiste (Handy) verschwindet */
  ensureVisible(t) {
    if (getComputedStyle(t).position === 'fixed' || t.closest('.kpk-stage-col')) return false;
    const el = this.app.el;
    const steps = $('.kpk-steps', el);
    let topObs = 0;
    if (steps && t !== steps && !t.contains(steps)) topObs = (parseFloat(getComputedStyle(steps).top) || 0) + steps.offsetHeight;
    const buy = $('.kpk-buy', el);
    const bp = buy ? getComputedStyle(buy).position : '';
    const botObs = buy && (bp === 'fixed' || bp === 'sticky') && !t.closest('.kpk-buy') ? Math.max(0, window.innerHeight - buy.getBoundingClientRect().top) : 0;
    const r = t.getBoundingClientRect();
    const topLimit = topObs + 14, botLimit = window.innerHeight - botObs - 14;
    if (r.top >= topLimit && r.bottom <= botLimit) return false;
    try { window.scrollBy({ top: r.top - topLimit, behavior: 'smooth' }); } catch (e) { window.scrollBy(0, r.top - topLimit); }
    return true;
  }

  /* Hervorhebung und Sprechblase an das Ziel anlegen */
  place() {
    if (!this.root) return;
    const vw = window.innerWidth, vh = window.innerHeight;
    const tip = this.tip;
    const tw = Math.min(360, vw - 32);
    tip.style.width = tw + 'px';
    if (!this.target || !this.target.isConnected) {
      this.spot.style.opacity = '0';
      tip.dataset.side = 'none';
      tip.style.left = Math.round((vw - tw) / 2) + 'px';
      tip.style.top = Math.round(Math.max(16, (vh - tip.offsetHeight) / 2)) + 'px';
      return;
    }
    const r = this.target.getBoundingClientRect();
    const pad = 8;
    const x0 = Math.max(6, r.left - pad), y0 = Math.max(6, r.top - pad);
    const x1 = Math.min(vw - 6, r.right + pad), y1 = Math.min(vh - 6, r.bottom + pad);
    const radius = parseFloat(getComputedStyle(this.target).borderTopLeftRadius) || 12;
    Object.assign(this.spot.style, { opacity: '1', left: x0 + 'px', top: y0 + 'px', width: Math.max(0, x1 - x0) + 'px', height: Math.max(0, y1 - y0) + 'px', borderRadius: Math.min(28, radius + pad) + 'px' });
    const th = tip.offsetHeight, gap = 14;
    let side, top, left;
    if (y1 + gap + th <= vh - 12) { side = 'below'; top = y1 + gap; }
    else if (y0 - gap - th >= 12) { side = 'above'; top = y0 - gap - th; }
    else if (vw - x1 - gap >= tw + 12) { side = 'right'; left = x1 + gap; top = clamp((y0 + y1) / 2 - th / 2, 12, vh - th - 12); }
    else if (x0 - gap >= tw + 12) { side = 'left'; left = x0 - gap - tw; top = clamp((y0 + y1) / 2 - th / 2, 12, vh - th - 12); }
    else { side = 'over'; top = vh - th - 16; }
    if (left == null) left = clamp((x0 + x1) / 2 - tw / 2, 16, vw - tw - 16);
    tip.dataset.side = side;
    tip.style.left = Math.round(left) + 'px';
    tip.style.top = Math.round(top) + 'px';
    const ax = clamp((x0 + x1) / 2 - left, 24, tw - 24);
    const ay = clamp((y0 + y1) / 2 - top, 24, th - 24);
    tip.style.setProperty('--ax', ax + 'px');
    tip.style.setProperty('--ay', ay + 'px');
  }

  next() { if (this.i < TOUR_STEPS.length - 1) this.show(this.i + 1); else this.end(); }
  prev() { if (this.i > 1) this.show(this.i - 1); }

  end(silent) {
    if (!this.root) return;
    const root = this.root;
    this.root = null;
    clearTimeout(this.settle);
    window.removeEventListener('scroll', this.onMove);
    window.removeEventListener('resize', this.onMove);
    document.removeEventListener('keydown', this.onKey, true);
    storage.set(TOUR_KEY, { t: Date.now() });
    if (silent) { root.remove(); return; }
    root.classList.remove('is-in');
    setTimeout(() => root.remove(), 260);
    if (this.startStep && this.app.panels.step !== this.startStep) this.app.panels.go(this.startStep, { silent: true });
    try { if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true }); } catch (e) { /* egal */ }
  }
}

/* ---- js/60-export.js ---- */
/* ---------------------------------------------------------------------------
   Eigenes Bild (Upload + Schwarz/Weiß), Druckdatei, Vorschau, Warenkorb
   --------------------------------------------------------------------------- */

const Upload = {
  async load(file) {
    if (!file || !/^image\//.test(file.type || '') && !/\.(svg|png|jpe?g|webp|gif)$/i.test(file.name || '')) {
      throw new Error('Bitte wähle eine Bilddatei (JPG, PNG, SVG oder WebP).');
    }
    if (file.size > 15 * 1024 * 1024) throw new Error('Die Datei ist größer als 15 MB – bitte verkleinern.');
    const url = URL.createObjectURL(file);
    let img;
    try { img = await loadImage(url); } finally { setTimeout(() => URL.revokeObjectURL(url), 4000); }
    let w = img.naturalWidth || img.width, hh = img.naturalHeight || img.height;
    const isSvg = /svg/i.test(file.type) || /\.svg$/i.test(file.name || '');
    if (!w || !hh) { w = 1200; hh = 1200; }
    const target = isSvg ? 1600 : Math.min(1600, Math.max(w, hh));
    const sc = target / Math.max(w, hh);
    const c = canvas(w * sc, hh * sc);
    const ctx = c.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.drawImage(img, 0, 0, c.width, c.height);
    const data = ctx.getImageData(0, 0, c.width, c.height).data;
    const gray = new Uint8ClampedArray(c.width * c.height);
    const hist = new Uint32Array(256);
    for (let i = 0, p = 0; i < data.length; i += 4, p++) {
      const v = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]);
      gray[p] = v; hist[v]++;
    }
    return { w: c.width, h: c.height, gray, otsu: otsu(hist, gray.length), srcW: w, srcH: hh, isSvg, name: file.name || 'bild' };
  },

  /* Graustufen → weiche Schwarz/Weiß-Maske, zugeschnitten */
  mask(u, thr, invert, smooth) {
    const { w, h: hh } = u;
    let g = u.gray;
    if (smooth) g = boxBlur(g, w, hh, Math.max(1, Math.round(Math.max(w, hh) / 700)));
    const c = canvas(w, hh);
    const ctx = c.getContext('2d');
    const id = ctx.createImageData(w, hh);
    const soft = 10;
    let x0 = w, y0 = hh, x1 = -1, y1 = -1;
    for (let y = 0, p = 0; y < hh; y++) {
      for (let x = 0; x < w; x++, p++) {
        let a = (thr + soft - g[p]) / (soft * 2);
        if (invert) a = 1 - a;
        a = a <= 0 ? 0 : a >= 1 ? 1 : a;
        if (a > 0.5) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
        const o = p * 4;
        id.data[o] = id.data[o + 1] = id.data[o + 2] = 0;
        id.data[o + 3] = Math.round(a * 255);
      }
    }
    ctx.putImageData(id, 0, 0);
    if (x1 < 0) return { canvas: c, empty: true, ratio: hh / w };
    const pad = 2;
    x0 = Math.max(0, x0 - pad); y0 = Math.max(0, y0 - pad); x1 = Math.min(w - 1, x1 + pad); y1 = Math.min(hh - 1, y1 + pad);
    const t = canvas(x1 - x0 + 1, y1 - y0 + 1);
    t.getContext('2d').drawImage(c, x0, y0, t.width, t.height, 0, 0, t.width, t.height);
    return { canvas: t, empty: false, ratio: t.height / t.width, coverage: (x1 - x0) * (y1 - y0) / (w * hh) };
  }
};

/* Schwelle nach Otsu. Liegt das Maximum auf einer Ebene (leere Grauwerte zwischen
   hell und dunkel, z. B. reines Schwarz/Weiß ohne Kantenglättung), gilt deren Mitte –
   sonst läge die Schwelle bei 0 und ein sauberes Schwarz/Weiß-Logo wäre „leer“ (v1.6). */
function otsu(hist, total) {
  let sum = 0;
  for (let i = 0; i < 256; i++) sum += i * hist[i];
  let sumB = 0, wB = 0, max = 0, t0 = 128, t1 = 128;
  for (let t = 0; t < 256; t++) {
    wB += hist[t]; if (!wB) continue;
    const wF = total - wB; if (!wF) break;
    sumB += t * hist[t];
    const mB = sumB / wB, mF = (sum - sumB) / wF;
    const between = wB * wF * (mB - mF) * (mB - mF);
    if (between > max) { max = between; t0 = t1 = t; }
    else if (between === max) t1 = t;
  }
  return Math.round((t0 + t1) / 2);
}

function boxBlur(src, w, hh, r) {
  const tmp = new Float32Array(w * hh), out = new Uint8ClampedArray(w * hh);
  for (let y = 0; y < hh; y++) {
    let acc = 0; const row = y * w;
    for (let x = -r; x <= r; x++) acc += src[row + clamp(x, 0, w - 1)];
    for (let x = 0; x < w; x++) {
      tmp[row + x] = acc / (2 * r + 1);
      acc += src[row + clamp(x + r + 1, 0, w - 1)] - src[row + clamp(x - r, 0, w - 1)];
    }
  }
  for (let x = 0; x < w; x++) {
    let acc = 0;
    for (let y = -r; y <= r; y++) acc += tmp[clamp(y, 0, hh - 1) * w + x];
    for (let y = 0; y < hh; y++) {
      out[y * w + x] = acc / (2 * r + 1);
      acc += tmp[clamp(y + r + 1, 0, hh - 1) * w + x] - tmp[clamp(y - r, 0, hh - 1) * w + x];
    }
  }
  return out;
}

/* ---------- Dialog „Bild anpassen“ ---------- */
/* Hochladen-Fenster (v1.7, Wunsch 25.09.): erst die Datei wählen – dabei stehen die Beispiele, was
   sich gut stempeln lässt –, danach im selben Fenster Kontrast einstellen (openUploadDialog). */
function openUploadChooser(app, how = {}) {
  const design = how.mode === 'design';
  const input = h('input', { type: 'file', accept: 'image/png,image/jpeg,image/webp,image/svg+xml,image/gif', class: 'kpk-file', 'aria-label': design ? 'Fertiges Design auswählen' : 'Bild auswählen' });
  const zone = h('label', { class: 'kpk-up-zone' }, input,
    h('span', { class: 'kpk-drop-ic' }, icon('upload')),
    h('span', { class: 'kpk-up-zone-t' }, h('strong', null, 'Bild auswählen'), h('span', null, 'oder hierher ziehen · JPG, PNG, SVG')));
  const modal = h('div', { class: 'kpk-modal', role: 'dialog', 'aria-modal': 'true', 'aria-label': design ? 'Fertiges Design hochladen' : 'Eigenes Bild hochladen' },
    h('div', { class: 'kpk-modal-card kpk-up-card' },
      h('button', { type: 'button', class: 'kpk-modal-x', 'aria-label': 'Schließen', onclick: () => close() }, icon('close')),
      h('h2', { class: 'kpk-h2' }, design ? 'Dein fertiges Design hochladen' : 'Eigenes Bild oder Logo hochladen'),
      h('p', { class: 'kpk-sub' }, design ? 'Es füllt die ganze Stempelfläche – die Vorlage überspringst du.' : 'Logo, Zeichnung oder Foto. Danach stellst du ein, wie es gestempelt wird.'),
      zone,
      uploadExamples()));
  let busy = false;
  const take = async f => {
    if (!f || busy) return;
    busy = true;
    zone.classList.add('is-busy');
    let u;
    try { u = await Upload.load(f); } catch (e) { busy = false; zone.classList.remove('is-busy'); app.toast(e.message); return; }
    document.removeEventListener('keydown', onKey);
    openUploadDialog(app, u, null, (res, opts) => app.applyUpload(u, res, opts, f, null, how.mode), modal);
  };
  input.addEventListener('change', () => { const f = input.files && input.files[0]; input.value = ''; take(f); });
  zone.addEventListener('dragover', e => { e.preventDefault(); zone.classList.add('is-over'); });
  zone.addEventListener('dragleave', () => zone.classList.remove('is-over'));
  zone.addEventListener('drop', e => {
    e.preventDefault(); zone.classList.remove('is-over');
    take(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]);
  });
  function close() {
    modal.classList.add('is-out');
    document.removeEventListener('keydown', onKey);
    setTimeout(() => modal.remove(), 200);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  document.addEventListener('keydown', onKey);
  app.el.appendChild(modal);
  requestAnimationFrame(() => modal.classList.add('is-in'));
  return modal;
}

function openUploadDialog(app, u, init, onApply, reuse) {
  const st = app.state;
  const ink = st.ink === 'ohne' ? 'schwarz' : st.ink;
  let thr = init && init.thr != null ? init.thr : u.otsu;
  let inv = !!(init && init.inv);
  let smooth = init && init.smooth != null ? init.smooth : true;
  const cv = h('canvas', { class: 'kpk-up-cv' });
  const info = h('p', { class: 'kpk-up-info' });
  let result = null;
  const draw = () => {
    result = Upload.mask(u, thr, inv, smooth);
    const box = cv.parentElement ? cv.parentElement.getBoundingClientRect() : { width: 320, height: 260 };
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = Math.round(box.width * dpr); cv.height = Math.round(box.height * dpr);
    cv.style.width = box.width + 'px'; cv.style.height = box.height + 'px';
    const ctx = cv.getContext('2d');
    ctx.clearRect(0, 0, cv.width, cv.height);
    const m = result.canvas;
    const sc = Math.min(cv.width * 0.86 / m.width, cv.height * 0.86 / m.height);
    const tmp = canvas(m.width * sc, m.height * sc);
    tmp.getContext('2d').drawImage(m, 0, 0, tmp.width, tmp.height);
    composeInk(ctx, tmp, (cv.width - tmp.width) / 2, (cv.height - tmp.height) / 2, ink, { alpha: 1, blend: 'source-over' });
    const small = Math.max(u.srcW, u.srcH) < 500 && !u.isSvg;
    info.textContent = result.empty ? 'Nichts mehr zu sehen – verschiebe den Regler.' :
      small ? `Hinweis: Dein Bild ist nur ${u.srcW} × ${u.srcH} px groß – für scharfe Kanten sind etwa 1000 px ideal.` :
      'Alles, was dunkel ist, wird gestempelt. Mit dem Regler bestimmst du, wie viel.';
    info.classList.toggle('is-warn', small || result.empty);
  };
  const s = slider('Kontrast (Schwelle)', thr, 10, 245, 1, v => String(Math.round(v)), v => { thr = v; draw(); });
  const invBtn = h('button', { type: 'button', class: 'kpk-toggle' + (inv ? ' is-on' : ''), 'aria-pressed': String(inv), onclick: () => { inv = !inv; invBtn.classList.toggle('is-on', inv); invBtn.setAttribute('aria-pressed', String(inv)); draw(); } }, h('span', { class: 'kpk-toggle-k' }), 'Umkehren (hell ↔ dunkel)');
  const smBtn = h('button', { type: 'button', class: 'kpk-toggle' + (smooth ? ' is-on' : ''), 'aria-pressed': String(smooth), onclick: () => { smooth = !smooth; smBtn.classList.toggle('is-on', smooth); smBtn.setAttribute('aria-pressed', String(smooth)); draw(); } }, h('span', { class: 'kpk-toggle-k' }), 'Kanten glätten');
  const card = h('div', { class: 'kpk-modal-card' },
      h('button', { type: 'button', class: 'kpk-modal-x', 'aria-label': 'Schließen', onclick: () => close() }, icon('close')),
      h('h2', { class: 'kpk-h2' }, 'Bild für den Stempel anpassen'),
      h('div', { class: 'kpk-up-grid' },
        h('div', { class: 'kpk-up-media' }, cv),
        h('div', { class: 'kpk-up-ctl' }, s, h('div', { class: 'kpk-ctl-row' }, invBtn, smBtn), info,
          h('p', { class: 'kpk-note' }, 'Tipp: Am besten funktionieren klare Umrisse in Schwarz auf Weiß. Dein Original schicken wir mit der Bestellung mit.'))),
      h('div', { class: 'kpk-modal-actions' },
        h('button', { type: 'button', class: 'kpk-btn-ghost', onclick: () => close() }, 'Abbrechen'),
        h('button', { type: 'button', class: 'kpk-cta', onclick: () => { if (result && !result.empty) { onApply(result, { thr, inv, smooth }); close(); } } }, 'Übernehmen')));
  // aus dem Hochladen-Fenster: im selben Fenster weiter (kein Flackern)
  const modal = reuse || h('div', { class: 'kpk-modal', role: 'dialog', 'aria-modal': 'true' });
  modal.setAttribute('aria-label', 'Bild anpassen');
  modal.replaceChildren(card);
  function close() {
    modal.classList.add('is-out');
    document.removeEventListener('keydown', onKey);
    setTimeout(() => modal.remove(), 200);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  document.addEventListener('keydown', onKey);
  if (!reuse) app.el.appendChild(modal);
  requestAnimationFrame(() => { modal.classList.add('is-in'); draw(); });
}

/* ---------- Dateien für die Werkstatt ---------- */
async function productionFile(state) {
  const m = modelById(state.model);
  const k = EXPORT_PX_PER_MM;
  const mask = renderMask(state, k);
  const c = canvas(mask.width, mask.height);
  const ctx = c.getContext('2d');
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, c.width, c.height);
  const md = mask.getContext('2d').getImageData(0, 0, mask.width, mask.height).data;
  const out = ctx.getImageData(0, 0, c.width, c.height);
  for (let i = 0; i < md.length; i += 4) {
    if (md[i + 3] >= 128) { out.data[i] = out.data[i + 1] = out.data[i + 2] = 0; }
  }
  ctx.putImageData(out, 0, 0);
  const blob = await pngWithDpi(await blobFromCanvas(c), k);
  const name = `KP-Druckdatei-${m.label.replace(/\s+/g, '')}-${isRound(m) ? 'rund-' + m.w : m.w + 'x' + m.h}mm.png`;
  return { blob, name, w: c.width, h: c.height, dataUrl: null, canvas: c };
}

async function previewFile(state) {
  const m = modelById(state.model);
  const W = 1000, H = Math.round(W * (isSquarish(m) ? 1 : 0.62));
  const c = canvas(W, H);
  const ctx = c.getContext('2d');
  ctx.fillStyle = '#fffdfa';
  ctx.fillRect(0, 0, W, H);
  const k = Math.min(W * 0.8 / m.w, H * 0.72 / m.h);
  const mask = renderMask(state, k);
  composeInk(ctx, mask, (W - mask.width) / 2, (H - mask.height) / 2, state.ink === 'ohne' ? 'schwarz' : state.ink, { alpha: 0.96 });
  ctx.fillStyle = 'rgba(74,68,68,.55)';
  ctx.font = '600 20px "Quattrocento Sans", sans-serif';
  ctx.textAlign = 'center';
  ctx.fillText(`${m.label} · ${m.size} · ${inkTitle(state.ink)}`, W / 2, H - 26);
  const blob = await blobFromCanvas(c);
  return { blob, name: 'KP-Vorschau.png', canvas: c };
}

function orderProperties(app) {
  const st = app.state;
  const m = modelById(st.model);
  const props = [];
  const texts = st.elements.filter(e => e.type === 'text' && e.text.trim());
  const order = e => e.arc === 'oben' ? -1000 : e.arc === 'unten' ? 1000 : e.y;
  texts.sort((a, b) => order(a) - order(b));
  texts.forEach((t, i) => props.push([texts.length > 1 ? `Text ${i + 1}` : 'Text', t.text.replace(/\n/g, ' / ') + (t.arc === 'oben' ? ' (Bogen oben)' : t.arc === 'unten' ? ' (Bogen unten)' : '')]));
  const fonts = [...new Set(texts.map(t => t.font))].map(id => { const f = fontById(id); return `${f.label} (${f.family})`; });
  if (fonts.length) props.push(['Schrift', fonts.join(', ')]);
  const mo = st.elements.find(e => e.type === 'motif');
  if (mo) props.push(['Motiv', `Nr. ${mo.motif} – ${(Motifs.get(mo.motif) || {}).name || ''}`]);
  const fr = st.elements.find(e => e.type === 'frame' && e.style !== 'keiner');
  if (fr) props.push(['Rahmen', (FRAMES.find(f => f.id === fr.style) || {}).label || fr.style]);
  // Clair/Delicata: eine Shopify-Variante je Preisgruppe, die Farbe steht hier
  const ink = inkById(st.ink);
  if (ink.series) props.push(['Kissenfarbe', ink.label]);
  const design = { v: 1, model: st.model, housing: st.housing, ink: st.ink, template: st.template, elements: st.elements.map(e => { const c = Object.assign({}, e); return c; }) };
  if (st.template === 'design') props.push(['Gestaltung', 'Eigenes Design (ohne Vorlage)']);
  props.push(['_Entwurf', JSON.stringify(design)]);
  props.push(['_Bestätigung', `Entwurf geprüft; Hinweis „kein Widerrufsrecht bei individueller Anfertigung (§ 312g Abs. 2 Nr. 1 BGB)“ bestätigt am ${new Date().toLocaleString('de-DE', { timeZone: 'Europe/Berlin' })}`]);
  props.push(['_Konfigurator', 'KP-Stempelwerkstatt 1.8']);
  return props;
}

async function buildOrder(app) {
  const st = app.state;
  const prod = await productionFile(st);
  const prev = await previewFile(st);
  const props = orderProperties(app);
  const files = [['_Druckdatei', prod.blob, prod.name], ['_Vorschau', prev.blob, prev.name]];
  const img = st.elements.find(e => e.type === 'image');
  if (img) {
    const orig = app.uploads.get(img.id);
    if (orig && orig.file) files.unshift(['Eigenes Bild', orig.file, orig.file.name || 'eigenes-bild']);
    else {
      const c = imageCache.get(img.id);
      if (c) files.unshift(['Eigenes Bild', await blobFromCanvas(c), 'eigenes-bild.png']);
    }
  }
  return { props, files, prod, prev };
}

async function cartAdd(app, order) {
  const v = app.variant();
  const fd = new FormData();
  fd.append('id', String(v.id));
  fd.append('quantity', String(app.state.qty || 1));
  for (const [k, val] of order.props) fd.append(`properties[${k}]`, val);
  for (const [k, blob, name] of order.files) fd.append(`properties[${k}]`, blob, name);
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const res = await fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
  let data = null;
  try { data = await res.json(); } catch (e) { /* leer */ }
  if (!res.ok || (data && data.status && data.status >= 400)) {
    throw new Error((data && (data.description || data.message)) || 'Der Stempel konnte nicht in den Warenkorb gelegt werden.');
  }
  return data;
}

/* Vorschau-Modus: zeigt, was bei euch in der Bestellung ankommt */
function showOrderDemo(app, order) {
  const v = app.variant();
  const m = modelById(app.state.model);
  const prodUrl = URL.createObjectURL(order.prod.blob);
  const prevUrl = URL.createObjectURL(order.prev.blob);
  const rows = [
    ['Variante', `${m.option} / ${m.housingPrefix}${HOUSINGS[app.state.housing].label} / ${inkById(app.state.ink).option}`],
    ['Preis', `${app.state.qty || 1} × ${formatPrice(v.price, app.cfg.currency)}`],
    ...order.props.filter(p => p[0] !== '_Entwurf').map(p => [p[0], p[1]]),
    ...order.files.map(f => [f[0], `Datei: ${f[2]} (${Math.round(f[1].size / 1024)} KB)`]),
    ['_Entwurf', 'Bauplan des Entwurfs (zum späteren Nachbearbeiten)']
  ];
  const modal = h('div', { class: 'kpk-modal', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'So kommt die Bestellung an' },
    h('div', { class: 'kpk-modal-card kpk-modal-wide' },
      h('button', { type: 'button', class: 'kpk-modal-x', 'aria-label': 'Schließen', onclick: () => close() }, icon('close')),
      h('div', { class: 'kpk-eyebrow' }, 'Vorschau-Modus'),
      h('h2', { class: 'kpk-h2' }, 'So kommt die Bestellung bei euch an'),
      h('p', { class: 'kpk-sub' }, 'Im Shop landet der Stempel mit genau diesen Angaben im Warenkorb. Die Dateien hängen an der Bestellung und lassen sich im Admin öffnen.'),
      h('div', { class: 'kpk-demo-grid' },
        h('figure', null, h('img', { src: prevUrl, alt: 'Vorschau' }), h('figcaption', null, 'Vorschau (für euch und die Kundin)')),
        h('figure', null, h('img', { src: prodUrl, alt: 'Druckdatei', class: 'is-prod' }), h('figcaption', null, `Druckdatei für den Laser · ${order.prod.w} × ${order.prod.h} px · 1016 dpi · schwarz/weiß, nicht gespiegelt`))),
      h('table', { class: 'kpk-demo-table' }, h('tbody', null, rows.map(r => h('tr', null, h('th', null, r[0]), h('td', null, r[1])))))));
  function close() { modal.classList.add('is-out'); setTimeout(() => { modal.remove(); URL.revokeObjectURL(prodUrl); URL.revokeObjectURL(prevUrl); }, 200); }
  app.el.appendChild(modal);
  requestAnimationFrame(() => modal.classList.add('is-in'));
}

/* ---- js/70-app.js ---- */
/* ---------------------------------------------------------------------------
   App: Zustand, Verlauf (Rückgängig), Aktionen, Start
   --------------------------------------------------------------------------- */

const STORE_KEY = 'kpk-entwurf-v1';

class App {
  constructor(el, cfg) {
    App.current = this;
    this.el = el;
    this.cfg = Object.assign({ mode: 'demo', currency: 'EUR', assetBase: '', assets: {} }, cfg || {});
    this.variants = buildVariants(this.cfg);
    this.uploads = new Map();
    this.history = [];
    this.hIndex = -1;
    this.uidRoot = Math.random().toString(36).slice(2, 7);
    this.state = null;
    this.persist = debounce(() => this._persist(), 500);
    this.lastModel = {};
  }

  asset(name) {
    if (this.cfg.assets && this.cfg.assets[name]) return this.cfg.assets[name];
    return (this.cfg.assetBase || '') + name;
  }

  async start() {
    this.el.classList.add('kpk', 'is-loading');
    this.el.replaceChildren(h('div', { class: 'kpk-loader' }, h('span', { class: 'kpk-dots is-pulse', 'aria-hidden': 'true' }, h('i'), h('i')), h('span', null, 'Die Stempel-Werkstatt wird vorbereitet …')));
    try {
      const res = await fetch(this.asset('kp-konfig-motive.json'));
      Motifs.load(await res.json());
    } catch (e) {
      console.warn('[KP-Konfigurator] Motive nicht geladen', e);
      Motifs.load({ motive: [] });
    }
    this.state = this.restore() || this.defaultState();
    await this.ensureFonts(this.state.elements);
    this.buildUI();
    this.commit(true);
    this.el.classList.remove('is-loading');
    if (document.fonts && document.fonts.addEventListener) {
      document.fonts.addEventListener('loadingdone', () => { Measure.clear(); this.stage.renderSoon(); });
    }
    if (this.restored) this.toast('Dein letzter Entwurf ist wieder da.', 'Neu beginnen', () => this.reset());
    this.tour = new Tour(this);
    this.watchChat();
    if (!this.restored) this.tour.offer();
    // Rückgängig/Wiederholen per Tastatur, solange man im Konfigurator arbeitet (nicht beim Tippen)
    document.addEventListener('keydown', e => {
      if (!(e.metaKey || e.ctrlKey) || e.altKey) return;
      const k = e.key.toLowerCase();
      if (k !== 'z' && k !== 'y') return;
      const t = e.target;
      if (t && (/INPUT|TEXTAREA|SELECT/.test(t.tagName) || t.isContentEditable)) return;
      if (!this.el.contains(t) && t !== document.body) return;
      if (this.stage.root.contains(t)) return; // die Bühne regelt das selbst
      e.preventDefault();
      if (k === 'y' || e.shiftKey) this.redo(); else this.undo();
    });
  }

  defaultState() {
    const s = { model: 'edy', housing: 'pastell-gruen', ink: 'schwarz', template: 'motiv-text', elements: [], selected: null, qty: 1, confirmed: false, lastMotif: 6 };
    // Start: Platzhalter-Grafik „Dein Design“ und darunter „Dein Wunschtext“ (v1.7)
    applyTemplate(s, 'motiv-text', { texts: [], fonts: [], font: 'lettering', pic: newMotif(PH_MOTIF, { ph: true }), frame: null });
    return s;
  }

  buildUI() {
    this.el.replaceChildren();
    const stageRoot = h('div', { class: 'kpk-stage' });
    const side = h('div', { class: 'kpk-side' });
    this.el.append(h('div', { class: 'kpk-grid' }, h('div', { class: 'kpk-stage-col' }, stageRoot), side));
    this.stage = new Stage(this, stageRoot);
    this.panels = new Panels(this, side);
    this.stage.setDevice(this.state.model, this.state.housing, false);
    this.stage.render();
  }

  /* ---------- Schriften ---------- */
  ensureFont(id) {
    const f = fontById(id);
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return document.fonts.load(`${f.weight} 32px "${f.family}"`, 'AaÄäÖöÜüß!').then(() => { Measure.clear(); this.stage && this.stage.renderSoon(); }).catch(() => {});
  }
  ensureFonts(els) {
    const ids = [...new Set((els || []).filter(e => e.type === 'text').map(e => e.font))];
    const all = Promise.all(ids.map(id => this.ensureFont(id)));
    return Promise.race([all, new Promise(r => setTimeout(r, 2500))]);
  }

  /* ---------- Verlauf ---------- */
  snapshot() {
    const s = this.state;
    return JSON.stringify({ model: s.model, housing: s.housing, ink: s.ink, template: s.template, manual: !!s.manual, elements: settledElements(s.elements) });
  }
  commit(initial) {
    const snap = this.snapshot();
    if (this.history[this.hIndex] === snap) return;
    this.history = this.history.slice(0, this.hIndex + 1);
    this.history.push(snap);
    if (this.history.length > 80) this.history.shift();
    this.hIndex = this.history.length - 1;
    this.updateUndo();
    if (!initial) this.persist();
  }
  undo() { if (this.hIndex > 0) { this.hIndex--; this.restoreSnap(this.history[this.hIndex]); } }
  redo() { if (this.hIndex < this.history.length - 1) { this.hIndex++; this.restoreSnap(this.history[this.hIndex]); } }
  restoreSnap(snap) {
    const d = JSON.parse(snap);
    const modelChanged = d.model !== this.state.model || d.housing !== this.state.housing;
    Object.assign(this.state, d);
    if (!this.state.elements.some(e => e.id === this.state.selected)) this.state.selected = null;
    if (modelChanged) this.stage.setDevice(this.state.model, this.state.housing);
    this.stage.render();
    this.panels.render();
    this.panels.updateBuy();
    this.updateUndo();
    this.persist();
  }
  updateUndo() {
    if (!this.stage) return;
    this.stage.btnUndo.disabled = this.hIndex <= 0;
    this.stage.btnRedo.disabled = this.hIndex >= this.history.length - 1;
  }

  /* Zentrale Änderungsmeldung */
  changed(o = {}) {
    this.stage.renderSoon();
    if (!o.live) this.panels.refresh(o.what);
    else if (this.panels.step === 'text') this.panels.syncTextControls();
    else if (this.panels.step === 'motiv') this.panels.syncMotifControls();
    if (o.commit) { this.commit(); this.panels.refresh(o.what); }
    this.stage.setWarnings(this.warnings().filter(w => w.stage));
  }


  select(id, o = {}) {
    this.state.selected = id;
    this.stage.updateOverlay();
    if (o.silent) return;
    const el = id ? this.state.elements.find(e => e.id === id) : null;
    if (el && o.fromStage && !o.keepPanel) {
      if (el.type === 'text' && this.panels.step !== 'text') this.panels.go('text', { silent: true });
      else if ((el.type === 'motif' || el.type === 'image') && this.panels.step !== 'motiv') this.panels.go('motiv', { silent: true });
      else this.panels.refresh();
    } else if (!o.keepPanel) this.panels.refresh();
    if (this.panels.step === 'text') { this.panels.markTextCards(); this.panels.syncTextControls(); }
  }

  focusText(id) {
    this.select(id, { fromStage: true });
    if (this.panels.step !== 'text') this.panels.go('text', { silent: true });
    const ta = $(`.kpk-text-card[data-id="${id}"] textarea`, this.el);
    if (ta) { ta.focus(); ta.select(); }
  }

  /* Chat-Knopf des Shops (Shopify Inbox, <shopify-chat>): liegt er über der Kaufleiste
     (am Handy über „Weiter“), wird er nur auf dieser Seite so weit angehoben, dass nichts
     mehr verdeckt ist. Angehoben wird die ganze Chat-Ebene (CSS: shopify-chat { bottom }),
     damit auch ihr unsichtbarer Rand keine Klicks abfängt. Offener Chat: nicht anheben. */
  watchChat() {
    let observed = null;
    const lift = () => {
      const sc = document.querySelector('shopify-chat');
      const act = sc && sc.shadowRoot && sc.shadowRoot.querySelector('[part~="activator"]');
      const buy = this.panels && this.panels.buy;
      if (!sc || !act || !buy) return;
      if (observed !== sc && window.MutationObserver) {
        observed = sc;
        new MutationObserver(rafThrottle(lift)).observe(sc.shadowRoot, { childList: true, subtree: true, attributes: true });
      }
      const box = (act.parentElement && act.parentElement.getBoundingClientRect().width ? act.parentElement : act).getBoundingClientRect();
      const cur = parseFloat(sc.style.getPropertyValue('--kpk-chat-lift')) || 0;
      let need = 0;
      if (box.width && box.height && sc.open !== true && getComputedStyle(buy).position === 'fixed') {
        const b = buy.getBoundingClientRect();
        const bottom = box.bottom + cur;                      // Lage ohne unser Anheben
        if (box.left < b.right && box.right > b.left && bottom > b.top - 6) need = Math.ceil(bottom - b.top + 10);
      }
      if (Math.abs(need - cur) > 1) sc.style.setProperty('--kpk-chat-lift', need + 'px');
    };
    this.liftChat = lift;
    let n = 0;
    const t = setInterval(() => { lift(); if (++n > 40) clearInterval(t); }, 750);
    window.addEventListener('resize', rafThrottle(lift));
    window.addEventListener('orientationchange', () => setTimeout(lift, 300));
  }

  /* ---------- Platzhalter (v1.7, Wunsch 25.09.) ----------
     „Dein Wunschtext“: Antippen → der Text verschwindet sofort und man schreibt direkt auf der
     Fläche (Stage.openEditor). Bleibt das Feld leer, kommt der Platzhalter zurück.
     „Dein Design“: bleibt beim Antippen stehen (Auswahl, „Design“ öffnet sich); ersetzt wird er
     durch ein Motiv oder ein eigenes Bild, gelöscht über den Mülleimer. Beide Platzhalter
     bleiben Platzhalter, auch wenn man sie verschiebt – bestellen lässt sich so nicht. */
  tapElement(id, o = {}) {
    const el = this.state.elements.find(e => e.id === id);
    if (!el) return;
    if (el.type === 'text' && (el.ph || o.wasSelected)) this.stage.openEditor(id);
  }
  openTextPlaceholder(id) {
    const el = this.state.elements.find(e => e.id === id);
    if (!el || el.type !== 'text' || !el.ph) return false;
    el.phWas = el.text;
    el.text = '';
    el.phOpen = true;
    delete el.ph;
    this.changed({ live: true, what: 'typing' });
    return true;
  }
  closeTextPlaceholder(id) {
    const el = this.state.elements.find(e => e.id === id);
    if (!el || el.type !== 'text' || !el.phOpen) return false;
    if (!el.text.trim()) { el.text = el.phWas || PH_TEXT; el.ph = true; }
    delete el.phOpen; delete el.phWas;
    this.changed({ live: true });
    return true;
  }
  /* offene Platzhalter wieder schließen (kind: 'image' nur Bilder) */
  closePlaceholders(kind) {
    let any = false;
    for (const el of this.state.elements) {
      if (!el.phOpen) continue;
      if (el.type === 'text') {
        if (kind === 'image') continue;
        if (!el.text.trim()) { el.text = el.phWas || PH_TEXT; el.ph = true; }
        delete el.phWas;
      } else delete el.hidden;
      delete el.phOpen;
      any = true;
    }
    return any;
  }

  onStep(step) {
    this.el.dataset.step = step;
    const st = this.state;
    if (step === 'text' && (!st.selected || !st.elements.some(e => e.id === st.selected && e.type === 'text'))) {
      const t = st.elements.find(e => e.type === 'text');
      if (t) { st.selected = t.id; }
    }
    if (step === 'motiv') {
      const m = st.elements.find(e => e.type === 'motif' || e.type === 'image');
      if (m && (!st.selected || !st.elements.some(e => e.id === st.selected && (e.type === 'motif' || e.type === 'image')))) st.selected = m.id;
    }
    if (step === 'fertig' || step === 'stempel' || step === 'vorlage') st.selected = null;
    if (this.stage) { this.stage.updateOverlay(); this.stage.togglePreview(step === 'fertig'); }
  }

  /* ---------- Aktionen ---------- */
  setModel(id) {
    const st = this.state;
    if (st.model === id) return;
    const from = modelById(st.model), to = modelById(id);
    const hsLabel = HOUSINGS[st.housing] ? st.housing : null;
    st.model = id;
    if (to.group) this.lastModel[to.group] = id;
    st.housing = to.housings.includes(hsLabel) ? hsLabel : to.housings[0];
    if (!to.inks.includes(st.ink)) st.ink = 'schwarz';
    const map = {
      square: { 'motiv-links': 'motiv-text', 'motiv-rechts': 'motiv-text', text: 'text', rahmen: 'text' },
      round: { 'motiv-links': 'motiv-text', 'motiv-rechts': 'motiv-text', rahmen: 'text', 'oben-unten': 'kreis' },
      rect: { 'motiv-text': 'motiv-links', kreis: 'motiv-links', bogen: 'motiv-links', 'oben-unten': 'motiv-links', text: 'text', motiv: 'motiv-links' }
    };
    let tpl = st.template;
    if (tpl === 'design') { /* eigenes Design bleibt formatfüllend */ }
    else if (!templatesFor(to).some(t => t.id === tpl) || (from.shape === 'rect') !== (to.shape === 'rect')) tpl = (map[to.shape] || {})[tpl] || (templatesFor(to).some(t => t.id === tpl) ? tpl : templatesFor(to)[0].id);
    const c = extractContent(st);
    // leerer Entwurf: die Vorlage setzt ihren Beispieltext (Platzhalter)
    if (to.shape === 'rect' && c.texts.length === 1 && c.texts[0].length > 18 && !c.texts[0].includes('\n')) {
      const [a, b] = splitInTwo(c.texts[0]);
      c.texts = b ? [a, b] : [a];
      if (c.phs && c.phs[0]) c.phs = c.texts.map(() => true);
    }
    applyTemplate(st, tpl, c);
    st.selected = null;
    this.stage.setDevice(st.model, st.housing);
    this.stage.render();
    this.changed({ commit: true });
    this.panels.updateBuy();
  }

  /* zuletzt gewählte Größe einer Gruppe (Holzstempel) */
  lastOf(group) { return this.lastModel[group] || null; }

  setHousing(hs) {
    this.state.housing = hs;
    this.stage.setDevice(this.state.model, hs);
    this.changed({ commit: true });
  }

  setInk(id) {
    this.state.ink = id;
    this.changed({ commit: true });
    this.stage.render();
  }

  setQty(n) { this.state.qty = clamp(n, 1, 99); this.panels.updateBuy(); }

  useTemplate(id) {
    const st = this.state;
    const c = extractContent(st);
    const tpl = templatesFor(modelById(st.model)).find(t => t.id === id);
    if (tpl && tpl.needs.includes('m') && !c.pic) c.pic = newMotif(PH_MOTIF, { ph: true });
    // fehlt Text, setzt die Vorlage ihren Beispieltext als Platzhalter
    applyTemplate(st, id, c);
    st.selected = null;
    this.ensureFonts(st.elements);
    this.changed({ commit: true });
  }

  setMotif(id) {
    const st = this.state;
    const cur = st.elements.find(e => e.type === 'motif' || e.type === 'image');
    if (id == null) {
      st.elements = st.elements.filter(e => e.type !== 'motif' && e.type !== 'image');
      st.selected = null;
      this.changed({ commit: true });
      return;
    }
    st.lastMotif = id;
    if (cur) {
      const m = Motifs.get(id), old = cur.type === 'motif' ? Motifs.get(cur.motif) : null;
      const oldH = cur.type === 'motif' && old ? cur.w * old.h / old.w : cur.w * (cur.ratio || 1);
      const boxW = cur.w, boxH = oldH;
      const next = newMotif(id, { x: cur.x, y: cur.y, rot: cur.rot || 0, flip: !!cur.flip, id: cur.type === 'motif' ? cur.id : uid('m') });
      const ar = m ? m.h / m.w : 1;
      const model = modelById(st.model);
      fitMotif(next, Math.min(model.w * 0.95, Math.max(boxW * 0.6, boxH / ar)), boxH);
      const idx = st.elements.indexOf(cur);
      st.elements[idx] = next;
      st.selected = next.id;
    } else {
      const tpl = st.template === 'design' ? 'design' : isSquarish(modelById(st.model)) ? (st.template === 'text' ? 'motiv-text' : st.template) : (st.template === 'motiv-rechts' ? 'motiv-rechts' : 'motiv-links');
      const c = extractContent(st);
      c.pic = newMotif(id);
      applyTemplate(st, tpl, c);
      const p = st.elements.find(e => e.type === 'motif');
      st.selected = p ? p.id : null;
    }
    this.changed({ commit: true });
  }

  setFrame(style) {
    const st = this.state;
    st.elements = st.elements.filter(e => e.type !== 'frame');
    if (style && style !== 'keiner') {
      const fr = { id: uid('f'), type: 'frame', style, stroke: 0.42, inset: 0.5 };
      st.elements.unshift(fr);
      // Inhalt so weit verkleinern, dass er nicht in die Rahmenlinie läuft
      fitContentInto(st, frameRegion(fr, modelById(st.model)));
    }
    this.changed({ commit: true });
  }

  addText() {
    const st = this.state;
    const m = modelById(st.model);
    const last = st.elements.filter(e => e.type === 'text').pop();
    const t = newText(PH_TEXT, last ? last.font : 'lettering', { ph: true });
    if (isRound(m)) { fitText(t, m.w * 0.5, m.h * 0.16, MIN_PT, 12); t.y = round(m.h * 0.22, 2); }
    else {
      fitText(t, m.w * 0.7, m.h * 0.22, MIN_PT, 12);
      t.y = round(m.shape === 'square' ? m.h * 0.28 : 0, 2);
    }
    st.elements.push(t);
    if (isRound(m)) this.fitTextInside(t);
    st.selected = t.id;
    st.manual = true;
    this.changed({ commit: true });
    setTimeout(() => this.focusText(t.id), 30);   // Feld im Schritt „Text“ (leer, Platzhalter grau)
  }

  setTextForm(id, key, v) {
    const st = this.state;
    const el = st.elements.find(e => e.id === id);
    if (!el) return;
    const m = modelById(st.model);
    if (key === 'arc') {
      if (el.arc === v) return;
      const prevB = el.arc === 'none' ? elementBBox(el) : null;
      const prevCx = prevB ? el.x + (prevB.x0 + prevB.x1) / 2 : 0;
      const prevW = prevB ? prevB.x1 - prevB.x0 : m.w * 0.8;
      if (v !== 'none') {
        el.text = el.text.replace(/\s*\n\s*/g, ' ');
        el.arc = v;
        el.x = 0; el.y = 0; el.rot = 0;
        if (isSquarish(m)) {
          const outerR = Math.min(m.w, m.h) / 2 - safeOf(m) - 0.35;
          fitArc(el, outerR, deg2rad(160), Math.min(m.w, m.h) * 0.11);
        } else {
          // sanfter Bogen dort, wo der Text vorher stand: großer Radius, Mittelpunkt unterhalb
          const targetW = clamp(prevW, m.w * 0.3, m.w * 0.92);
          el.radius = round(Math.max(m.w * 0.85, targetW * 1.4), 2);
          let lo = MIN_PT, hi = 24;
          for (let i = 0; i < 14; i++) {
            const mid = (lo + hi) / 2; el.size = mid;
            const b = textLayout(el).bbox;
            if (b.x1 - b.x0 <= targetW && b.y1 - b.y0 <= m.h * 0.8) lo = mid; else hi = mid;
          }
          el.size = round(lo, 1);
          const b = textLayout(el).bbox;
          el.x = round(clamp(prevCx, -m.w / 2 + targetW / 2, m.w / 2 - targetW / 2), 2);
          el.y = round(-(b.y0 + b.y1) / 2, 2);
        }
      } else {
        const wasTop = el.arc === 'oben';
        el.arc = 'none';
        el.rot = 0;
        if (isRound(m)) {
          // rund: gerade Zeile oben bzw. unten, die Ecken bleiben im Kreis
          el.x = 0;
          fitText(el, m.w * 0.62, m.h * 0.16, MIN_PT, 14);
          const b = textLayout(el).bbox;
          const R = m.w / 2 - safeOf(m) - 0.3, hw = Math.max(-b.x0, b.x1);
          const yb = Math.sqrt(Math.max(0, R * R - hw * hw));
          el.y = round(wasTop ? -yb - b.y0 : yb - b.y1, 2);
        } else if (m.shape === 'square') {
          el.x = 0;
          fitText(el, m.w * 0.9, m.h * 0.2, MIN_PT, 14);
          const b = textLayout(el).bbox;
          const half = m.h / 2 - safeOf(m) - 0.3;
          el.y = round(wasTop ? -half - b.y0 : half - b.y1, 2);
        } else {
          fitText(el, m.w * 0.6, m.h * 0.8, MIN_PT, 16);
          const b = textLayout(el).bbox;
          el.y = round(-(b.y0 + b.y1) / 2, 2);
        }
      }
    } else el[key] = v;
    if (key === 'arc' || key === 'align') st.manual = true;
    this.ensureFont(el.font);
    this.changed({ commit: true });
  }

  updateEl(id, patch, commit, what) {
    const st = this.state;
    const el = st.elements.find(e => e.id === id);
    if (!el) return;
    Object.assign(el, patch);
    if (what !== 'typing' && ['x', 'y', 'w', 'size', 'rot', 'radius', 'lh', 'ls'].some(k => k in patch)) st.manual = true;
    if (what === 'typing' && el.type === 'text') { delete el.ph; delete el.phOpen; delete el.phWas; this.autoFitText(id); }
    if (patch.font && el.type === 'text') {
      // erst wenn die Schrift da ist, stimmt die Breite – dann einpassen
      this.ensureFont(patch.font).then(() => {
        const cur = this.state.elements.find(e => e.id === id);
        if (cur && cur.font === patch.font && this.autoFitText(id)) this.changed({ commit: true });
      });
    }
    this.changed({ live: !commit, commit: !!commit, what });
    const cur = st.elements.find(e => e.id === id) || el;
    if (what === 'typing') this.panels.updateFontSamples(cur);
  }

  /* Text nach dem Tippen / Schriftwechsel einpassen.
     Kommt die Anordnung noch aus der Vorlage, wird die Vorlage neu berechnet
     (Motiv und Text teilen sich den Platz wie in der Vorschau). Hat die Kundin
     selbst verschoben oder die Größe geändert, wird nur verkleinert/nachgerückt,
     damit nichts über den Rand läuft. Gibt true zurück, wenn sich etwas geändert hat. */
  autoFitText(id) {
    const st = this.state;
    const el = st.elements.find(e => e.id === id);
    if (!el || el.type !== 'text' || !el.text.trim()) return false;
    const before = JSON.stringify(st.elements);
    if (!st.manual && st.template && st.template !== 'design') {
      const order = e => e.arc === 'oben' ? -1000 + e.x : e.arc === 'unten' ? 1000 + e.x : e.y;
      const oldTexts = st.elements.filter(e => e.type === 'text').sort((a, b) => order(a) - order(b));
      const trial = { model: st.model, template: st.template, elements: JSON.parse(before) };
      const hadFrame = trial.elements.find(e => e.type === 'frame');
      applyTemplate(trial, st.template);
      const newTexts = trial.elements.filter(e => e.type === 'text').sort((a, b) => order(a) - order(b));
      const sameShape = newTexts.length === oldTexts.length && newTexts.every((t, i) => t.arc === oldTexts[i].arc);
      if (sameShape) {
        newTexts.forEach((t, i) => { t.id = oldTexts[i].id; });
        const nf = trial.elements.find(e => e.type === 'frame');
        if (nf && hadFrame) { nf.id = hadFrame.id; nf.style = hadFrame.style; }
        st.elements = trial.elements;
        st.template = trial.template;
        st.manual = false;
      }
    }
    const cur = st.elements.find(e => e.id === id);
    if (cur) this.fitTextInside(cur);
    return JSON.stringify(st.elements) !== before;
  }

  /* Nur dieses Textfeld: verkleinern (bis 4 pt) und nach innen rücken, bis es in die Fläche passt */
  fitTextInside(el) {
    if (!el || el.type !== 'text' || el.arc !== 'none' || !el.text.trim()) return;
    const R = contentRegion(this.state);
    const hx = R.circle ? R.r * Math.SQRT1_2 : R.hx, hy = R.circle ? R.r * Math.SQRT1_2 : R.hy;
    const box = () => {
      const pts = elementCorners(el);
      return { x0: Math.min(...pts.map(p => p[0])), x1: Math.max(...pts.map(p => p[0])), y0: Math.min(...pts.map(p => p[1])), y1: Math.max(...pts.map(p => p[1])) };
    };
    let b = box();
    const s = Math.min(1, (2 * hx) / Math.max(b.x1 - b.x0, 0.01), (2 * hy) / Math.max(b.y1 - b.y0, 0.01));
    if (s < 1) { el.size = round(Math.max(4, el.size * s * 0.995), 2); b = box(); }
    let dx = 0, dy = 0;
    if (b.x1 - b.x0 <= 2 * hx) { if (b.x0 < -hx) dx = -hx - b.x0; else if (b.x1 > hx) dx = hx - b.x1; }
    if (b.y1 - b.y0 <= 2 * hy) { if (b.y0 < -hy) dy = -hy - b.y0; else if (b.y1 > hy) dy = hy - b.y1; }
    if (dx || dy) { el.x = round(el.x + dx, 3); el.y = round(el.y + dy, 3); }
  }

  removeEl(id) {
    const st = this.state;
    if (st.elements.some(e => e.id === id && e.type === 'text')) st.manual = true;
    st.elements = st.elements.filter(e => e.id !== id);
    if (st.selected === id) st.selected = null;
    this.changed({ commit: true });
  }

  elementAction(act) {
    const st = this.state;
    const el = st.elements.find(e => e.id === st.selected);
    if (!el) return;
    if (act === 'delete') { this.removeEl(el.id); this.panels.render(); return; }
    st.manual = true;
    if (act === 'duplicate') {
      const c = JSON.parse(JSON.stringify(el));
      c.id = uid(el.type[0]);
      c.x = round(c.x + 1.5, 2); c.y = round(c.y + 1.5, 2);
      if (el.type === 'image') imageCache.set(c.id, imageCache.get(el.id));
      st.elements.push(c);
      st.selected = c.id;
    } else if (act === 'center') {
      if (el.type === 'text' && el.arc !== 'none') { el.x = 0; el.y = 0; }
      else {
        const b = elementBBox(el);
        const [cx, cy] = fromLocal((b.x0 + b.x1) / 2, (b.y0 + b.y1) / 2, 0, 0, el.rot);
        el.x = round(-cx, 3);
        if (modelById(st.model).shape === 'rect' || el.type !== 'text') el.y = round(-cy, 3);
      }
      const both = el.type !== 'text' || el.arc !== 'none' || modelById(st.model).shape === 'rect';
      if (this.stage.flashGuides) this.stage.flashGuides(true, both);
    } else if (act === 'front') {
      st.elements = st.elements.filter(e => e !== el);
      st.elements.push(el);
    }
    this.changed({ commit: true });
    this.panels.render();
  }

  /* ---------- Eigenes Bild ---------- */
  async openUpload(file, how = {}) {
    let u;
    try { u = await Upload.load(file); } catch (e) { this.toast(e.message); return; }
    openUploadDialog(this, u, null, (res, opts) => this.applyUpload(u, res, opts, file, null, how.mode));
  }
  reopenUpload(id) {
    const rec = this.uploads.get(id);
    if (!rec || !rec.u) { this.toast('Das Original ist nach dem Neuladen nicht mehr da – lade das Bild bitte neu hoch.'); return; }
    openUploadDialog(this, rec.u, rec.opts, (res, opts) => this.applyUpload(rec.u, res, opts, rec.file, id));
  }
  applyUpload(u, res, opts, file, existingId, mode) {
    const st = this.state;
    const m = modelById(st.model);
    const id = existingId || uid('i');
    imageCache.set(id, res.canvas);
    this.uploads.set(id, { u, opts, file });
    const old = st.elements.find(e => e.id === id) || st.elements.find(e => e.type === 'motif' || e.type === 'image');
    const el = { id, type: 'image', w: 10, ratio: res.ratio, x: 0, y: 0, rot: 0, flip: false, src: u.name, srcPx: Math.max(u.srcW, u.srcH), vector: u.isSvg };
    if (mode === 'design') {
      // Fertiges Design: füllt die ganze Stempelfläche, keine Vorlage, keine Texte
      applyTemplate(st, 'design', { texts: [], fonts: [], font: 'grund', pic: el, frame: null });
      st.selected = id;
      this.changed({ commit: true });
      this.panels.go('motiv');
      this.toast('Dein Design ist drin – die Vorlage haben wir übersprungen.');
      return;
    }
    if (old) {
      const oldH = old.type === 'motif' ? old.w * ((Motifs.get(old.motif) || { h: 1, w: 1 }).h / (Motifs.get(old.motif) || { h: 1, w: 1 }).w) : old.w * (old.ratio || 1);
      el.x = old.x; el.y = old.y; el.rot = old.rot || 0;
      fitMotif(el, Math.max(old.w, oldH / res.ratio), oldH);
      st.elements[st.elements.indexOf(old)] = el;
    } else {
      const c = extractContent(st);
      c.pic = el;
      applyTemplate(st, isSquarish(m) ? (st.template === 'text' ? 'motiv-text' : st.template) : 'motiv-links', c);
    }
    st.selected = id;
    this.changed({ commit: true });
    this.panels.render();
  }

  /* ---------- Preis / Prüfung / Warenkorb ---------- */
  variant() { const s = this.state; return this.variants.get(s.model, s.housing, s.ink); }

  warnings() {
    const st = this.state;
    const m = modelById(st.model);
    const out = [];
    const els = st.elements.filter(e => e.type !== 'frame');
    if (!els.length || !els.some(e => e.type !== 'text' || e.text.trim())) out.push({ level: 'stop', text: 'Dein Stempel ist noch leer – füge einen Text oder ein Motiv hinzu.', short: 'Noch leer', stage: false });
    if (els.some(e => e.ph && e.type !== 'text')) out.push({ level: 'stop', text: 'Da ist noch der Platzhalter „Dein Design“ – ersetze ihn durch ein Motiv oder dein eigenes Bild, oder lösch ihn über den Mülleimer.', short: 'Platzhalter „Dein Design“', stage: false, ph: true });
    if (els.some(e => e.ph && e.type === 'text')) out.push({ level: 'stop', text: 'Da steht noch „Dein Wunschtext“ – tipp drauf und schreib deinen Text, oder lösch das Textfeld.', short: 'Platzhalter „Dein Wunschtext“', stage: false, ph: true });
    // Grenze: Plattenrand (0,15 mm Toleranz); mit Knauf zählt der 1-mm-Rand (0,25 mm Toleranz)
    const edge = Math.max(0.15, safeOf(m) - 0.25);
    const lim = { x0: -m.w / 2 + edge, x1: m.w / 2 - edge, y0: -m.h / 2 + edge, y1: m.h / 2 - edge };
    const rr = m.w / 2 - edge;
    const outside = isRound(m) ? ([x, y]) => x * x + y * y > rr * rr : ([x, y]) => x < lim.x0 || x > lim.x1 || y < lim.y0 || y > lim.y1;
    // rund: ragt nur der Kasten über den Kreis, zählen die echten Bildpunkte (runde Logos füllen den Kreis)
    const inkOut = el => {
      const P = inkPoints(st, 3, el), r2 = (rr + 0.2) * (rr + 0.2);
      for (let i = 0; i < P.length; i += 2) if (P[i] * P[i] + P[i + 1] * P[i + 1] > r2) return true;
      return false;
    };
    for (const el of els) {
      if (el.type === 'text' && !el.text.trim()) continue;
      if (el.ph) continue;                         // Platzhalter werden ohnehin ersetzt
      const pts = el.type === 'text' && el.arc !== 'none' ? arcBandPoints(el) : elementCorners(el);
      const out1 = pts.some(outside) && (!isRound(m) || (el.type === 'text' && el.arc !== 'none') || inkOut(el));
      const name = el.type === 'text' ? `„${el.text.split('\n')[0].slice(0, 18)}${el.text.length > 18 ? '…' : ''}“` : el.type === 'motif' ? 'Das Motiv' : 'Dein Bild';
      if (out1) out.push({ level: 'warn', text: `${name} ragt über den Rand der Stempelfläche – dieser Teil wird nicht mitgestempelt.`, short: `${name} ragt über den Rand`, stage: true });
      if (el.type === 'text' && el.size < 6) out.push({ level: 'warn', text: `${name} ist mit ${String(el.size).replace('.', ',')} pt sehr klein – unter 6 pt kann die Schrift beim Stempeln zulaufen.`, short: 'Sehr kleine Schrift', stage: true });
      if (el.type === 'text' && el.arc !== 'none' && textLayout(el).overlap) out.push({ level: 'warn', text: `${name} ist zu lang für den Kreis – verkleinere die Schrift oder kürze den Text.`, short: 'Bogentext zu lang', stage: true });
      if (el.type === 'image' && el.srcPx && el.srcPx < 500 && !el.vector) out.push({ level: 'warn', text: 'Dein Bild ist sehr klein aufgelöst – die Kanten können unscharf werden.', short: 'Bild unscharf', stage: false });
    }
    const lines = st.elements.filter(e => e.type === 'text').reduce((n, e) => n + (e.arc !== 'none' ? 1 : e.text.split('\n').length), 0);
    if (lines > m.maxLines) out.push({ level: 'warn', text: `${lines} Zeilen sind viel für den ${m.label} – empfohlen sind höchstens ${m.maxLines}.`, short: 'Viele Zeilen', stage: false });
    return out;
  }

  canOrder() {
    const v = this.variant();
    if (!v || !v.available) return { ok: false, reason: 'Diese Kombination ist gerade nicht verfügbar.' };
    const stop = this.warnings().find(w => w.level === 'stop');
    if (stop) return { ok: false, reason: stop.text };
    if (!this.state.confirmed) return { ok: false, reason: 'Bitte bestätige kurz deinen Entwurf und den Hinweis zum Widerrufsrecht.' };
    return { ok: true };
  }

  async addToCart() {
    const ok = this.canOrder();
    if (!ok.ok) { this.toast(ok.reason); return; }
    const btn = this.panels.cta;
    btn.disabled = true;
    btn.classList.add('is-busy');
    const label = btn.textContent;
    btn.textContent = 'Wird vorbereitet …';
    try {
      if (this.closePlaceholders()) this.changed({ live: true });
      await this.ensureFonts(this.state.elements);
      const order = await buildOrder(this);
      if (this.cfg.mode === 'shopify') {
        btn.textContent = 'Wird hinzugefügt …';
        await cartAdd(this, order);
        storage.del(STORE_KEY);
        const cartUrl = (window.routes && window.routes.cart_url) || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
        window.location.href = cartUrl;
        return;
      }
      showOrderDemo(this, order);
    } catch (e) {
      console.error(e);
      this.toast(e.message || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.');
    } finally {
      btn.classList.remove('is-busy');
      btn.textContent = label;
      btn.disabled = false;
      this.panels.updateBuy();
    }
  }

  /* ---------- Speichern im Browser ---------- */
  restore() {
    const d = storage.get(STORE_KEY);
    if (!d || !d.state || !Array.isArray(d.state.elements)) return null;
    if (!MODELS.some(m => m.id === d.state.model)) return null;
    for (const el of d.state.elements) {
      if (el.type === 'image' && d.images && d.images[el.id]) {
        const img = new Image();
        img.onload = () => { const c = canvas(img.width, img.height); c.getContext('2d').drawImage(img, 0, 0); imageCache.set(el.id, c); this.stage && this.stage.renderSoon(); };
        img.src = d.images[el.id];
      }
    }
    d.state.elements = d.state.elements.filter(el => el.type !== 'image' || (d.images && d.images[el.id]));
    this.restored = true;
    const st = Object.assign({ qty: 1, confirmed: false, selected: null, lastMotif: 6 }, d.state, { confirmed: false, selected: null });
    migratePlaceholders(st);
    return st;
  }
  reset() {
    storage.del(STORE_KEY);
    this.state = this.defaultState();
    this.history = []; this.hIndex = -1;
    this.stage.setDevice(this.state.model, this.state.housing);
    this.commit(true);
    this.stage.render();
    this.panels.go('stempel');
  }

  toast(msg, actionLabel, action) {
    const t = h('div', { class: 'kpk-toast', role: 'status' }, h('span', null, msg),
      actionLabel ? h('button', { type: 'button', onclick: () => { action(); t.remove(); } }, actionLabel) : null);
    this.el.appendChild(t);
    requestAnimationFrame(() => t.classList.add('is-in'));
    setTimeout(() => { t.classList.remove('is-in'); setTimeout(() => t.remove(), 300); }, actionLabel ? 7000 : 4200);
  }
}

App.prototype._persist = function () {
  const s = this.state;
  if (!s) return;
  const images = {};
  for (const el of s.elements) {
    if (el.type !== 'image') continue;
    const c = imageCache.get(el.id);
    if (c) { try { const d = c.toDataURL('image/png'); if (d.length < 1500000) images[el.id] = d; } catch (e) { /* egal */ } }
  }
  storage.set(STORE_KEY, { v: 1, t: Date.now(), state: { model: s.model, housing: s.housing, ink: s.ink, template: s.template, manual: !!s.manual, elements: settledElements(s.elements), qty: s.qty, lastMotif: s.lastMotif }, images });
};

function arcBandPoints(el) {
  const L = textLayout(el);
  const pts = [];
  const inner = el.arc === 'oben' ? L.rb - L.D : L.rb - L.A;
  const outer = el.arc === 'oben' ? L.rb + L.A : L.rb + L.D;
  for (let i = 0; i <= 16; i++) {
    const phi = -L.span / 2 + L.span * i / 16;
    for (const r of [inner, outer]) {
      const lx = r * Math.sin(phi), ly = el.arc === 'oben' ? -r * Math.cos(phi) : r * Math.cos(phi);
      pts.push(fromLocal(lx, ly, el.x, el.y, el.rot));
    }
  }
  return pts;
}

/* Start: alle Elemente mit [data-kp-konfigurator] */
function boot() {
  for (const el of document.querySelectorAll('[data-kp-konfigurator]')) {
    if (el.__kpk) continue;
    let cfg = {};
    const cfgEl = el.querySelector('script[type="application/json"]');
    if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[KP-Konfigurator] Konfiguration fehlerhaft', e); } }
    if (window.KPK_CONFIG) cfg = Object.assign({}, window.KPK_CONFIG, cfg);
    el.__kpk = new App(el, cfg);
    el.__kpk.start();
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
window.KPKonfigurator = { boot, App, version: '1.8', util: { contentRegion, inkPoints, inRegion, productionFile, previewFile, orderProperties, pngWithDpi } };

/* Entwürfe von v1.5/v1.6: Beispielmotiv (Eule) und Beispieltexte waren Platzhalter – jetzt heißen sie
   „Dein Design“ und „Dein Wunschtext“ (v1.7). Anordnung aus der Vorlage wird neu berechnet. */
function migratePlaceholders(st) {
  let changed = false;
  for (const el of st.elements) {
    if (el.ph && el.type === 'motif' && Number(el.motif) !== PH_MOTIF) {
      const old = Motifs.get(el.motif);
      const boxH = old ? el.w * old.h / old.w : el.w;
      el.motif = PH_MOTIF;
      fitMotif(el, Math.max(el.w, boxH / (PH_MOTIF_DATA.h / PH_MOTIF_DATA.w)), boxH);
      changed = true;
    } else if (el.ph && el.type === 'text' && el.text !== PH_TEXT && !['Dein', 'Wunschtext'].includes(el.text)) {
      el.text = PH_TEXT;
      changed = true;
    }
  }
  if (changed && !st.manual && st.template && st.template !== 'design' && templatesFor(modelById(st.model)).some(t => t.id === st.template)) {
    applyTemplate(st, st.template);
  }
  return changed;
}

/* Entwurf ohne offene Platzhalter (für Verlauf, Speichern, Bestellung) */
function settledElements(els) {
  return els.map(e => {
    if (!e.phOpen) return e;
    const c = Object.assign({}, e);
    if (c.type === 'text') { if (!String(c.text || '').trim()) { c.text = c.phWas || PH_TEXT; c.ph = true; } delete c.phWas; }
    else delete c.hidden;
    delete c.phOpen;
    return c;
  });
}

})();
